import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AmrData = {
  __typename?: 'AMRData';
  event_participant?: Maybe<EventParticipant>;
};

export type ActionLookupResponse = {
  __typename?: 'ActionLookupResponse';
  action_phone_numbers?: Maybe<Array<Maybe<EncounterTypePhoneNumber>>>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_sagbus?: Maybe<Scalars['Boolean']['output']>;
  is_send_updated_location?: Maybe<Scalars['Boolean']['output']>;
  is_unique?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  protocol?: Maybe<Scalars['String']['output']>;
  use_emergency_info_flag?: Maybe<Scalars['Boolean']['output']>;
};

/** What an activity does to the record. */
export enum ActivityCategory {
  /** Produces spot data destined for a problem's encounter. */
  Contribution = 'CONTRIBUTION',
  /** Opens and owns a problem with its own lifecycle. */
  Problem = 'PROBLEM',
  /** Movement rather than clinical content. */
  Tracking = 'TRACKING'
}

/** What the record is, clinically. NONE is an answer, not a missing value. */
export enum ActivityClassification {
  Illness = 'ILLNESS',
  Injury = 'INJURY',
  None = 'NONE'
}

export type Allergy = {
  __typename?: 'Allergy';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A notification in a user's in-app history. */
export type AppNotification = {
  __typename?: 'AppNotification';
  body?: Maybe<Scalars['String']['output']>;
  /** When it was sent. */
  created_at: Scalars['DateTime']['output'];
  /**
   * The event this was sent from, when it was sent from one. Null for anything
   * sent before senders recorded it, so the app must read it as optional.
   */
  event?: Maybe<Event>;
  /** Stable public id; also sent in the push payload as notification_id. */
  id: Scalars['ID']['output'];
  /** When this user read it; null while unread. */
  read_at?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of AppNotification items. */
export type AppNotificationPaginator = {
  __typename?: 'AppNotificationPaginator';
  /** A list of AppNotification items. */
  data: Array<AppNotification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Who is expected to be holding the device. Drives kiosk lockdown, PHI minimisation and attribution. */
export enum CaptureRole {
  Provider = 'PROVIDER',
  SelfReport = 'SELF_REPORT'
}

export type ChartData = {
  __typename?: 'ChartData';
  encountersByDelegation?: Maybe<Array<Maybe<EncountersByDelegation>>>;
  encountersBySport?: Maybe<Array<Maybe<IncidentsBySport>>>;
  illnessOpinions?: Maybe<Array<Maybe<Symptom>>>;
  illnessPhysicalFindings?: Maybe<Array<Maybe<Symptom>>>;
  illnessSymptoms?: Maybe<Array<Maybe<Symptom>>>;
  illnessTreatments?: Maybe<Array<Maybe<Symptom>>>;
  incidentsByStation?: Maybe<Array<Maybe<IncidentsByStation>>>;
  incidentsByTime?: Maybe<Array<Maybe<IncidentsByTime>>>;
  injuryOpinions?: Maybe<Array<Maybe<Symptom>>>;
  injuryPhysicalFindings?: Maybe<Array<Maybe<Symptom>>>;
  injurySymptoms?: Maybe<Array<Maybe<Symptom>>>;
  injuryTreatments?: Maybe<Array<Maybe<Symptom>>>;
};

export type ChartsData = {
  __typename?: 'ChartsData';
  chartData?: Maybe<ChartData>;
  eventDateRange?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
};

export type CleanData = {
  __typename?: 'CleanData';
  event_participants?: Maybe<Array<Maybe<CleanDataEventParticipant>>>;
  next_cursor?: Maybe<Scalars['String']['output']>;
};

export type CleanDataEventParticipant = {
  __typename?: 'CleanDataEventParticipant';
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  alternate_phone_number?: Maybe<Scalars['String']['output']>;
  alternative_identifier?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  birth_date?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  delegation?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  encounters_with_trashed?: Maybe<Array<Maybe<Encounter>>>;
  event?: Maybe<Event>;
  event_signup_complete?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gender_short?: Maybe<Scalars['String']['output']>;
  has_cards_creation_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_exercises_manager_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_health_check_enabled?: Maybe<Scalars['Boolean']['output']>;
  health_check_level?: Maybe<Scalars['String']['output']>;
  height_formatted?: Maybe<Scalars['String']['output']>;
  height_inches?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier_number?: Maybe<Scalars['String']['output']>;
  import_error?: Maybe<Scalars['String']['output']>;
  import_id?: Maybe<Scalars['ID']['output']>;
  is_agreement_consented?: Maybe<Scalars['Boolean']['output']>;
  is_deidentified?: Maybe<Scalars['Boolean']['output']>;
  is_offline_mode?: Maybe<Scalars['Boolean']['output']>;
  is_spectator?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  master_encounters?: Maybe<Array<Maybe<Encounter>>>;
  offline_context?: Maybe<Scalars['JSON']['output']>;
  offline_review_note?: Maybe<Scalars['String']['output']>;
  offline_reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  offline_reviewed_by?: Maybe<Scalars['ID']['output']>;
  offline_reviewer?: Maybe<User>;
  offline_sync_status?: Maybe<OfflineSyncStatus>;
  participant_agreement_timestamp?: Maybe<Scalars['DateTime']['output']>;
  participant_allergies?: Maybe<Array<Maybe<ParticipantAllergy>>>;
  participant_answers?: Maybe<Array<Maybe<ParticipantAnswer>>>;
  participant_conditions?: Maybe<Array<Maybe<ParticipantCondition>>>;
  participant_medications?: Maybe<Array<Maybe<ParticipantMedication>>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  primary_cellphone_number?: Maybe<Scalars['String']['output']>;
  primary_contact_email?: Maybe<Scalars['String']['output']>;
  primary_contact_first_name?: Maybe<Scalars['String']['output']>;
  primary_contact_last_name?: Maybe<Scalars['String']['output']>;
  primary_contact_phone?: Maybe<Scalars['String']['output']>;
  primary_contact_relationship?: Maybe<Scalars['String']['output']>;
  profile_photo?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  runner_number?: Maybe<Scalars['String']['output']>;
  secondary_contact_email?: Maybe<Scalars['String']['output']>;
  secondary_contact_first_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_last_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_phone?: Maybe<Scalars['String']['output']>;
  secondary_contact_relationship?: Maybe<Scalars['String']['output']>;
  share_user_data?: Maybe<Scalars['Boolean']['output']>;
  show_in_engage_listing?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<User>;
  weight_lbs?: Maybe<Scalars['String']['output']>;
};

export type CommandStats = {
  __typename?: 'CommandStats';
  activeMedicalIncidents?: Maybe<Scalars['JSON']['output']>;
  activeMedicalIncidentsByParticipant?: Maybe<Scalars['JSON']['output']>;
  activeMedicalIncidentsByParticipantByDay?: Maybe<Scalars['JSON']['output']>;
  incidentSummary?: Maybe<Scalars['JSON']['output']>;
  incidentSummaryByParticipant?: Maybe<Scalars['JSON']['output']>;
  incidentSummaryByParticipantByDay?: Maybe<Scalars['JSON']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactResponse = {
  __typename?: 'ContactResponse';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DailyIncident = {
  __typename?: 'DailyIncident';
  call?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  illness?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DailyIncidentSummary = {
  __typename?: 'DailyIncidentSummary';
  totalIllnessActivity?: Maybe<Scalars['JSON']['output']>;
  totalIncidents?: Maybe<Scalars['Int']['output']>;
  totalInjuryActivity?: Maybe<Scalars['JSON']['output']>;
  totalMajorIncidents?: Maybe<Scalars['Int']['output']>;
  totalMinorAssistance?: Maybe<Scalars['JSON']['output']>;
  totalUniquePersonsSeen?: Maybe<Scalars['Int']['output']>;
};

export type DataExport = {
  __typename?: 'DataExport';
  download_url?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  expires_in_minutes?: Maybe<Scalars['Int']['output']>;
  export_download?: Maybe<Scalars['String']['output']>;
  export_type?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  filters_applied?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Input type for encounter disposition changes.
 * When hospital is provided/changed, the service will automatically:
 * - Find or create an EventHospital record with that name
 * - Update existing EventTransport or create new one
 * - Link the disposition to the EventTransport
 * Always set created_at/updated_at
 */
export type DispositionChangesInput = {
  admit_at?: InputMaybe<Scalars['String']['input']>;
  care_provider?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  discharge_at?: InputMaybe<Scalars['String']['input']>;
  encounter_disposition_type_id?: InputMaybe<Scalars['ID']['input']>;
  event_resource_id?: InputMaybe<Scalars['ID']['input']>;
  event_team_id?: InputMaybe<Scalars['ID']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_cancel_transport?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  local_time?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reported_by?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type DispositionLookupResponse = {
  __typename?: 'DispositionLookupResponse';
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_mobile_activity?: Maybe<Scalars['Boolean']['output']>;
  is_unique?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  protocol?: Maybe<Scalars['String']['output']>;
  transport_disposition?: Maybe<Scalars['String']['output']>;
};

export type Encounter = {
  __typename?: 'Encounter';
  appointment?: Maybe<Scalars['String']['output']>;
  audit_logs: Array<EventAuditLog>;
  auto_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_user?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  encounter_dispositions?: Maybe<Array<Maybe<EncounterDisposition>>>;
  encounter_spot_data?: Maybe<Array<Maybe<EncounterSpotData>>>;
  encounter_status?: Maybe<Scalars['String']['output']>;
  /** When a team member last corrected this entry's treatments. Null if never. */
  entry_edited_at?: Maybe<Scalars['DateTime']['output']>;
  entry_source?: Maybe<EntrySource>;
  event?: Maybe<Event>;
  event_activity?: Maybe<EventActivity>;
  event_activity_id?: Maybe<Scalars['ID']['output']>;
  event_bodypart_data?: Maybe<Array<Maybe<EventBodyPartData>>>;
  event_button_data?: Maybe<Array<Maybe<EventButtonData>>>;
  event_button_freetext_data?: Maybe<Array<Maybe<EventButtonFreetextData>>>;
  event_labs_data?: Maybe<Array<Maybe<EventLabsData>>>;
  event_medicationgiven_data?: Maybe<Array<Maybe<EventMedicationGivenData>>>;
  event_participant?: Maybe<EventParticipant>;
  event_research_question_data?: Maybe<Array<Maybe<EventResearchQuestionData>>>;
  event_resource?: Maybe<EventResource>;
  event_subresource?: Maybe<EventSubresource>;
  event_team?: Maybe<EventTeam>;
  event_vitalsigns_data?: Maybe<Array<Maybe<EventVitalSignsData>>>;
  /** Clinical content filed from this review entry into its chosen problem. */
  filed_spot_data?: Maybe<Array<Maybe<EncounterSpotData>>>;
  hospitalization?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_amr_triage_status?: Maybe<Scalars['Boolean']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_call_started?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_offline_mode?: Maybe<Scalars['Boolean']['output']>;
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  is_set_location?: Maybe<Scalars['Boolean']['output']>;
  is_triage?: Maybe<Scalars['Boolean']['output']>;
  is_uploaded?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  latest_encounter_disposition?: Maybe<EncounterDisposition>;
  merged_encounters?: Maybe<Array<Maybe<Encounter>>>;
  offline_context?: Maybe<Scalars['JSON']['output']>;
  offline_review_note?: Maybe<Scalars['String']['output']>;
  offline_reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  offline_reviewed_by?: Maybe<Scalars['ID']['output']>;
  offline_reviewer?: Maybe<User>;
  offline_sync_status?: Maybe<OfflineSyncStatus>;
  original_closest_station?: Maybe<Scalars['ID']['output']>;
  parent?: Maybe<Encounter>;
  parent_encounter_id?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  proposed_encounter?: Maybe<Encounter>;
  /** The problem the athlete said this visit was about. Their claim, not a decision. */
  proposed_encounter_id?: Maybe<Scalars['ID']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  review_status?: Maybe<ReviewStatus>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewed_by?: Maybe<Scalars['ID']['output']>;
  reviewer?: Maybe<User>;
  server_received_at?: Maybe<Scalars['String']['output']>;
  status_history?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Temperature>;
  tracking?: Maybe<Tracking>;
  tracking_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type EncounterCallAction = {
  __typename?: 'EncounterCallAction';
  action_type?: Maybe<Scalars['String']['output']>;
  encounterTypePhoneNumbers: Array<EncounterTypePhoneNumber>;
  event_id?: Maybe<Scalars['ID']['output']>;
  event_tracking_status?: Maybe<EventTrackingStatus>;
  id: Scalars['ID']['output'];
  is_sagbus?: Maybe<Scalars['Boolean']['output']>;
  is_send_updated_location?: Maybe<Scalars['Boolean']['output']>;
  is_unique?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  systemLabel?: Maybe<SystemLabel>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  use_emergency_info_flag?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Input type for encounter field changes
 * Always set created_at and updated_at, as created_at is used when encounter active and updated_at is used when encounter is closed
 */
export type EncounterChangesInput = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  event_resource_id?: InputMaybe<Scalars['ID']['input']>;
  event_team_id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type EncounterDisposition = {
  __typename?: 'EncounterDisposition';
  admit_at?: Maybe<Scalars['String']['output']>;
  care_provider?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  discharge_at?: Maybe<Scalars['String']['output']>;
  encounter_disposition_type?: Maybe<EncounterDispositionType>;
  event_resource?: Maybe<EventResource>;
  event_transport?: Maybe<EventTransport>;
  hospital?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_cancel_transport?: Maybe<Scalars['Boolean']['output']>;
  is_offline_mode?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  local_time?: Maybe<Scalars['DateTime']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offline_context?: Maybe<Scalars['JSON']['output']>;
  offline_review_note?: Maybe<Scalars['String']['output']>;
  offline_reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  offline_reviewed_by?: Maybe<Scalars['ID']['output']>;
  offline_reviewer?: Maybe<User>;
  offline_sync_status?: Maybe<OfflineSyncStatus>;
  parent_encounter_id?: Maybe<Scalars['ID']['output']>;
  serialized_data?: Maybe<Scalars['String']['output']>;
};

export type EncounterDispositionType = {
  __typename?: 'EncounterDispositionType';
  eventTrackingStatus?: Maybe<EventTrackingStatus>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_mobile_activity?: Maybe<Scalars['Boolean']['output']>;
  is_sagbus_activity?: Maybe<Scalars['Boolean']['output']>;
  is_unique?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  systemLabel?: Maybe<SystemLabel>;
  transport_disposition?: Maybe<Scalars['Boolean']['output']>;
};

export type EncounterFilterData = {
  __typename?: 'EncounterFilterData';
  call_actions?: Maybe<Array<Maybe<EncounterCallAction>>>;
  disposition_types?: Maybe<Array<Maybe<EncounterDispositionType>>>;
};

/** A paginated list of Encounter items. */
export type EncounterPaginator = {
  __typename?: 'EncounterPaginator';
  /** A list of Encounter items. */
  data: Array<Encounter>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type EncounterSpotData = {
  __typename?: 'EncounterSpotData';
  auto_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  encounter_call_action?: Maybe<EncounterCallAction>;
  encounter_call_action_id?: Maybe<Scalars['ID']['output']>;
  encounter_id?: Maybe<Scalars['ID']['output']>;
  entry_source?: Maybe<EntrySource>;
  event_activity?: Maybe<EventActivity>;
  event_activity_id?: Maybe<Scalars['ID']['output']>;
  event_bodypart_data?: Maybe<Array<Maybe<EventBodyPartData>>>;
  event_button_data?: Maybe<Array<Maybe<EventButtonData>>>;
  event_button_freetext_data?: Maybe<Array<Maybe<EventButtonFreetextData>>>;
  event_labs_data?: Maybe<Array<Maybe<EventLabsData>>>;
  event_medicationgiven_data?: Maybe<Array<Maybe<EventMedicationGivenData>>>;
  event_vitalsigns_data?: Maybe<Array<Maybe<EventVitalSignsData>>>;
  id: Scalars['ID']['output'];
  is_offline_mode?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  offline_context?: Maybe<Scalars['JSON']['output']>;
  offline_review_note?: Maybe<Scalars['String']['output']>;
  offline_reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  offline_reviewed_by?: Maybe<Scalars['ID']['output']>;
  offline_reviewer?: Maybe<User>;
  offline_sync_status?: Maybe<OfflineSyncStatus>;
  parent_encounter_id?: Maybe<Scalars['ID']['output']>;
  review_note?: Maybe<Scalars['String']['output']>;
  review_status?: Maybe<ReviewStatus>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewed_by?: Maybe<Scalars['ID']['output']>;
  reviewer?: Maybe<User>;
  serialized_data?: Maybe<Scalars['String']['output']>;
  source_encounter_id?: Maybe<Scalars['ID']['output']>;
};

export type EncounterTypePhoneNumber = {
  __typename?: 'EncounterTypePhoneNumber';
  encounter_action_type_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

export type EncountersByDelegation = {
  __typename?: 'EncountersByDelegation';
  call?: Maybe<Scalars['Int']['output']>;
  delegation?: Maybe<Scalars['String']['output']>;
  illness?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
};

/** What a reviewer decided about an entry. */
export enum EntryReviewAction {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

/** Who actually entered a record, as opposed to whose device it was entered on. */
export enum EntrySource {
  /** Entered by the subject of care themselves. A claim until a clinician accepts it. */
  AthleteSelfReport = 'ATHLETE_SELF_REPORT',
  Provider = 'PROVIDER'
}

export type Event = {
  __typename?: 'Event';
  activity_settings?: Maybe<Scalars['String']['output']>;
  allow_user_location?: Maybe<Scalars['Boolean']['output']>;
  app_search_participant_filter?: Maybe<Scalars['String']['output']>;
  auto_close_time?: Maybe<Scalars['Int']['output']>;
  autoincrement_digits?: Maybe<Scalars['Int']['output']>;
  autoincrement_enabled?: Maybe<Scalars['Boolean']['output']>;
  autoincrement_fill_zeros?: Maybe<Scalars['Boolean']['output']>;
  autoincrement_prefix?: Maybe<Scalars['String']['output']>;
  /** The activities this event offers now, per its activity settings. event_activities also holds deselected ones. */
  available_activities: Array<EventActivity>;
  barcode_query_string?: Maybe<Scalars['String']['output']>;
  button_triage_delayed?: Maybe<Scalars['String']['output']>;
  button_triage_immediate?: Maybe<Scalars['String']['output']>;
  button_triage_minor?: Maybe<Scalars['String']['output']>;
  content_user_id?: Maybe<Scalars['ID']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  customer_type_id?: Maybe<Scalars['ID']['output']>;
  daily_report_title?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  date_display?: Maybe<Scalars['String']['output']>;
  date_end?: Maybe<Scalars['Date']['output']>;
  date_start?: Maybe<Scalars['Date']['output']>;
  default_sms_email_message?: Maybe<Scalars['String']['output']>;
  default_start_time_for_reports?: Maybe<Scalars['DateTime']['output']>;
  detail_instructions?: Maybe<Scalars['String']['output']>;
  display_can_be_moved?: Maybe<Scalars['Boolean']['output']>;
  display_group_preference?: Maybe<Scalars['Boolean']['output']>;
  display_indicate_skills?: Maybe<Scalars['Boolean']['output']>;
  display_racesafe_app_opt_out?: Maybe<Scalars['Boolean']['output']>;
  display_shirt_size?: Maybe<Scalars['Boolean']['output']>;
  display_station_preference?: Maybe<Scalars['Boolean']['output']>;
  display_volunteer_notes?: Maybe<Scalars['Boolean']['output']>;
  encounterCallActions: Array<EncounterCallAction>;
  encounterDispositionTypes: Array<EncounterDispositionType>;
  eventTranslations: Array<EventTranslation>;
  eventVideos?: Maybe<Array<Maybe<EventVideo>>>;
  event_activities: Array<EventActivity>;
  event_forms: Array<EventForm>;
  event_hospitals: Array<EventHospital>;
  event_research_question_data: Array<EventResearchQuestionData>;
  event_research_questions: Array<EventResearchQuestion>;
  event_resources: Array<EventResource>;
  /** Optional HTML for the Medical Team registration confirmation email; supports {event name}. */
  event_team_registration_message?: Maybe<Scalars['String']['output']>;
  event_tracking_statuses: Array<EventTrackingStatus>;
  google_analytics_code?: Maybe<Scalars['String']['output']>;
  has_barcode?: Maybe<Scalars['Boolean']['output']>;
  has_chat_feature?: Maybe<Scalars['Boolean']['output']>;
  has_deidentified_data?: Maybe<Scalars['Boolean']['output']>;
  has_health_illness_button?: Maybe<Scalars['Boolean']['output']>;
  has_opinion_questionnaire?: Maybe<Scalars['Boolean']['output']>;
  has_triage_feature?: Maybe<Scalars['Boolean']['output']>;
  has_wgbt?: Maybe<Scalars['Boolean']['output']>;
  hospital_list?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intro_video?: Maybe<EventVideo>;
  is_active_app?: Maybe<Scalars['Boolean']['output']>;
  is_active_command?: Maybe<Scalars['Boolean']['output']>;
  is_disposition_default_resolved?: Maybe<Scalars['Boolean']['output']>;
  is_highschool?: Maybe<Scalars['Boolean']['output']>;
  is_master?: Maybe<Scalars['Boolean']['output']>;
  is_opinion_mandatory?: Maybe<Scalars['Boolean']['output']>;
  is_private?: Maybe<Scalars['Boolean']['output']>;
  is_regular_event?: Maybe<Scalars['Boolean']['output']>;
  is_subevent?: Maybe<Scalars['Boolean']['output']>;
  is_volunteer_shared?: Maybe<Scalars['Boolean']['output']>;
  kml_file?: Maybe<Scalars['String']['output']>;
  label_quick_search_id?: Maybe<Scalars['String']['output']>;
  label_search_id?: Maybe<Scalars['String']['output']>;
  label_triage_end?: Maybe<Scalars['String']['output']>;
  label_triage_start?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  latitude?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  low_connection_mode_threshold?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parent_event_id?: Maybe<Scalars['ID']['output']>;
  participantQuestions: Array<ParticipantQuestion>;
  participant_deadline?: Maybe<Scalars['Date']['output']>;
  participant_description?: Maybe<Scalars['String']['output']>;
  participant_hash?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  quick_report_title?: Maybe<Scalars['String']['output']>;
  /** Copy shown to event participants after registration completes (HTML). Also used as the participant registration confirmation email body when provided; omit for a default plaintext email. Supports {event name}. */
  registration_complete_instructions?: Maybe<Scalars['String']['output']>;
  show_event_research_question_on_open_spot?: Maybe<Scalars['Boolean']['output']>;
  show_sowg_fields?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subevent_instruction?: Maybe<Scalars['String']['output']>;
  subevent_resources?: Maybe<Array<Maybe<EventResource>>>;
  subevent_select_behavior?: Maybe<Scalars['String']['output']>;
  subevents: Array<Event>;
  teamQuestions: Array<TeamQuestion>;
  team_agreement?: Maybe<Scalars['String']['output']>;
  team_description?: Maybe<Scalars['String']['output']>;
  team_experience?: Maybe<Scalars['String']['output']>;
  team_role_id?: Maybe<Scalars['ID']['output']>;
  temperature_save_end_date?: Maybe<Scalars['Date']['output']>;
  temperature_save_start_date?: Maybe<Scalars['Date']['output']>;
  temperature_unit?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  total_count_visit?: Maybe<Scalars['Boolean']['output']>;
  training_status_app_access?: Maybe<Scalars['String']['output']>;
  training_video?: Maybe<EventVideo>;
  training_video_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  use_for_signup?: Maybe<Scalars['Boolean']['output']>;
  visit_modal_secs?: Maybe<Scalars['Int']['output']>;
  volunteer_deadline?: Maybe<Scalars['Date']['output']>;
  volunteer_hash?: Maybe<Scalars['String']['output']>;
  zoom?: Maybe<Scalars['Int']['output']>;
};

export type EventActivity = {
  __typename?: 'EventActivity';
  attaches_to_problem?: Maybe<Scalars['Boolean']['output']>;
  capture_role?: Maybe<CaptureRole>;
  category?: Maybe<ActivityCategory>;
  classification?: Maybe<ActivityClassification>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  eventButtonGroups: Array<EventButtonGroup>;
  eventForms: Array<EventForm>;
  event_id?: Maybe<Scalars['ID']['output']>;
  /** Name of the icon that shortcut shows. The apps ship the artwork. */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Compatibility field derived from capture_role: true for SELF_REPORT. */
  requires_review?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this activity is offered as a shortcut on the athlete search screen. */
  shows_on_search?: Maybe<Scalars['Boolean']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  systemActivityPage?: Maybe<SystemActivityPage>;
  system_activity_id?: Maybe<Scalars['ID']['output']>;
  system_activity_page_id?: Maybe<Scalars['ID']['output']>;
  translations: Array<EventActivityTranslation>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventActivityTranslation = {
  __typename?: 'EventActivityTranslation';
  event_activity_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

/**
 * Audit log entry tracking all changes to models.
 * Groups related changes with a unique change_id (ULID).
 */
export type EventAuditLog = {
  __typename?: 'EventAuditLog';
  action: Scalars['String']['output'];
  actor?: Maybe<User>;
  actor_id?: Maybe<Scalars['ID']['output']>;
  change_id: Scalars['String']['output'];
  changed: Scalars['JSON']['output'];
  created_at: Scalars['DateTime']['output'];
  enriched_changes?: Maybe<Scalars['JSON']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  record_pk: Scalars['String']['output'];
  table_name: Scalars['String']['output'];
  user_agent?: Maybe<Scalars['String']['output']>;
};

export type EventBodyPartData = {
  __typename?: 'EventBodyPartData';
  body?: Maybe<Scalars['String']['output']>;
  event_activity?: Maybe<EventActivity>;
  event_form?: Maybe<EventForm>;
  id?: Maybe<Scalars['ID']['output']>;
  part?: Maybe<Scalars['String']['output']>;
};

export type EventButton = {
  __typename?: 'EventButton';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventForm?: Maybe<EventForm>;
  event_id?: Maybe<Scalars['ID']['output']>;
  has_negative?: Maybe<Scalars['Boolean']['output']>;
  icd10?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  image_url_signed?: Maybe<Scalars['String']['output']>;
  is_medications_given?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  loinc?: Maybe<Scalars['String']['output']>;
  research_form_name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  system_button_id?: Maybe<Scalars['ID']['output']>;
  system_form_id?: Maybe<Scalars['ID']['output']>;
  tag1?: Maybe<Scalars['String']['output']>;
  tag2?: Maybe<Scalars['String']['output']>;
  tag3?: Maybe<Scalars['String']['output']>;
  translations: Array<EventButtonTranslation>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventButtonData = {
  __typename?: 'EventButtonData';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_activity?: Maybe<EventActivity>;
  event_button?: Maybe<EventButton>;
  event_button_group?: Maybe<EventButtonGroup>;
  id?: Maybe<Scalars['ID']['output']>;
  is_negative?: Maybe<Scalars['Boolean']['output']>;
};

export type EventButtonFreetextData = {
  __typename?: 'EventButtonFreetextData';
  event_activity?: Maybe<EventActivity>;
  event_button_group?: Maybe<EventButtonGroup>;
  freetext?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EventButtonGroup = {
  __typename?: 'EventButtonGroup';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  eventButtons: Array<EventButton>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_single_selection?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  system_button_group_id?: Maybe<Scalars['ID']['output']>;
  translations: Array<EventButtonGroupTranslation>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventButtonGroupTranslation = {
  __typename?: 'EventButtonGroupTranslation';
  event_button_group_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type EventButtonTranslation = {
  __typename?: 'EventButtonTranslation';
  event_button_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type EventContent = {
  __typename?: 'EventContent';
  copy?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type EventForm = {
  __typename?: 'EventForm';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  system_form_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventHospital = {
  __typename?: 'EventHospital';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventLabsData = {
  __typename?: 'EventLabsData';
  event_activity?: Maybe<EventActivity>;
  event_form?: Maybe<EventForm>;
  glucose?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  saturation?: Maybe<Scalars['String']['output']>;
  sodium?: Maybe<Scalars['String']['output']>;
};

export type EventMedicationGivenData = {
  __typename?: 'EventMedicationGivenData';
  directions?: Maybe<Scalars['String']['output']>;
  doseunit?: Maybe<Scalars['String']['output']>;
  event_activity?: Maybe<EventActivity>;
  event_form?: Maybe<EventForm>;
  id?: Maybe<Scalars['ID']['output']>;
  medication?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Event items. */
export type EventPaginator = {
  __typename?: 'EventPaginator';
  /** A list of Event items. */
  data: Array<Event>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type EventParticipant = {
  __typename?: 'EventParticipant';
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  alternate_phone_number?: Maybe<Scalars['String']['output']>;
  alternative_identifier?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  birth_date?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  delegation?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  encounters_with_trashed?: Maybe<Array<Maybe<Encounter>>>;
  event?: Maybe<Event>;
  event_signup_complete?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gender_short?: Maybe<Scalars['String']['output']>;
  has_cards_creation_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_exercises_manager_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_health_check_enabled?: Maybe<Scalars['Boolean']['output']>;
  health_check_level?: Maybe<Scalars['String']['output']>;
  height_formatted?: Maybe<Scalars['String']['output']>;
  height_inches?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier_number?: Maybe<Scalars['String']['output']>;
  import_error?: Maybe<Scalars['String']['output']>;
  import_id?: Maybe<Scalars['ID']['output']>;
  is_agreement_consented?: Maybe<Scalars['Boolean']['output']>;
  is_deidentified?: Maybe<Scalars['Boolean']['output']>;
  is_offline_mode?: Maybe<Scalars['Boolean']['output']>;
  is_spectator?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  master_encounters?: Maybe<Array<Maybe<Encounter>>>;
  master_tracking?: Maybe<Array<Maybe<TrackingHistory>>>;
  offline_context?: Maybe<Scalars['JSON']['output']>;
  offline_review_note?: Maybe<Scalars['String']['output']>;
  offline_reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  offline_reviewed_by?: Maybe<Scalars['ID']['output']>;
  offline_reviewer?: Maybe<User>;
  offline_sync_status?: Maybe<OfflineSyncStatus>;
  participant_agreement_timestamp?: Maybe<Scalars['DateTime']['output']>;
  participant_allergies?: Maybe<Array<Maybe<ParticipantAllergy>>>;
  participant_answers?: Maybe<Array<Maybe<ParticipantAnswer>>>;
  participant_conditions?: Maybe<Array<Maybe<ParticipantCondition>>>;
  participant_medications?: Maybe<Array<Maybe<ParticipantMedication>>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  primary_cellphone_number?: Maybe<Scalars['String']['output']>;
  primary_contact_email?: Maybe<Scalars['String']['output']>;
  primary_contact_first_name?: Maybe<Scalars['String']['output']>;
  primary_contact_last_name?: Maybe<Scalars['String']['output']>;
  primary_contact_phone?: Maybe<Scalars['String']['output']>;
  primary_contact_relationship?: Maybe<Scalars['String']['output']>;
  profile_photo?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  runner_number?: Maybe<Scalars['String']['output']>;
  secondary_contact_email?: Maybe<Scalars['String']['output']>;
  secondary_contact_first_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_last_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_phone?: Maybe<Scalars['String']['output']>;
  secondary_contact_relationship?: Maybe<Scalars['String']['output']>;
  share_user_data?: Maybe<Scalars['Boolean']['output']>;
  show_in_engage_listing?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<User>;
  user_allergies?: Maybe<Array<Maybe<Allergy>>>;
  user_conditions?: Maybe<Array<Maybe<Condition>>>;
  user_medications?: Maybe<Array<Maybe<UserMedication>>>;
  weight_lbs?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of EventParticipant items. */
export type EventParticipantPaginator = {
  __typename?: 'EventParticipantPaginator';
  /** A list of EventParticipant items. */
  data: Array<EventParticipant>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type EventRegistrationFieldOptions = {
  __typename?: 'EventRegistrationFieldOptions';
  countries: Array<Scalars['String']['output']>;
  delegations: Array<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  sports: Array<Scalars['String']['output']>;
};

export type EventResearchQuestion = {
  __typename?: 'EventResearchQuestion';
  eventButtonGroup?: Maybe<EventButtonGroup>;
  event_button_group_id?: Maybe<Scalars['ID']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  form_name?: Maybe<Scalars['String']['output']>;
  has_other_option?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  multiple_choice?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  options_source?: Maybe<Scalars['String']['output']>;
  other_title?: Maybe<Scalars['String']['output']>;
  show_in_amr?: Maybe<Scalars['Boolean']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tooltip_info?: Maybe<Scalars['String']['output']>;
  trigger_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EventResearchQuestionData = {
  __typename?: 'EventResearchQuestionData';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  encounter_spot_data_id?: Maybe<Scalars['ID']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  research_question_answer?: Maybe<Scalars['String']['output']>;
  research_question_title?: Maybe<Scalars['String']['output']>;
  research_question_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type EventResource = {
  __typename?: 'EventResource';
  assignment_time?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  default_nearest_station?: Maybe<Scalars['Boolean']['output']>;
  dont_relate_events?: Maybe<Scalars['Boolean']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  event_teams?: Maybe<Array<Maybe<EventTeam>>>;
  id: Scalars['ID']['output'];
  is_mobile?: Maybe<Scalars['Boolean']['output']>;
  is_sagbus?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mobile_resource_status?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ord?: Maybe<Scalars['Int']['output']>;
  resource_type?: Maybe<ResourceType>;
  resource_type_id?: Maybe<Scalars['ID']['output']>;
  tracking_dashboard_count?: Maybe<TrackingDashboardCounts>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventSubresource = {
  __typename?: 'EventSubresource';
  assignment_time?: Maybe<Scalars['String']['output']>;
  default_nearest_station?: Maybe<Scalars['Boolean']['output']>;
  event_resource_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_no_encounters?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ord?: Maybe<Scalars['Int']['output']>;
  resource_type_id?: Maybe<Scalars['ID']['output']>;
};

export type EventTeam = {
  __typename?: 'EventTeam';
  agreement?: Maybe<Scalars['Boolean']['output']>;
  authorization_level?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  background_with_fallback?: Maybe<Scalars['String']['output']>;
  can_be_moved?: Maybe<Scalars['Boolean']['output']>;
  chaperon?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  delegation?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  event_id?: Maybe<Scalars['ID']['output']>;
  event_resource?: Maybe<EventResource>;
  event_resource_preference?: Maybe<EventResource>;
  event_team_answers?: Maybe<Array<Maybe<TeamAnswer>>>;
  event_team_group_preference?: Maybe<EventTeamGroup>;
  experience?: Maybe<Scalars['String']['output']>;
  group_preference?: Maybe<Scalars['ID']['output']>;
  groupname?: Maybe<Scalars['String']['output']>;
  has_cards_creation_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_exercises_manager_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_health_check_enabled?: Maybe<Scalars['Boolean']['output']>;
  has_mobile_phone?: Maybe<Scalars['Boolean']['output']>;
  has_training_pages?: Maybe<Scalars['Boolean']['output']>;
  head_of_delegation?: Maybe<Scalars['String']['output']>;
  health_check_level?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSubevent?: Maybe<Scalars['Boolean']['output']>;
  is_own_guardian?: Maybe<Scalars['Boolean']['output']>;
  is_volunteer_other_events?: Maybe<Scalars['Boolean']['output']>;
  last_latitude?: Maybe<Scalars['Float']['output']>;
  /** Last successful RaceSafe GPS ping (server); null until a valid fix. */
  last_location_ping_at?: Maybe<Scalars['DateTime']['output']>;
  last_longitude?: Maybe<Scalars['Float']['output']>;
  last_nearest_resource?: Maybe<EventResource>;
  /** GPS-derived nearest station from the last presence ping; cleared on nightly reset. Distinct from station_preference (the team's chosen assignment). */
  last_nearest_resource_id?: Maybe<Scalars['ID']['output']>;
  /** What last updated RaceSafe presence on this row: refresh | spot | call | disposition. */
  last_ping_source?: Maybe<Scalars['String']['output']>;
  location_status?: Maybe<Scalars['String']['output']>;
  location_status_color?: Maybe<Scalars['String']['output']>;
  mobile_carrier?: Maybe<Scalars['String']['output']>;
  mobile_phone_type?: Maybe<Scalars['String']['output']>;
  mobile_type?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** Decay-adjusted presence token (green | yellow | red | gray); prefer this over location_status_color for live UI. */
  presence_status?: Maybe<Scalars['String']['output']>;
  /** Plain-language explanation of presence_status for operators. */
  presence_status_interpretation?: Maybe<Scalars['String']['output']>;
  racesafe_status?: Maybe<Scalars['String']['output']>;
  racesafe_status_decoded?: Maybe<Scalars['String']['output']>;
  racesafe_status_label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  show_in_engage_listing?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Scalars['String']['output']>;
  station_preference?: Maybe<Scalars['ID']['output']>;
  team_role?: Maybe<TeamRole>;
  training_status?: Maybe<Scalars['JSON']['output']>;
  user?: Maybe<User>;
  volunteer_assignment_info?: Maybe<Scalars['String']['output']>;
  volunteer_notes?: Maybe<Scalars['String']['output']>;
  wizard_complete?: Maybe<Scalars['Boolean']['output']>;
};

export type EventTeamGroup = {
  __typename?: 'EventTeamGroup';
  created_by?: Maybe<Scalars['ID']['output']>;
  event?: Maybe<Event>;
  id: Scalars['ID']['output'];
  is_displayed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EventTrackingStatus = {
  __typename?: 'EventTrackingStatus';
  color?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  font_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_private?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  systemLabel?: Maybe<SystemLabel>;
  system_tracking_status_id?: Maybe<Scalars['ID']['output']>;
};

export type EventTrainingPage = {
  __typename?: 'EventTrainingPage';
  event_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type EventTranslation = {
  __typename?: 'EventTranslation';
  daily_report_title?: Maybe<Scalars['String']['output']>;
  detail_instructions?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label_quick_search_id?: Maybe<Scalars['String']['output']>;
  label_search_id?: Maybe<Scalars['String']['output']>;
  label_triage_end?: Maybe<Scalars['String']['output']>;
  label_triage_green?: Maybe<Scalars['String']['output']>;
  label_triage_red?: Maybe<Scalars['String']['output']>;
  label_triage_start?: Maybe<Scalars['String']['output']>;
  label_triage_yellow?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  participant_description?: Maybe<Scalars['String']['output']>;
  quick_report_title?: Maybe<Scalars['String']['output']>;
  /** Localized participant registration screen copy (HTML); also used for localized registration confirmation emails when provided. */
  registration_complete_instructions?: Maybe<Scalars['String']['output']>;
  subevent_instruction?: Maybe<Scalars['String']['output']>;
  volunteer_agreement?: Maybe<Scalars['String']['output']>;
  volunteer_description?: Maybe<Scalars['String']['output']>;
  volunteer_experience_options?: Maybe<Scalars['String']['output']>;
};

export type EventTransport = {
  __typename?: 'EventTransport';
  event?: Maybe<Event>;
  event_hospital?: Maybe<EventHospital>;
  id: Scalars['ID']['output'];
};

export type EventVideo = {
  __typename?: 'EventVideo';
  description?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  medical_background?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type EventVitalSignsData = {
  __typename?: 'EventVitalSignsData';
  blood_pressure?: Maybe<Scalars['String']['output']>;
  breathing?: Maybe<Scalars['String']['output']>;
  diastole?: Maybe<Scalars['String']['output']>;
  event_activity?: Maybe<EventActivity>;
  event_form?: Maybe<EventForm>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  systole?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
};

export type FeatureState = {
  __typename?: 'FeatureState';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FileDeleteDetails = {
  __typename?: 'FileDeleteDetails';
  deletedAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
};

export type FileDetails = {
  __typename?: 'FileDetails';
  /** Source event of the file (populated by master/subevent aggregation). */
  eventId?: Maybe<Scalars['ID']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  /** The event participant the file is stored against. */
  eventParticipantId?: Maybe<Scalars['ID']['output']>;
  /** True when the file belongs to the participant currently being viewed (master aggregation only). */
  isCurrentParticipant?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<Maybe<FileMetadata>>>;
  name?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  temporaryUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['String']['output']>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FileRenameDetails = {
  __typename?: 'FileRenameDetails';
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newName?: Maybe<Scalars['String']['output']>;
  oldName?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  renamedAt?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  temporaryUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['String']['output']>;
};

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type HostConfig = {
  __typename?: 'HostConfig';
  app_title?: Maybe<Scalars['String']['output']>;
  balloons_background_color?: Maybe<Scalars['String']['output']>;
  balloons_background_pattern?: Maybe<Scalars['String']['output']>;
  balloons_icons?: Maybe<Scalars['String']['output']>;
  balloons_image?: Maybe<Scalars['String']['output']>;
  balloons_title?: Maybe<Scalars['String']['output']>;
  better_background_color?: Maybe<Scalars['String']['output']>;
  better_background_pattern?: Maybe<Scalars['String']['output']>;
  better_footer_text?: Maybe<Scalars['String']['output']>;
  better_image?: Maybe<Scalars['String']['output']>;
  better_left_image?: Maybe<Scalars['String']['output']>;
  better_left_text?: Maybe<Scalars['String']['output']>;
  better_right_image?: Maybe<Scalars['String']['output']>;
  better_right_text?: Maybe<Scalars['String']['output']>;
  better_subtitle?: Maybe<Scalars['String']['output']>;
  better_title?: Maybe<Scalars['String']['output']>;
  blocks_order?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  business_id?: Maybe<Scalars['ID']['output']>;
  card_images_titles_color?: Maybe<Scalars['String']['output']>;
  card_titles_color?: Maybe<Scalars['String']['output']>;
  cards_action_button_gradient_end_color?: Maybe<Scalars['String']['output']>;
  cards_action_button_gradient_start_color?: Maybe<Scalars['String']['output']>;
  cards_category_header_color?: Maybe<Scalars['String']['output']>;
  cards_outline_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  domain_name?: Maybe<Scalars['String']['output']>;
  domain_products?: Maybe<Scalars['JSON']['output']>;
  experience_background_color?: Maybe<Scalars['String']['output']>;
  experience_background_pattern?: Maybe<Scalars['String']['output']>;
  experience_buttons?: Maybe<Scalars['String']['output']>;
  experience_image?: Maybe<Scalars['String']['output']>;
  experience_subtitle?: Maybe<Scalars['String']['output']>;
  experience_text?: Maybe<Scalars['String']['output']>;
  experience_title?: Maybe<Scalars['String']['output']>;
  expire_date?: Maybe<Scalars['Date']['output']>;
  extra_css?: Maybe<Scalars['String']['output']>;
  header_color?: Maybe<Scalars['String']['output']>;
  header_end_color?: Maybe<Scalars['String']['output']>;
  header_font_color?: Maybe<Scalars['String']['output']>;
  header_links?: Maybe<Scalars['String']['output']>;
  header_runsafe_color?: Maybe<Scalars['String']['output']>;
  header_start_color?: Maybe<Scalars['String']['output']>;
  hero_background_color?: Maybe<Scalars['String']['output']>;
  hero_background_pattern?: Maybe<Scalars['String']['output']>;
  hero_buttons?: Maybe<Scalars['String']['output']>;
  hero_has_testimonial?: Maybe<Scalars['Boolean']['output']>;
  hero_image?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hero_main_title?: Maybe<Scalars['String']['output']>;
  hero_sub_title?: Maybe<Scalars['String']['output']>;
  hero_testimonial_image?: Maybe<Scalars['String']['output']>;
  hero_testimonial_quote?: Maybe<Scalars['String']['output']>;
  hero_testimonial_quote_from?: Maybe<Scalars['String']['output']>;
  hero_text_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inverted_powered_by?: Maybe<Scalars['Boolean']['output']>;
  is_internal_site?: Maybe<Scalars['Boolean']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  mobile_background_color?: Maybe<Scalars['String']['output']>;
  mobile_background_pattern?: Maybe<Scalars['String']['output']>;
  mobile_image?: Maybe<Scalars['String']['output']>;
  mobile_left_image?: Maybe<Scalars['String']['output']>;
  mobile_right_text?: Maybe<Scalars['String']['output']>;
  mobile_subtitle?: Maybe<Scalars['String']['output']>;
  mobile_title?: Maybe<Scalars['String']['output']>;
  news_background_color?: Maybe<Scalars['String']['output']>;
  news_background_pattern?: Maybe<Scalars['String']['output']>;
  news_image?: Maybe<Scalars['String']['output']>;
  news_title?: Maybe<Scalars['String']['output']>;
  og_description?: Maybe<Scalars['String']['output']>;
  og_image?: Maybe<Scalars['String']['output']>;
  og_title?: Maybe<Scalars['String']['output']>;
  partners_background_color?: Maybe<Scalars['String']['output']>;
  partners_background_pattern?: Maybe<Scalars['String']['output']>;
  partners_image?: Maybe<Scalars['String']['output']>;
  partners_logo?: Maybe<Scalars['String']['output']>;
  partners_title?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  primary_color_hover?: Maybe<Scalars['String']['output']>;
  primary_color_shadow?: Maybe<Scalars['String']['output']>;
  primary_text_color?: Maybe<Scalars['String']['output']>;
  racesafe_session_timeout?: Maybe<Scalars['Int']['output']>;
  recruit_background_color?: Maybe<Scalars['String']['output']>;
  recruit_background_pattern?: Maybe<Scalars['String']['output']>;
  recruit_image?: Maybe<Scalars['String']['output']>;
  recruit_images?: Maybe<Scalars['String']['output']>;
  recruit_link?: Maybe<Scalars['String']['output']>;
  recruit_subtitle?: Maybe<Scalars['String']['output']>;
  recruit_title?: Maybe<Scalars['String']['output']>;
  runsafe_session_timeout?: Maybe<Scalars['Int']['output']>;
  secondary_color?: Maybe<Scalars['String']['output']>;
  secondary_color_hover?: Maybe<Scalars['String']['output']>;
  secondary_color_shadow?: Maybe<Scalars['String']['output']>;
  secondary_text_color?: Maybe<Scalars['String']['output']>;
  subdomain_name?: Maybe<Scalars['String']['output']>;
  tertiary_color?: Maybe<Scalars['String']['output']>;
  tertiary_color_gradient_end?: Maybe<Scalars['String']['output']>;
  tertiary_color_hover?: Maybe<Scalars['String']['output']>;
  tertiary_color_hover_gradient_end?: Maybe<Scalars['String']['output']>;
  tertiary_text_color?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  videos_background_color?: Maybe<Scalars['String']['output']>;
  videos_image?: Maybe<Scalars['String']['output']>;
};

export type IncidentMoveCandidate = {
  __typename?: 'IncidentMoveCandidate';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type IncidentMoveCandidatePage = {
  __typename?: 'IncidentMoveCandidatePage';
  data: Array<IncidentMoveCandidate>;
  has_more: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type IncidentMoveCount = {
  __typename?: 'IncidentMoveCount';
  rows: Scalars['Int']['output'];
  table: Scalars['String']['output'];
};

export type IncidentMoveDestination = {
  __typename?: 'IncidentMoveDestination';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IncidentMoveIncident = {
  __typename?: 'IncidentMoveIncident';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The athlete's bib or identifier. */
  identifier: Scalars['String']['output'];
};

/** An operator's choice of destination equivalent for one unmatched reference. */
export type IncidentMoveMappingInput = {
  destination_id: Scalars['ID']['input'];
  /** Which kind of thing is being mapped: button, resource, activity, and so on. */
  reference: Scalars['String']['input'];
  source_id: Scalars['ID']['input'];
};

/**
 * How one athlete is handled. `action` is repoint (use the destination's existing
 * record), move (carry their record across), create (give them a new record
 * there), or undecided, which the operator has to settle before the move can run.
 */
export type IncidentMoveParticipant = {
  __typename?: 'IncidentMoveParticipant';
  action: Scalars['String']['output'];
  /** False when other incidents of theirs would be left behind, which rules out moving the record. */
  can_move: Scalars['Boolean']['output'];
  from: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  /** How many athletes on the destination event hold this identifier. */
  match_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Why this athlete needs a decision, in plain terms. */
  reason?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['ID']['output']>;
  /** What the athlete will end up attached to, once decided. */
  to_label?: Maybe<Scalars['String']['output']>;
};

export type IncidentMoveParticipantCandidate = {
  __typename?: 'IncidentMoveParticipantCandidate';
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type IncidentMoveParticipantChoiceInput = {
  /** repoint, move, or create. */
  action: Scalars['String']['input'];
  from_participant_id: Scalars['ID']['input'];
  /** The athlete to attach the care to. Required for repoint. */
  to_participant_id?: InputMaybe<Scalars['ID']['input']>;
};

export type IncidentMoveParticipantPage = {
  __typename?: 'IncidentMoveParticipantPage';
  data: Array<IncidentMoveParticipantCandidate>;
  has_more: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

/** What moving one incident to another subevent would do, worked out before anything is written. */
export type IncidentMovePlan = {
  __typename?: 'IncidentMovePlan';
  /** Reasons the move cannot go ahead at all. These cannot be resolved by choosing an equivalent. */
  blockers: Array<Scalars['String']['output']>;
  counts: Array<IncidentMoveCount>;
  destination_event_id: Scalars['ID']['output'];
  encounter_ids: Array<Scalars['ID']['output']>;
  /** The incidents in this move, for confirming the right ones were selected. */
  incidents: Array<IncidentMoveIncident>;
  /** False while anything is blocked or unresolved. The move cannot be confirmed until this is true. */
  is_ready: Scalars['Boolean']['output'];
  /** True while any athlete still needs the operator to say how to handle them. */
  needs_participant_decision: Scalars['Boolean']['output'];
  participants: Array<IncidentMoveParticipant>;
  /** What the move deliberately leaves alone. */
  preserved: Array<Scalars['String']['output']>;
  /** References that will be repointed, and what they will become. */
  remapped: Array<IncidentMoveRemap>;
  source_event_id: Scalars['ID']['output'];
  /** References with no equivalent on the destination subevent. Each needs a choice. */
  unresolved: Array<IncidentMoveUnresolved>;
};

export type IncidentMoveRemap = {
  __typename?: 'IncidentMoveRemap';
  destination_id: Scalars['ID']['output'];
  destination_label: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  source_id: Scalars['ID']['output'];
  source_label: Scalars['String']['output'];
};

export type IncidentMoveUnresolved = {
  __typename?: 'IncidentMoveUnresolved';
  /** How many rows on the destination subevent could stand in for it. Fetch them with incidentMoveCandidates; zero means there is nothing to choose and the destination has to be edited first. */
  candidate_count: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  source_id: Scalars['ID']['output'];
  source_label: Scalars['String']['output'];
  /** Where this reference is used, in plain terms. */
  used_by: Scalars['String']['output'];
};

export type IncidentSummary = {
  __typename?: 'IncidentSummary';
  illnessIncidents?: Maybe<Scalars['Int']['output']>;
  injuryIncidents?: Maybe<Scalars['Int']['output']>;
  majorIncidents?: Maybe<Scalars['Int']['output']>;
  minorIncidents?: Maybe<Scalars['Int']['output']>;
  totalIncidents?: Maybe<Scalars['Int']['output']>;
  totalPersons?: Maybe<Scalars['Int']['output']>;
};

export type IncidentsBySport = {
  __typename?: 'IncidentsBySport';
  call?: Maybe<Scalars['Int']['output']>;
  illness?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
};

export type IncidentsByStation = {
  __typename?: 'IncidentsByStation';
  call?: Maybe<Scalars['Int']['output']>;
  illness?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  station?: Maybe<Scalars['String']['output']>;
};

export type IncidentsByTime = {
  __typename?: 'IncidentsByTime';
  illness?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  wbgt?: Maybe<Scalars['Float']['output']>;
};

export type KunakElement = {
  __typename?: 'KunakElement';
  element_id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KunakTemperatureData = {
  __typename?: 'KunakTemperatureData';
  elements: Array<KunakElement>;
  enabled: Scalars['Boolean']['output'];
  period_uuid?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarkNotificationsReadResponse = {
  __typename?: 'MarkNotificationsReadResponse';
  success: Scalars['Boolean']['output'];
  unread_count: Scalars['Int']['output'];
};

export type MedicalTeamPageData = {
  __typename?: 'MedicalTeamPageData';
  event?: Maybe<Event>;
  event_resources?: Maybe<Array<Maybe<EventResource>>>;
  roles?: Maybe<Array<Maybe<TeamRole>>>;
  unassigned_event_teams?: Maybe<Array<Maybe<EventTeam>>>;
};

export type MedicalTeamProfileData = {
  __typename?: 'MedicalTeamProfileData';
  event_teams?: Maybe<Array<Maybe<EventTeam>>>;
  user?: Maybe<User>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addParticipant?: Maybe<EventParticipant>;
  assignEventTeamToEventResource?: Maybe<EventTeam>;
  assignEventTeamsToEventResource?: Maybe<Array<Maybe<EventTeam>>>;
  assignParentEncounter?: Maybe<Encounter>;
  assignRoleToEventTeam?: Maybe<EventTeam>;
  /** Clear a day's queue in one action. Files nothing — use reviewEntry to attach content to a problem. */
  bulkReviewEntries?: Maybe<Array<Maybe<Encounter>>>;
  cancelTransport?: Maybe<EncounterDisposition>;
  changeEncounterRecord?: Maybe<Encounter>;
  closeRecord?: Maybe<Encounter>;
  contactUs: ContactResponse;
  createChild?: Maybe<User>;
  createEncounterDisposition?: Maybe<Array<Maybe<Encounter>>>;
  createEventParticipant?: Maybe<EventParticipant>;
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteEncounter?: Maybe<Encounter>;
  deleteEventParticipantFile?: Maybe<FileDeleteDetails>;
  /** Correct the treatments on an entry awaiting review. The athlete's original answer is kept for audit. */
  editEntry?: Maybe<Encounter>;
  exportEventTeamList?: Maybe<Array<Maybe<EventTeam>>>;
  findEventParticipant?: Maybe<EventParticipant>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  generateIdentifierNumber?: Maybe<Scalars['String']['output']>;
  login: AuthPayload;
  loginDemoUser: AuthPayload;
  logout: LogoutResponse;
  makeCall?: Maybe<Encounter>;
  /** Marks notifications read for the signed-in user. Omit ids to mark them all. */
  markNotificationsRead: MarkNotificationsReadResponse;
  /** SUP-634. Move one incident to another subevent of the same master event, remapping every event-scoped reference it carries. */
  moveIncidentToSubevent?: Maybe<IncidentMovePlan>;
  moveParticipantData?: Maybe<EventParticipant>;
  notifyContact?: Maybe<Encounter>;
  openRecord?: Maybe<Encounter>;
  recordSpot?: Maybe<Encounter>;
  recordSpotDisposition?: Maybe<Encounter>;
  recordWbgt: Temperature;
  registerEventParticipant?: Maybe<Array<Maybe<EventParticipant>>>;
  registerEventTeam?: Maybe<Array<Maybe<EventTeam>>>;
  renameEventParticipantFile?: Maybe<FileRenameDetails>;
  resend2FACode: Resend2FaCodePayload;
  resetPassword?: Maybe<ForgotPasswordPayload>;
  /**
   * Resolve an offline record whose participant could not be identified.
   *
   * Pass to_participant to attach the care to the athlete holding that identifier; omit it to
   * accept the record as care for someone who was never registered. Either way the record stops
   * asking for attention and rejoins the counts.
   */
  resolveOfflineRecord?: Maybe<EventParticipant>;
  /**
   * Accept or refuse an entry.
   *
   * Approving files its content into target_encounter_id, if one is given; the
   * athlete may have chosen no problem, in which case the entry stands on its own
   * for the clinician to classify. Rejecting moves nothing.
   */
  reviewEntry?: Maybe<Encounter>;
  searchParticipantsByQuery: SearchResult;
  sendPushNotification: PushNotificationResponse;
  signup: AuthPayload;
  /** Start an open problem for an entry's athlete, to file the entry into. Created with no details. */
  startProblemFromEntry?: Maybe<Encounter>;
  submitSmsNotificationConsent?: Maybe<SmsNotificationConsent>;
  unassignEventTeamFromEventResource?: Maybe<EventTeam>;
  unassignEventTeamsFromEventResource?: Maybe<Array<Maybe<EventTeam>>>;
  undeleteEncounter?: Maybe<Encounter>;
  /** Separate an encounter from whatever it is merged with: a merged child leaves its parent, a parent releases its merged children. */
  unmergeEncounter?: Maybe<Encounter>;
  updateCall?: Maybe<EncounterSpotData>;
  updateEventParticipantDetails?: Maybe<Array<Maybe<EventParticipant>>>;
  updateEventTeamAgreement?: Maybe<Array<Maybe<EventTeam>>>;
  updateEventTeamByAdmin?: Maybe<EventTeam>;
  updateEventTeamDetails?: Maybe<EventTeam>;
  updateEventTeamProfile?: Maybe<Array<Maybe<EventTeam>>>;
  updateEventTeamStatus?: Maybe<Array<Maybe<EventTeam>>>;
  updateParticipantStatus?: Maybe<Tracking>;
  updateProfile?: Maybe<User>;
  updateTransport?: Maybe<EncounterDisposition>;
  uploadEventParticipantFiles?: Maybe<FileDetails>;
  verify2FA: AuthPayload;
};


export type MutationAddParticipantArgs = {
  birth_date?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  primary_cellphone_number?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignEventTeamToEventResourceArgs = {
  event_id: Scalars['ID']['input'];
  event_resource_id: Scalars['ID']['input'];
  event_team_id: Scalars['ID']['input'];
};


export type MutationAssignEventTeamsToEventResourceArgs = {
  event_id: Scalars['ID']['input'];
  event_resource_id: Scalars['ID']['input'];
  event_team_ids: Array<Scalars['ID']['input']>;
};


export type MutationAssignParentEncounterArgs = {
  encounter_id: Scalars['ID']['input'];
  parent_encounter_id: Scalars['ID']['input'];
};


export type MutationAssignRoleToEventTeamArgs = {
  event_team_id: Scalars['ID']['input'];
  team_role_id: Scalars['ID']['input'];
};


export type MutationBulkReviewEntriesArgs = {
  action: EntryReviewAction;
  encounter_ids: Array<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  unattached_as_care?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCancelTransportArgs = {
  encounter_disposition_id: Scalars['ID']['input'];
};


export type MutationChangeEncounterRecordArgs = {
  disposition_changes?: InputMaybe<Array<DispositionChangesInput>>;
  encounter_changes?: InputMaybe<EncounterChangesInput>;
  encounter_id: Scalars['ID']['input'];
};


export type MutationCloseRecordArgs = {
  encounter_id: Scalars['ID']['input'];
  participant_id: Scalars['ID']['input'];
};


export type MutationContactUsArgs = {
  email: Scalars['String']['input'];
  event: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationCreateChildArgs = {
  date_of_birth: Scalars['Date']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  parent_id: Scalars['ID']['input'];
};


export type MutationCreateEncounterDispositionArgs = {
  active_encounter_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  care_provider?: InputMaybe<Scalars['String']['input']>;
  client_active_encounter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  client_resolved_encounter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  disposition_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  encounter_disposition_type_id: Scalars['ID']['input'];
  event_id: Scalars['ID']['input'];
  event_tracking_status_id?: InputMaybe<Scalars['ID']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  is_offline_mode?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mobile_resource_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
  offline_sync_status?: InputMaybe<OfflineSyncStatus>;
  participant_condition?: InputMaybe<Scalars['String']['input']>;
  reported_by?: InputMaybe<Scalars['ID']['input']>;
  resolved_encounter_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCreateEventParticipantArgs = {
  date_of_birth?: InputMaybe<Scalars['Date']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  is_offline_mode?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
  offline_sync_status?: InputMaybe<OfflineSyncStatus>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteEncounterArgs = {
  encounter_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
};


export type MutationDeleteEventParticipantFileArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  file_name: Scalars['String']['input'];
};


export type MutationEditEntryArgs = {
  data: Scalars['JSON']['input'];
  encounter_id: Scalars['ID']['input'];
};


export type MutationExportEventTeamListArgs = {
  volunteer_hash: Scalars['String']['input'];
};


export type MutationFindEventParticipantArgs = {
  audit_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateIdentifierNumberArgs = {
  event_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginDemoUserArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMakeCallArgs = {
  client_encounter_id?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  encounter_call_action_id: Scalars['ID']['input'];
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
  offline_sync_status?: InputMaybe<OfflineSyncStatus>;
  old_visit?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkNotificationsReadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationMoveIncidentToSubeventArgs = {
  destination_event_id: Scalars['ID']['input'];
  encounter_ids: Array<Scalars['ID']['input']>;
  mappings?: InputMaybe<Array<IncidentMoveMappingInput>>;
  participant_choices?: InputMaybe<Array<IncidentMoveParticipantChoiceInput>>;
};


export type MutationMoveParticipantDataArgs = {
  event_id: Scalars['ID']['input'];
  from_participant: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  to_participant: Scalars['String']['input'];
  to_participant_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationNotifyContactArgs = {
  client_encounter_id?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  encounter_call_action_id: Scalars['ID']['input'];
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
  offline_sync_status?: InputMaybe<OfflineSyncStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOpenRecordArgs = {
  encounter_id: Scalars['ID']['input'];
  participant_id: Scalars['ID']['input'];
};


export type MutationRecordSpotArgs = {
  client_encounter_id?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_activity_id?: InputMaybe<Scalars['ID']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
  offline_sync_status?: InputMaybe<OfflineSyncStatus>;
  old_visit?: InputMaybe<Scalars['Boolean']['input']>;
  proposed_encounter_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordSpotDispositionArgs = {
  care_provider?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  encounter_disposition_type_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  event_action_id?: InputMaybe<Scalars['ID']['input']>;
  event_activity_id?: InputMaybe<Scalars['ID']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  event_tracking_status_id?: InputMaybe<Scalars['ID']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mobile_resource_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reported_by?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordWbgtArgs = {
  event_resource_id?: InputMaybe<Scalars['ID']['input']>;
  scale: Scalars['String']['input'];
  temperature: Scalars['Float']['input'];
  volunteer_hash: Scalars['String']['input'];
};


export type MutationRegisterEventParticipantArgs = {
  event_ids: Array<Scalars['ID']['input']>;
};


export type MutationRegisterEventTeamArgs = {
  event_ids: Array<Scalars['ID']['input']>;
};


export type MutationRenameEventParticipantFileArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  new_file_name: Scalars['String']['input'];
  old_file_name: Scalars['String']['input'];
};


export type MutationResend2FaCodeArgs = {
  user_id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResolveOfflineRecordArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  participant_id: Scalars['ID']['input'];
  to_participant?: InputMaybe<Scalars['String']['input']>;
  to_participant_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationReviewEntryArgs = {
  action: EntryReviewAction;
  encounter_id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  target_encounter_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSearchParticipantsByQueryArgs = {
  event_id: Scalars['ID']['input'];
  only_subevent?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
};


export type MutationSendPushNotificationArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  event_id?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  dob: Scalars['String']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  race_signup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartProblemFromEntryArgs = {
  encounter_id: Scalars['ID']['input'];
  event_activity_id: Scalars['ID']['input'];
};


export type MutationSubmitSmsNotificationConsentArgs = {
  event_id: Scalars['ID']['input'];
  is_consent: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
};


export type MutationUnassignEventTeamFromEventResourceArgs = {
  event_id: Scalars['ID']['input'];
  event_team_id: Scalars['ID']['input'];
};


export type MutationUnassignEventTeamsFromEventResourceArgs = {
  event_id: Scalars['ID']['input'];
  event_team_ids: Array<Scalars['ID']['input']>;
};


export type MutationUndeleteEncounterArgs = {
  encounter_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
};


export type MutationUnmergeEncounterArgs = {
  encounter_id: Scalars['ID']['input'];
};


export type MutationUpdateCallArgs = {
  encounter_spot_data_id?: InputMaybe<Scalars['ID']['input']>;
  new_encounter_id: Scalars['ID']['input'];
  old_encounter_id: Scalars['ID']['input'];
};


export type MutationUpdateEventParticipantDetailsArgs = {
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  participant_hash: Scalars['String']['input'];
  primary_contact_email?: InputMaybe<Scalars['String']['input']>;
  primary_contact_first_name?: InputMaybe<Scalars['String']['input']>;
  primary_contact_last_name?: InputMaybe<Scalars['String']['input']>;
  primary_contact_phone?: InputMaybe<Scalars['String']['input']>;
  primary_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_email?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_first_name?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_last_name?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_phone?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  termsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEventTeamAgreementArgs = {
  agreed: Scalars['Boolean']['input'];
  volunteer_hash: Scalars['String']['input'];
};


export type MutationUpdateEventTeamByAdminArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  can_be_moved?: InputMaybe<Scalars['Boolean']['input']>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  delegation?: InputMaybe<Scalars['String']['input']>;
  event_team_id: Scalars['ID']['input'];
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['String']['input']>;
  volunteer_hash: Scalars['String']['input'];
  volunteer_notes?: InputMaybe<Scalars['String']['input']>;
  volunteer_other_events?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEventTeamDetailsArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  can_be_moved?: InputMaybe<Scalars['Boolean']['input']>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  delegation?: InputMaybe<Scalars['String']['input']>;
  event_team_id?: InputMaybe<Scalars['ID']['input']>;
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['String']['input']>;
  volunteer_hash: Scalars['String']['input'];
  volunteer_notes?: InputMaybe<Scalars['String']['input']>;
  volunteer_other_events?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEventTeamProfileArgs = {
  address1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  med_licence_number?: InputMaybe<Scalars['String']['input']>;
  medical_background?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subscribe_to_products_services?: InputMaybe<Scalars['Boolean']['input']>;
  terms_and_conditions: Scalars['Boolean']['input'];
  volunteer_hash: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventTeamStatusArgs = {
  status: Scalars['String']['input'];
  volunteer_hash: Scalars['String']['input'];
};


export type MutationUpdateParticipantStatusArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  event_tracking_status_id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  offline_context?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateProfileArgs = {
  address1?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email_about_other_products?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_identity?: InputMaybe<Scalars['String']['input']>;
  is_waiver_agreement_consented?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  med_licence_number?: InputMaybe<Scalars['String']['input']>;
  medical_background?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['ID']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTransportArgs = {
  admission_date?: InputMaybe<Scalars['Date']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  discharge_date?: InputMaybe<Scalars['Date']['input']>;
  encounter_disposition_id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadEventParticipantFilesArgs = {
  customFileName?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationVerify2FaArgs = {
  code: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};

export type NavbarData = {
  __typename?: 'NavbarData';
  is_super_admin?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maybe<NavbarItem>>;
};

export type NavbarItem = {
  __typename?: 'NavbarItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  participant_hash?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  subitems?: Maybe<Array<Maybe<NavbarItem>>>;
  team_role_controls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volunteer_hash?: Maybe<Scalars['String']['output']>;
};

export type NearestResourceResult = {
  __typename?: 'NearestResourceResult';
  assigned_resource?: Maybe<EventResource>;
  nearest_resource?: Maybe<EventResource>;
  same_resource?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team_role?: Maybe<TeamRole>;
};

export enum OfflineSyncStatus {
  MultiParticipant = 'MULTI_PARTICIPANT',
  NeedsReview = 'NEEDS_REVIEW',
  NewParticipant = 'NEW_PARTICIPANT',
  PossibleDuplicate = 'POSSIBLE_DUPLICATE',
  Reviewed = 'REVIEWED'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type ParticipantAllergy = {
  __typename?: 'ParticipantAllergy';
  allergy_id?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clinical_status?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  criticality?: Maybe<Scalars['String']['output']>;
  event_participant_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onset_age?: Maybe<Scalars['String']['output']>;
  onset_date_time?: Maybe<Scalars['DateTime']['output']>;
  onset_period?: Maybe<Scalars['String']['output']>;
  onset_range?: Maybe<Scalars['String']['output']>;
  onset_string?: Maybe<Scalars['String']['output']>;
  participant_questions_id?: Maybe<Scalars['ID']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ParticipantAnswer = {
  __typename?: 'ParticipantAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_participant_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  participant_question?: Maybe<ParticipantQuestion>;
  participant_questions_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ParticipantCondition = {
  __typename?: 'ParticipantCondition';
  abatement_date_time?: Maybe<Scalars['DateTime']['output']>;
  bodysite_id?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  clinical_status?: Maybe<Scalars['String']['output']>;
  condition_id?: Maybe<Scalars['ID']['output']>;
  condition_type_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  event_participant_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onset_date_time?: Maybe<Scalars['DateTime']['output']>;
  participant_questions_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  verification_status?: Maybe<Scalars['String']['output']>;
};

export type ParticipantMedication = {
  __typename?: 'ParticipantMedication';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  doseunit?: Maybe<Scalars['String']['output']>;
  event_participant_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  medication_id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  participant_questions_id?: Maybe<Scalars['ID']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type ParticipantProfileData = {
  __typename?: 'ParticipantProfileData';
  event_participants?: Maybe<Array<Maybe<EventParticipant>>>;
  user?: Maybe<User>;
};

export type ParticipantQuestion = {
  __typename?: 'ParticipantQuestion';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  multiple_selection?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  other_title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tooltip_info?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A page of entries for the review queue. */
export type PendingEntryPage = {
  __typename?: 'PendingEntryPage';
  entries?: Maybe<Array<Maybe<Encounter>>>;
  next_cursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PushNotificationResponse = {
  __typename?: 'PushNotificationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  encountersByTeam: Array<Encounter>;
  eventContents: Array<EventContent>;
  eventRegistrationFieldOptions: EventRegistrationFieldOptions;
  eventTeamByEvent?: Maybe<Array<EventTeam>>;
  eventTeamControls: TeamRole;
  events: EventPaginator;
  /** Release flags that are on for the signed-in user. Pass an event when the answer could depend on it. */
  features: Array<FeatureState>;
  fetchEvent?: Maybe<Event>;
  fetchEventWithHash?: Maybe<Event>;
  fetchParticipantStatus?: Maybe<Tracking>;
  findEncountersForCommandCenter: EncounterPaginator;
  findEventParticipant?: Maybe<EventParticipant>;
  findEventParticipantFiles?: Maybe<Array<Maybe<FileDetails>>>;
  findMasterEventParticipantFiles?: Maybe<Array<Maybe<FileDetails>>>;
  findTeamNearestResource?: Maybe<NearestResourceResult>;
  generateIdentifierNumber?: Maybe<Scalars['String']['output']>;
  getAMRData?: Maybe<AmrData>;
  getChartsData?: Maybe<ChartsData>;
  getCleanData?: Maybe<CleanData>;
  getCommandStats?: Maybe<CommandStats>;
  getDataExport?: Maybe<DataExport>;
  getEncounter?: Maybe<Encounter>;
  getEncounterAuditHistory: Array<EventAuditLog>;
  getEncounterFilterData?: Maybe<EncounterFilterData>;
  /**
   * The problems a reviewer may file an entry into.
   *
   * The entry's own athlete only, and only activities that own a problem — an entry
   * cannot be filed into another entry.
   */
  getEntryProblemOptions?: Maybe<Array<Maybe<Encounter>>>;
  getEventParticipantDetails?: Maybe<EventParticipant>;
  getEventTeams?: Maybe<Array<Maybe<EventTeam>>>;
  getHostConfig?: Maybe<HostConfig>;
  getKunakTemperatureData?: Maybe<KunakTemperatureData>;
  getMe?: Maybe<User>;
  getMedicalTeamPageData?: Maybe<MedicalTeamPageData>;
  getMedicalTeamProfileData?: Maybe<MedicalTeamProfileData>;
  getMyEventTeam?: Maybe<EventTeam>;
  getParticipantProfileData?: Maybe<ParticipantProfileData>;
  /**
   * Entries a clinician has yet to act on, for the review queue.
   *
   * Filtered on the entry's review status. Self-reported activities enter pending
   * review automatically; provider-captured activities do not.
   */
  getPendingEntries?: Maybe<PendingEntryPage>;
  getRegisteredEventTeams?: Maybe<Array<Maybe<EventTeam>>>;
  getReportTableData?: Maybe<ReportTableData>;
  getResourceTracking?: Maybe<Array<Maybe<Tracking>>>;
  getSignUpAgreementPageData?: Maybe<SignUpAgreementPageData>;
  getStatusDashboardCounts?: Maybe<Array<Maybe<TrackingDashboardCounts>>>;
  getStatusTracking?: Maybe<Array<Maybe<Tracking>>>;
  getTeamResources: Array<EventResource>;
  getTemperatureData?: Maybe<Temperature>;
  getTrainingPagesData?: Maybe<Array<Maybe<EventTrainingPage>>>;
  getUser?: Maybe<User>;
  /** SUP-634. Destination rows an unmatched reference could be mapped onto, searched and paginated. */
  incidentMoveCandidates: IncidentMoveCandidatePage;
  /** SUP-634. The other events under this incident's master event that it could be re-filed onto. */
  incidentMoveDestinations: Array<IncidentMoveDestination>;
  /** SUP-634. Athletes on the destination event, searched by bib or name. */
  incidentMoveParticipantCandidates: IncidentMoveParticipantPage;
  /** The signed-in user's notification history, newest first. */
  myNotifications: AppNotificationPaginator;
  navbar?: Maybe<NavbarData>;
  participantEmergencyContacts: Array<EventParticipant>;
  participants: EventParticipantPaginator;
  /** SUP-634. Dry run for moving one incident to another subevent of the same master event. */
  previewIncidentSubeventMove?: Maybe<IncidentMovePlan>;
  searchParticipantTracking?: Maybe<Array<Maybe<Tracking>>>;
  searchParticipantsByQuery: SearchResult;
  /** How many notifications in the history the signed-in user has not read. */
  unreadNotificationCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  userTeamEvents: EventPaginator;
  users: UserPaginator;
  verifyToken?: Maybe<TokenVerificationResult>;
};


export type QueryEncountersByTeamArgs = {
  event_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventContentsArgs = {
  participant_hash: Scalars['String']['input'];
};


export type QueryEventRegistrationFieldOptionsArgs = {
  event_id: Scalars['ID']['input'];
};


export type QueryEventTeamByEventArgs = {
  event_id: Scalars['ID']['input'];
};


export type QueryEventTeamControlsArgs = {
  event_id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeaturesArgs = {
  event_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFetchEventArgs = {
  participant_hash?: InputMaybe<Scalars['String']['input']>;
  volunteer_hash?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchEventWithHashArgs = {
  hash?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchParticipantStatusArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
};


export type QueryFindEncountersForCommandCenterArgs = {
  encounter_call_action_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_disposition_type_id?: InputMaybe<Scalars['ID']['input']>;
  event_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  ignore_related?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindEventParticipantArgs = {
  audit_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryFindEventParticipantFilesArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
};


export type QueryFindMasterEventParticipantFilesArgs = {
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
};


export type QueryFindTeamNearestResourceArgs = {
  event_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryGenerateIdentifierNumberArgs = {
  event_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAmrDataArgs = {
  event_participant_id: Scalars['ID']['input'];
};


export type QueryGetChartsDataArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  opinion?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCleanDataArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  opinion?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCommandStatsArgs = {
  hash: Scalars['ID']['input'];
};


export type QueryGetDataExportArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  opinion?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEncounterArgs = {
  encounter_id: Scalars['ID']['input'];
};


export type QueryGetEncounterAuditHistoryArgs = {
  encounter_id: Scalars['ID']['input'];
};


export type QueryGetEncounterFilterDataArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetEntryProblemOptionsArgs = {
  encounter_id: Scalars['ID']['input'];
};


export type QueryGetEventParticipantDetailsArgs = {
  participant_hash: Scalars['String']['input'];
};


export type QueryGetEventTeamsArgs = {
  volunteer_hash: Scalars['String']['input'];
};


export type QueryGetHostConfigArgs = {
  domain_name?: InputMaybe<Scalars['String']['input']>;
  subdomain_name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetKunakTemperatureDataArgs = {
  hash: Scalars['String']['input'];
  update?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetMedicalTeamPageDataArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetMyEventTeamArgs = {
  volunteer_hash: Scalars['String']['input'];
};


export type QueryGetPendingEntriesArgs = {
  across_subevents?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  opinion?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  review_status?: InputMaybe<ReviewStatus>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRegisteredEventTeamsArgs = {
  volunteer_hash: Scalars['String']['input'];
};


export type QueryGetReportTableDataArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  opinion?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetResourceTrackingArgs = {
  event_resource_id: Scalars['ID']['input'];
};


export type QueryGetSignUpAgreementPageDataArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetStatusDashboardCountsArgs = {
  hash: Scalars['String']['input'];
  recalculate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetStatusTrackingArgs = {
  event_id: Scalars['ID']['input'];
  event_tracking_status_id: Scalars['ID']['input'];
};


export type QueryGetTeamResourcesArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetTemperatureDataArgs = {
  hash: Scalars['String']['input'];
  update?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTrainingPagesDataArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIncidentMoveCandidatesArgs = {
  destination_event_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reference: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIncidentMoveDestinationsArgs = {
  encounter_id: Scalars['ID']['input'];
};


export type QueryIncidentMoveParticipantCandidatesArgs = {
  destination_event_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyNotificationsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParticipantEmergencyContactsArgs = {
  participant_id: Scalars['ID']['input'];
};


export type QueryParticipantsArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewIncidentSubeventMoveArgs = {
  destination_event_id: Scalars['ID']['input'];
  encounter_ids: Array<Scalars['ID']['input']>;
  mappings?: InputMaybe<Array<IncidentMoveMappingInput>>;
  participant_choices?: InputMaybe<Array<IncidentMoveParticipantChoiceInput>>;
};


export type QuerySearchParticipantTrackingArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  tracking_states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tracking_status_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QuerySearchParticipantsByQueryArgs = {
  event_id: Scalars['ID']['input'];
  only_subevent?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
};


export type QueryUserArgs = {
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserTeamEventsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  first?: Scalars['Int']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifyTokenArgs = {
  auth_token: Scalars['String']['input'];
};

export type ReportTableData = {
  __typename?: 'ReportTableData';
  dailyIncidentSummary?: Maybe<DailyIncidentSummary>;
  eventDateRange?: Maybe<Scalars['String']['output']>;
  eventTitle?: Maybe<Scalars['String']['output']>;
  incidentOutcomes?: Maybe<Scalars['JSON']['output']>;
};

export type Resend2FaCodePayload = {
  __typename?: 'Resend2FACodePayload';
  message: Scalars['String']['output'];
  /** Seconds until another code may be requested; null when the answer is to log in again. */
  retry_after_seconds?: Maybe<Scalars['Int']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  color?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  icon_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

/**
 * Where an entry sits between "an athlete said so" and "it is in the record".
 *
 * Null means the entry was never subject to review — every record captured before
 * this existed, and every provider-entered record since. Null is FINAL, not unfinished.
 */
export enum ReviewStatus {
  Approved = 'APPROVED',
  /** Accepted because its window expired, not because anyone read it. Credited to no clinician. */
  AutoAccepted = 'AUTO_ACCEPTED',
  /** The only state a clinician still has to act on. */
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  empty_due_permissions?: Maybe<Scalars['Boolean']['output']>;
  participants?: Maybe<Array<Maybe<EventParticipant>>>;
};

export type SignUpAgreementPageData = {
  __typename?: 'SignUpAgreementPageData';
  event?: Maybe<Event>;
  event_team?: Maybe<EventTeam>;
};

export type SmsNotificationConsent = {
  __typename?: 'SmsNotificationConsent';
  consented_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_consent?: Maybe<Scalars['Boolean']['output']>;
  master_event?: Maybe<Event>;
  name?: Maybe<Scalars['String']['output']>;
  phone_normalized?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  submitted_event?: Maybe<Event>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type StatusTrigger = {
  __typename?: 'StatusTrigger';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Symptom = {
  __typename?: 'Symptom';
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type SystemActivityPage = {
  __typename?: 'SystemActivityPage';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  system_activity_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type SystemLabel = {
  __typename?: 'SystemLabel';
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  it?: Maybe<Scalars['String']['output']>;
};

export type TeamAnswer = {
  __typename?: 'TeamAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_team_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  team_question?: Maybe<TeamQuestion>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamQuestion = {
  __typename?: 'TeamQuestion';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  multiple_selection?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  other_title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tooltip_info?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamRole = {
  __typename?: 'TeamRole';
  controls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  event?: Maybe<Event>;
  id: Scalars['ID']['output'];
  role_name?: Maybe<Scalars['String']['output']>;
};

export type Temperature = {
  __typename?: 'Temperature';
  alt_temperature?: Maybe<Scalars['Float']['output']>;
  build_date?: Maybe<Scalars['DateTime']['output']>;
  current?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  event_resource?: Maybe<EventResource>;
  forecast?: Maybe<Scalars['String']['output']>;
  humidity?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_weatherunderground?: Maybe<Scalars['Boolean']['output']>;
  is_wgbt?: Maybe<Scalars['Boolean']['output']>;
  json?: Maybe<Scalars['JSON']['output']>;
  temperature_celsius?: Maybe<Scalars['Float']['output']>;
  temperature_fahrenheit?: Maybe<Scalars['Float']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TokenVerificationResult = {
  __typename?: 'TokenVerificationResult';
  is_user_authenticated: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  encounter_disposition?: Maybe<EncounterDisposition>;
  event?: Maybe<Event>;
  event_activity?: Maybe<EventActivity>;
  event_participant?: Maybe<EventParticipant>;
  event_resource?: Maybe<EventResource>;
  event_subresource?: Maybe<EventSubresource>;
  event_team?: Maybe<EventTeam>;
  event_tracking_status?: Maybe<EventTrackingStatus>;
  event_transport?: Maybe<EventTransport>;
  event_transport_id?: Maybe<Scalars['ID']['output']>;
  has_checkin?: Maybe<Scalars['Boolean']['output']>;
  has_checkout?: Maybe<Scalars['Boolean']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_athlete_record?: Maybe<Scalars['Boolean']['output']>;
  is_check_in?: Maybe<Scalars['Boolean']['output']>;
  is_check_out?: Maybe<Scalars['Boolean']['output']>;
  is_disposition?: Maybe<Scalars['Boolean']['output']>;
  is_minorassist?: Maybe<Scalars['Boolean']['output']>;
  is_spot?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_name?: Maybe<Scalars['String']['output']>;
  status_trigger_id?: Maybe<Scalars['ID']['output']>;
  tracking_history?: Maybe<Array<Maybe<TrackingHistory>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TrackingDashboardCount = {
  __typename?: 'TrackingDashboardCount';
  active?: Maybe<Scalars['Int']['output']>;
  minor?: Maybe<Scalars['Int']['output']>;
  resolved?: Maybe<Scalars['Int']['output']>;
  statusCounts?: Maybe<Scalars['JSON']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  transport?: Maybe<Scalars['Int']['output']>;
};

export type TrackingDashboardCounts = {
  __typename?: 'TrackingDashboardCounts';
  active_gray?: Maybe<Scalars['Int']['output']>;
  active_green?: Maybe<Scalars['Int']['output']>;
  active_red?: Maybe<Scalars['Int']['output']>;
  active_total?: Maybe<Scalars['Int']['output']>;
  active_yellow?: Maybe<Scalars['Int']['output']>;
  activity_id?: Maybe<Scalars['ID']['output']>;
  counts?: Maybe<TrackingDashboardCount>;
  id: Scalars['ID']['output'];
  minor?: Maybe<Scalars['Int']['output']>;
  resolved?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  transport?: Maybe<Scalars['Int']['output']>;
};

export type TrackingHistory = {
  __typename?: 'TrackingHistory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  disposition_name?: Maybe<Scalars['String']['output']>;
  encounter_disposition?: Maybe<EncounterDisposition>;
  encounter_spot_data?: Maybe<EncounterSpotData>;
  event?: Maybe<Event>;
  event_activity?: Maybe<EventActivity>;
  event_participant?: Maybe<EventParticipant>;
  event_resource?: Maybe<EventResource>;
  event_subresource?: Maybe<EventSubresource>;
  event_team?: Maybe<EventTeam>;
  event_tracking_status?: Maybe<EventTrackingStatus>;
  event_transport_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_name?: Maybe<Scalars['String']['output']>;
  status_trigger?: Maybe<StatusTrigger>;
  tracking?: Maybe<Tracking>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updater?: Maybe<User>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type User = {
  __typename?: 'User';
  children: Array<User>;
  content_user_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  email_address: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_super_admin?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  parent_user_id?: Maybe<Scalars['ID']['output']>;
  password_wrong_count?: Maybe<Scalars['Int']['output']>;
  profile?: Maybe<UserProfile>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_allergies: Array<UserAllergy>;
  user_conditions: Array<UserCondition>;
  user_medications: Array<UserMedication>;
  username: Scalars['String']['output'];
};

export type UserAllergy = {
  __typename?: 'UserAllergy';
  allergy?: Maybe<Allergy>;
  allergy_id?: Maybe<Scalars['ID']['output']>;
  clinical_status?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onset_age?: Maybe<Scalars['String']['output']>;
  onset_date_time?: Maybe<Scalars['DateTime']['output']>;
  onset_period?: Maybe<Scalars['String']['output']>;
  onset_range?: Maybe<Scalars['String']['output']>;
  onset_string?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserCondition = {
  __typename?: 'UserCondition';
  abatement_date_time?: Maybe<Scalars['DateTime']['output']>;
  bodysite_id?: Maybe<Scalars['ID']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  clinical_status?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  condition_id?: Maybe<Scalars['ID']['output']>;
  condition_type_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  onset_date_time?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  verification_status?: Maybe<Scalars['String']['output']>;
};

export type UserMedication = {
  __typename?: 'UserMedication';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  doseunit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  activation_date?: Maybe<Scalars['String']['output']>;
  address_line1?: Maybe<Scalars['String']['output']>;
  address_line2?: Maybe<Scalars['String']['output']>;
  alternate_phone_number?: Maybe<Scalars['String']['output']>;
  birth_date?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Scalars['String']['output']>;
  confirmation_code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  deidentified?: Maybe<Scalars['Boolean']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email_about_other_products?: Maybe<Scalars['Boolean']['output']>;
  fixed_age?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gender_identity?: Maybe<Scalars['String']['output']>;
  height_inches?: Maybe<Scalars['Int']['output']>;
  hipaa_authorized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_center_user?: Maybe<Scalars['Boolean']['output']>;
  is_event_user?: Maybe<Scalars['Boolean']['output']>;
  is_med_team?: Maybe<Scalars['Boolean']['output']>;
  is_race_safe_app_user?: Maybe<Scalars['Boolean']['output']>;
  is_waiver_agreement_consented?: Maybe<Scalars['Boolean']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  measurement_unit?: Maybe<Scalars['String']['output']>;
  medical_background?: Maybe<Scalars['String']['output']>;
  mobile_carrier?: Maybe<Scalars['String']['output']>;
  mobile_type?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  primary_cellphone_number?: Maybe<Scalars['String']['output']>;
  primary_contact_email?: Maybe<Scalars['String']['output']>;
  primary_contact_first_name?: Maybe<Scalars['String']['output']>;
  primary_contact_last_name?: Maybe<Scalars['String']['output']>;
  primary_contact_phone?: Maybe<Scalars['String']['output']>;
  primary_contact_relationship?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  secondary_contact_email?: Maybe<Scalars['String']['output']>;
  secondary_contact_first_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_last_name?: Maybe<Scalars['String']['output']>;
  secondary_contact_phone?: Maybe<Scalars['String']['output']>;
  secondary_contact_relationship?: Maybe<Scalars['String']['output']>;
  show_in_engage_listing?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_temperature_unit?: Maybe<Scalars['String']['output']>;
  user_timezone?: Maybe<Scalars['String']['output']>;
  user_uses_24_clock?: Maybe<Scalars['Boolean']['output']>;
  user_uses_metric_system?: Maybe<Scalars['Boolean']['output']>;
  weight_lbs?: Maybe<Scalars['Int']['output']>;
};

export type AmrEncounterFragment = { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null, server_received_at?: string | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, label?: string | null, category?: ActivityCategory | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', full_name: string } | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, serialized_data?: string | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string } | null> | null };

export type EventTeamFragment = { __typename?: 'EventTeam', id: string, event?: { __typename?: 'Event', id: string, name: string } | null, user?: { __typename?: 'User', is_super_admin?: boolean | null } | null, team_role?: { __typename?: 'TeamRole', id: string, role_name?: string | null, controls?: Array<string | null> | null } | null };

export type PaginatorInfoFragment = { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number, total: number };

export type PickEventFragment = { __typename?: 'Event', name: string, id: string, participant_description?: string | null, team_description?: string | null, logo?: string | null, subevent_select_behavior?: string | null, subevents: Array<{ __typename?: 'Event', id: string, name: string, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }> }>, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }>, encounterCallActions: Array<{ __typename?: 'EncounterCallAction', name?: string | null, encounterTypePhoneNumbers: Array<{ __typename?: 'EncounterTypePhoneNumber', id: string }> }>, encounterDispositionTypes: Array<{ __typename?: 'EncounterDispositionType', name?: string | null }>, event_tracking_statuses: Array<{ __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null, is_private?: boolean | null, sort_order?: number | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, participantQuestions: Array<{ __typename?: 'ParticipantQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }> };

export type SearchParticipantFragment = { __typename?: 'EventParticipant', id: string, last_name?: string | null, first_name?: string | null, full_name?: string | null, age?: string | null, gender_short?: string | null, birth_date?: string | null, identifier_number?: string | null, email_address?: string | null, gender?: string | null, pronoun?: string | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, event?: { __typename?: 'Event', id: string, name: string } | null };

export type SpotEncounterFragment = { __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null, created_at?: Date | null, updated_at?: Date | null, created_by_user?: { __typename?: 'User', full_name: string } | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, category?: ActivityCategory | null } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, default_nearest_station?: boolean | null, dont_relate_events?: boolean | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, latitude?: number | null, longitude?: number | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, parent_encounter_id?: string | null, message?: string | null, contact_phone?: string | null, contact_email?: string | null, created_at?: Date | null, encounter_call_action?: { __typename?: 'EncounterCallAction', name?: string | null, updated_at?: Date | null } | null, event_button_data?: Array<{ __typename?: 'EventButtonData', id?: string | null, created_at?: Date | null, event_button?: { __typename?: 'EventButton', id: string, label?: string | null } | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_button_freetext_data?: Array<{ __typename?: 'EventButtonFreetextData', id?: string | null, freetext?: string | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_bodypart_data?: Array<{ __typename?: 'EventBodyPartData', id?: string | null, body?: string | null, part?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_labs_data?: Array<{ __typename?: 'EventLabsData', id?: string | null, saturation?: string | null, sodium?: string | null, glucose?: string | null, note?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_vitalsigns_data?: Array<{ __typename?: 'EventVitalSignsData', id?: string | null, temperature?: string | null, pulse?: string | null, breathing?: string | null, systole?: string | null, diastole?: string | null, note?: string | null, blood_pressure?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_medicationgiven_data?: Array<{ __typename?: 'EventMedicationGivenData', id?: string | null, medication?: string | null, directions?: string | null, strength?: string | null, doseunit?: string | null, note?: string | null, route?: string | null, status?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string, note?: string | null, care_provider?: string | null, is_cancel_transport?: boolean | null, diagnosis?: string | null, admit_at?: string | null, discharge_at?: string | null, parent_encounter_id?: string | null, created_at?: Date | null, local_time?: Date | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null, transport_disposition?: boolean | null, is_mobile_activity?: boolean | null, is_sagbus_activity?: boolean | null } | null, event_transport?: { __typename?: 'EventTransport', event_hospital?: { __typename?: 'EventHospital', name?: string | null } | null } | null } | null> | null, event_research_question_data?: Array<{ __typename?: 'EventResearchQuestionData', id: string, encounter_spot_data_id?: string | null, research_question_type?: string | null, research_question_title?: string | null, research_question_answer?: string | null, created_at?: Date | null } | null> | null, latest_encounter_disposition?: { __typename?: 'EncounterDisposition', id: string, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null, tracking?: { __typename?: 'Tracking', status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', label?: string | null, color?: string | null } | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null };

export type UserFragment = { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> };

export type UpdateEventTeamByAdminMutationVariables = Exact<{
  volunteer_hash: Scalars['String']['input'];
  event_team_id: Scalars['ID']['input'];
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  delegation?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['String']['input']>;
  volunteer_other_events?: InputMaybe<Scalars['Boolean']['input']>;
  can_be_moved?: InputMaybe<Scalars['Boolean']['input']>;
  volunteer_notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventTeamByAdminMutation = { __typename?: 'Mutation', updateEventTeamByAdmin?: { __typename?: 'EventTeam', id: string, background?: string | null, background_with_fallback?: string | null } | null };

export type UpdateEventTeamDetailsMutationVariables = Exact<{
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  custom?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  delegation?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['String']['input']>;
  volunteer_other_events?: InputMaybe<Scalars['Boolean']['input']>;
  can_be_moved?: InputMaybe<Scalars['Boolean']['input']>;
  volunteer_notes?: InputMaybe<Scalars['String']['input']>;
  volunteer_hash: Scalars['String']['input'];
  event_team_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateEventTeamDetailsMutation = { __typename?: 'Mutation', updateEventTeamDetails?: { __typename?: 'EventTeam', id: string } | null };

export type UpdateEventTeamProfileMutationVariables = Exact<{
  gender?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  subscribe_to_products_services?: InputMaybe<Scalars['Boolean']['input']>;
  medical_background?: InputMaybe<Scalars['String']['input']>;
  med_licence_number?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  terms_and_conditions: Scalars['Boolean']['input'];
  volunteer_hash: Scalars['String']['input'];
}>;


export type UpdateEventTeamProfileMutation = { __typename?: 'Mutation', updateEventTeamProfile?: Array<{ __typename?: 'EventTeam', id: string } | null> | null };

export type UpdateProfileMutationVariables = Exact<{
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['ID']['input'];
  birth_date?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_identity?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  email_about_other_products?: InputMaybe<Scalars['Boolean']['input']>;
  medical_background?: InputMaybe<Scalars['String']['input']>;
  med_licence_number?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  is_waiver_agreement_consented?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string } | null };

export type AssignEventTeamsToEventResourceMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_resource_id: Scalars['ID']['input'];
  event_team_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AssignEventTeamsToEventResourceMutation = { __typename?: 'Mutation', assignEventTeamsToEventResource?: Array<{ __typename?: 'EventTeam', id: string } | null> | null };

export type CancelTransportMutationVariables = Exact<{
  encounter_disposition_id: Scalars['ID']['input'];
}>;


export type CancelTransportMutation = { __typename?: 'Mutation', cancelTransport?: { __typename?: 'EncounterDisposition', id: string } | null };

export type ChangeEncounterRecordMutationVariables = Exact<{
  encounter_id: Scalars['ID']['input'];
  encounter_changes?: InputMaybe<EncounterChangesInput>;
  disposition_changes?: InputMaybe<Array<DispositionChangesInput> | DispositionChangesInput>;
}>;


export type ChangeEncounterRecordMutation = { __typename?: 'Mutation', changeEncounterRecord?: { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null, server_received_at?: string | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, label?: string | null, category?: ActivityCategory | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', full_name: string } | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, serialized_data?: string | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string } | null> | null } | null };

export type CloseRecordMutationVariables = Exact<{
  encounter_id: Scalars['ID']['input'];
  participant_id: Scalars['ID']['input'];
}>;


export type CloseRecordMutation = { __typename?: 'Mutation', closeRecord?: { __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null } | null };

export type CreateChildMutationVariables = Exact<{
  parent_id: Scalars['ID']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  date_of_birth: Scalars['Date']['input'];
}>;


export type CreateChildMutation = { __typename?: 'Mutation', createChild?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null };

export type CreateEventParticipantMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  longitude: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['Date']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEventParticipantMutation = { __typename?: 'Mutation', createEventParticipant?: { __typename?: 'EventParticipant', id: string, last_name?: string | null, first_name?: string | null, full_name?: string | null, age?: string | null, gender_short?: string | null, birth_date?: string | null, identifier_number?: string | null, email_address?: string | null, gender?: string | null, pronoun?: string | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null };

export type ExportEventTeamListMutationVariables = Exact<{
  volunteer_hash: Scalars['String']['input'];
}>;


export type ExportEventTeamListMutation = { __typename?: 'Mutation', exportEventTeamList?: Array<{ __typename?: 'EventTeam', id: string, is_volunteer_other_events?: boolean | null, has_exercises_manager_enabled?: boolean | null, has_cards_creation_enabled?: boolean | null, show_in_engage_listing?: boolean | null, has_health_check_enabled?: boolean | null, health_check_level?: string | null, location_status?: string | null, location_status_color?: string | null, wizard_complete?: boolean | null, sports?: string | null, delegation?: string | null, role?: string | null, country?: string | null, background?: string | null, background_with_fallback?: string | null, phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, mobile_phone_type?: string | null, has_mobile_phone?: boolean | null, volunteer_notes?: string | null, volunteer_assignment_info?: string | null, can_be_moved?: boolean | null, racesafe_status?: string | null, racesafe_status_label?: string | null, racesafe_status_decoded?: string | null, experience?: string | null, agreement?: boolean | null, authorization_level?: string | null, last_latitude?: number | null, last_longitude?: number | null, groupname?: string | null, code?: string | null, head_of_delegation?: string | null, chaperon?: string | null, is_own_guardian?: boolean | null, deidentified?: boolean | null, event?: { __typename?: 'Event', name: string, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }> } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, assignment_time?: string | null } | null, team_role?: { __typename?: 'TeamRole', id: string, role_name?: string | null } | null, event_team_answers?: Array<{ __typename?: 'TeamAnswer', id: string, answer?: string | null, team_question?: { __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null } | null } | null> | null, event_team_group_preference?: { __typename?: 'EventTeamGroup', id: string, name?: string | null } | null, event_resource_preference?: { __typename?: 'EventResource', id: string, name?: string | null } | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string, email_address: string, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null } | null } | null> | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'ForgotPasswordPayload', status?: boolean | null, message?: string | null } | null };

export type GenerateIdentifierNumberMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
}>;


export type GenerateIdentifierNumberMutation = { __typename?: 'Mutation', generateIdentifierNumber?: string | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', token?: string | null, user?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null } };

export type MakeCallMutationVariables = Exact<{
  encounter_call_action_id: Scalars['ID']['input'];
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeCallMutation = { __typename?: 'Mutation', makeCall?: { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null } | null };

export type MoveParticipantDataMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  from_participant: Scalars['ID']['input'];
  to_participant: Scalars['String']['input'];
  to_participant_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveParticipantDataMutation = { __typename?: 'Mutation', moveParticipantData?: { __typename?: 'EventParticipant', id: string, last_name?: string | null, first_name?: string | null, full_name?: string | null, age?: string | null, gender_short?: string | null, birth_date?: string | null, identifier_number?: string | null, email_address?: string | null, gender?: string | null, pronoun?: string | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null };

export type NotifyContactMutationVariables = Exact<{
  encounter_call_action_id: Scalars['ID']['input'];
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotifyContactMutation = { __typename?: 'Mutation', notifyContact?: { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null } | null };

export type OpenRecordMutationVariables = Exact<{
  encounter_id: Scalars['ID']['input'];
  participant_id: Scalars['ID']['input'];
}>;


export type OpenRecordMutation = { __typename?: 'Mutation', openRecord?: { __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null } | null };

export type RecordSpotMutationVariables = Exact<{
  data?: InputMaybe<Scalars['JSON']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  event_id: Scalars['ID']['input'];
  event_participant_id?: InputMaybe<Scalars['ID']['input']>;
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  old_visit?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordSpotMutation = { __typename?: 'Mutation', recordSpot?: { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null, server_received_at?: string | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, label?: string | null, category?: ActivityCategory | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', full_name: string } | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, serialized_data?: string | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string } | null> | null } | null };

export type RecordSpotDispositionMutationVariables = Exact<{
  identifier_number?: InputMaybe<Scalars['String']['input']>;
  event_id: Scalars['ID']['input'];
  event_action_id?: InputMaybe<Scalars['ID']['input']>;
  event_participant_id: Scalars['ID']['input'];
  event_activity_id?: InputMaybe<Scalars['ID']['input']>;
  encounter_id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  resource_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  encounter_disposition_type_id?: InputMaybe<Scalars['ID']['input']>;
  event_tracking_status_id?: InputMaybe<Scalars['ID']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reported_by?: InputMaybe<Scalars['String']['input']>;
  care_provider?: InputMaybe<Scalars['String']['input']>;
  mobile_resource_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RecordSpotDispositionMutation = { __typename?: 'Mutation', recordSpotDisposition?: { __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null, server_received_at?: string | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, label?: string | null, category?: ActivityCategory | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', full_name: string } | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, serialized_data?: string | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string } | null> | null } | null };

export type RecordWbgtMutationVariables = Exact<{
  volunteer_hash: Scalars['String']['input'];
  temperature: Scalars['Float']['input'];
  scale: Scalars['String']['input'];
  event_resource_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RecordWbgtMutation = { __typename?: 'Mutation', recordWbgt: { __typename?: 'Temperature', id: string, build_date?: Date | null, value?: number | null, is_wgbt?: boolean | null, humidity?: number | null, temperature_fahrenheit?: number | null, temperature_celsius?: number | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null } | null } };

export type RegisterEventParticipantMutationVariables = Exact<{
  event_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RegisterEventParticipantMutation = { __typename?: 'Mutation', registerEventParticipant?: Array<{ __typename?: 'EventParticipant', id: string, user?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null } | null> | null };

export type RegisterEventTeamMutationVariables = Exact<{
  event_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RegisterEventTeamMutation = { __typename?: 'Mutation', registerEventTeam?: Array<{ __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null } | null> | null };

export type Resend2FaCodeMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
}>;


export type Resend2FaCodeMutation = { __typename?: 'Mutation', resend2FACode: { __typename?: 'Resend2FACodePayload', status: boolean, message: string, retry_after_seconds?: number | null } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ForgotPasswordPayload', status?: boolean | null, message?: string | null } | null };

export type SearchParticipantsMutationVariables = Exact<{
  query: Scalars['String']['input'];
  event_id: Scalars['ID']['input'];
  only_subevent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchParticipantsMutation = { __typename?: 'Mutation', searchParticipantsByQuery: { __typename?: 'SearchResult', empty_due_permissions?: boolean | null, participants?: Array<{ __typename?: 'EventParticipant', id: string, last_name?: string | null, first_name?: string | null, full_name?: string | null, age?: string | null, gender_short?: string | null, birth_date?: string | null, identifier_number?: string | null, email_address?: string | null, gender?: string | null, pronoun?: string | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null> | null } };

export type SendPushNotificationMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  title: Scalars['String']['input'];
  message: Scalars['String']['input'];
  event_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SendPushNotificationMutation = { __typename?: 'Mutation', sendPushNotification: { __typename?: 'PushNotificationResponse', success: boolean, message: string } };

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  dob: Scalars['String']['input'];
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'AuthPayload', token?: string | null, user?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null } };

export type SubmitSmsNotificationConsentMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  is_consent: Scalars['Boolean']['input'];
}>;


export type SubmitSmsNotificationConsentMutation = { __typename?: 'Mutation', submitSmsNotificationConsent?: { __typename?: 'SmsNotificationConsent', id: string, name?: string | null, phone_number?: string | null, phone_normalized?: string | null, is_consent?: boolean | null, consented_at?: Date | null, created_at?: Date | null, master_event?: { __typename?: 'Event', id: string, name: string } | null, submitted_event?: { __typename?: 'Event', id: string, name: string } | null } | null };

export type UnassignEventTeamFromEventResourceMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_team_id: Scalars['ID']['input'];
}>;


export type UnassignEventTeamFromEventResourceMutation = { __typename?: 'Mutation', unassignEventTeamFromEventResource?: { __typename?: 'EventTeam', id: string, event_resource?: { __typename?: 'EventResource', id: string } | null } | null };

export type UnassignEventTeamsFromEventResourceMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_team_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnassignEventTeamsFromEventResourceMutation = { __typename?: 'Mutation', unassignEventTeamsFromEventResource?: Array<{ __typename?: 'EventTeam', id: string, event_resource?: { __typename?: 'EventResource', id: string } | null } | null> | null };

export type UpdateEventParticipantDetailsMutationVariables = Exact<{
  termsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  participant_hash: Scalars['String']['input'];
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  primary_contact_first_name?: InputMaybe<Scalars['String']['input']>;
  primary_contact_last_name?: InputMaybe<Scalars['String']['input']>;
  primary_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  primary_contact_phone?: InputMaybe<Scalars['String']['input']>;
  primary_contact_email?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_first_name?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_last_name?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_phone?: InputMaybe<Scalars['String']['input']>;
  secondary_contact_email?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventParticipantDetailsMutation = { __typename?: 'Mutation', updateEventParticipantDetails?: Array<{ __typename?: 'EventParticipant', id: string } | null> | null };

export type UpdateParticipantStatusMutationVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  event_tracking_status_id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateParticipantStatusMutation = { __typename?: 'Mutation', updateParticipantStatus?: { __typename?: 'Tracking', id: string, status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', color?: string | null, id: string, label?: string | null, font_color?: string | null, is_private?: boolean | null } | null } | null };

export type UpdateTransportMutationVariables = Exact<{
  encounter_disposition_id: Scalars['ID']['input'];
  admission_date?: InputMaybe<Scalars['Date']['input']>;
  discharge_date?: InputMaybe<Scalars['Date']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTransportMutation = { __typename?: 'Mutation', updateTransport?: { __typename?: 'EncounterDisposition', id: string, diagnosis?: string | null, note?: string | null } | null };

export type UploadEventParticipantFilesMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
}>;


export type UploadEventParticipantFilesMutation = { __typename?: 'Mutation', uploadEventParticipantFiles?: { __typename?: 'FileDetails', temporaryUrl?: string | null, name?: string | null, metadata?: Array<{ __typename?: 'FileMetadata', key?: string | null, value?: string | null } | null> | null } | null };

export type Verify2FaMutationVariables = Exact<{
  code: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
}>;


export type Verify2FaMutation = { __typename?: 'Mutation', verify2FA: { __typename?: 'AuthPayload', token?: string | null, user?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null } };

export type EventQueryVariables = Exact<{
  volunteer_hash?: InputMaybe<Scalars['String']['input']>;
  participant_hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventQuery = { __typename?: 'Query', fetchEvent?: { __typename?: 'Event', date_display?: string | null, date_start?: any | null, date_end?: any | null, state?: string | null, name: string, id: string, participant_description?: string | null, team_description?: string | null, logo?: string | null, subevent_select_behavior?: string | null, subevents: Array<{ __typename?: 'Event', id: string, name: string, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }> }>, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }>, encounterCallActions: Array<{ __typename?: 'EncounterCallAction', name?: string | null, encounterTypePhoneNumbers: Array<{ __typename?: 'EncounterTypePhoneNumber', id: string }> }>, encounterDispositionTypes: Array<{ __typename?: 'EncounterDispositionType', name?: string | null }>, event_tracking_statuses: Array<{ __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null, is_private?: boolean | null, sort_order?: number | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, participantQuestions: Array<{ __typename?: 'ParticipantQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }> } | null };

export type EventContentsQueryVariables = Exact<{
  participant_hash: Scalars['String']['input'];
}>;


export type EventContentsQuery = { __typename?: 'Query', eventContents: Array<{ __typename?: 'EventContent', id: string, copy?: string | null, image?: string | null, url?: string | null, event?: { __typename?: 'Event', id: string, name: string, logo?: string | null } | null }> };

export type EventRegistrationFieldOptionsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type EventRegistrationFieldOptionsQuery = { __typename?: 'Query', eventRegistrationFieldOptions: { __typename?: 'EventRegistrationFieldOptions', roles: Array<string>, delegations: Array<string>, sports: Array<string>, countries: Array<string> } };

export type EventWithHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventWithHashQuery = { __typename?: 'Query', fetchEventWithHash?: { __typename?: 'Event', name: string, id: string, participant_description?: string | null, team_description?: string | null, logo?: string | null, subevent_select_behavior?: string | null, subevents: Array<{ __typename?: 'Event', id: string, name: string, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }> }>, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }>, encounterCallActions: Array<{ __typename?: 'EncounterCallAction', name?: string | null, encounterTypePhoneNumbers: Array<{ __typename?: 'EncounterTypePhoneNumber', id: string }> }>, encounterDispositionTypes: Array<{ __typename?: 'EncounterDispositionType', name?: string | null }>, event_tracking_statuses: Array<{ __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null, is_private?: boolean | null, sort_order?: number | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, participantQuestions: Array<{ __typename?: 'ParticipantQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }> } | null };

export type EventsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type EventsQuery = { __typename?: 'Query', events: { __typename?: 'EventPaginator', data: Array<{ __typename?: 'Event', id: string, name: string, slug?: string | null, longitude?: number | null, latitude?: number | null, time_zone?: string | null, temperature_unit?: string | null, state?: string | null, logo?: string | null, is_active_app?: boolean | null, is_active_command?: boolean | null, is_highschool?: boolean | null, is_master?: boolean | null, is_private?: boolean | null, is_subevent?: boolean | null, is_volunteer_shared?: boolean | null, has_triage_feature?: boolean | null, has_wgbt?: boolean | null, hospital_list?: string | null, has_barcode?: boolean | null, has_chat_feature?: boolean | null, has_deidentified_data?: boolean | null, has_health_illness_button?: boolean | null, has_opinion_questionnaire?: boolean | null, google_analytics_code?: string | null, country?: string | null, allow_user_location?: boolean | null, barcode_query_string?: string | null, button_triage_delayed?: string | null, button_triage_immediate?: string | null, button_triage_minor?: string | null, parent_event_id?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, hasMorePages: boolean, lastPage: number, total: number } } };

export type FetchEventQueryVariables = Exact<{
  volunteer_hash?: InputMaybe<Scalars['String']['input']>;
  participant_hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchEventQuery = { __typename?: 'Query', fetchEvent?: { __typename?: 'Event', name: string, id: string, participant_description?: string | null, team_description?: string | null, logo?: string | null } | null };

export type FetchParticipantStatusQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
}>;


export type FetchParticipantStatusQuery = { __typename?: 'Query', fetchParticipantStatus?: { __typename?: 'Tracking', id: string, status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', color?: string | null, id: string, label?: string | null, font_color?: string | null, is_private?: boolean | null } | null } | null };

export type FindEventParticipantQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type FindEventParticipantQuery = { __typename?: 'Query', findEventParticipant?: { __typename?: 'EventParticipant', id: string, user?: { __typename?: 'User', full_name: string } | null, event?: { __typename?: 'Event', name: string, id: string } | null, participant_allergies?: Array<{ __typename?: 'ParticipantAllergy', id: string, allergy_id?: string | null } | null> | null, participant_medications?: Array<{ __typename?: 'ParticipantMedication', id: string, name?: string | null, note?: string | null, doseunit?: string | null, directions?: string | null } | null> | null, participant_conditions?: Array<{ __typename?: 'ParticipantCondition', id: string, name?: string | null } | null> | null, master_encounters?: Array<{ __typename?: 'Encounter', id?: string | null, created_at?: Date | null, updated_at?: Date | null, server_received_at?: string | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, label?: string | null, category?: ActivityCategory | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', full_name: string } | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, serialized_data?: string | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string } | null> | null } | null> | null } | null };

export type FindEventParticipantFilesQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  event_participant_id: Scalars['ID']['input'];
}>;


export type FindEventParticipantFilesQuery = { __typename?: 'Query', findEventParticipantFiles?: Array<{ __typename?: 'FileDetails', temporaryUrl?: string | null, uploadedAt?: string | null, type?: string | null, name?: string | null, metadata?: Array<{ __typename?: 'FileMetadata', key?: string | null, value?: string | null } | null> | null } | null> | null };

export type FindTeamNearestResourceQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type FindTeamNearestResourceQuery = { __typename?: 'Query', findTeamNearestResource?: { __typename?: 'NearestResourceResult', status?: string | null, same_resource?: boolean | null, nearest_resource?: { __typename?: 'EventResource', id: string, name?: string | null } | null, assigned_resource?: { __typename?: 'EventResource', id: string, name?: string | null } | null, team_role?: { __typename?: 'TeamRole', controls?: Array<string | null> | null, role_name?: string | null } | null } | null };

export type GetAmrDataQueryVariables = Exact<{
  event_participant_id: Scalars['ID']['input'];
}>;


export type GetAmrDataQuery = { __typename?: 'Query', getAMRData?: { __typename?: 'AMRData', event_participant?: { __typename?: 'EventParticipant', id: string, full_name?: string | null, profile_photo?: string | null, identifier_number?: string | null, is_offline_mode?: boolean | null, offline_sync_status?: OfflineSyncStatus | null, offline_context?: any | null, birth_date?: string | null, age?: string | null, height_formatted?: string | null, weight_lbs?: string | null, gender?: string | null, primary_cellphone_number?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null, sports?: string | null, delegation?: string | null, role?: string | null, user?: { __typename?: 'User', full_name: string, profile?: { __typename?: 'UserProfile', profile_picture?: string | null, gender?: string | null, birth_date?: string | null } | null } | null, event?: { __typename?: 'Event', id: string, name: string, language?: Array<string | null> | null, default_sms_email_message?: string | null, show_event_research_question_on_open_spot?: boolean | null, has_opinion_questionnaire?: boolean | null, event_research_questions: Array<{ __typename?: 'EventResearchQuestion', id: string, form_name?: string | null, event_button_group_id?: string | null, options_source?: string | null, trigger_type?: string | null, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, type?: string | null, mandatory?: boolean | null, multiple_choice?: boolean | null, has_other_option?: boolean | null, is_active?: boolean | null, show_in_amr?: boolean | null, sort_order?: number | null, eventButtonGroup?: { __typename?: 'EventButtonGroup', id: string, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, code?: string | null, image_url?: string | null, image_url_signed?: string | null, sort_order?: number | null, has_negative?: boolean | null }> } | null }>, event_tracking_statuses: Array<{ __typename?: 'EventTrackingStatus', id: string, is_private?: boolean | null, label?: string | null, color?: string | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, research_form_name?: string | null, image_url?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, event_forms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }>, participantQuestions: Array<{ __typename?: 'ParticipantQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, event_resources: Array<{ __typename?: 'EventResource', id: string, name?: string | null, default_nearest_station?: boolean | null, dont_relate_events?: boolean | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, longitude?: number | null, latitude?: number | null }>, event_hospitals: Array<{ __typename?: 'EventHospital', id: string, name?: string | null }>, encounterDispositionTypes: Array<{ __typename?: 'EncounterDispositionType', id: string, name?: string | null, is_mobile_activity?: boolean | null, is_sagbus_activity?: boolean | null, protocol?: string | null, eventTrackingStatus?: { __typename?: 'EventTrackingStatus', id: string, is_private?: boolean | null, label?: string | null, color?: string | null, font_color?: string | null } | null }>, encounterCallActions: Array<{ __typename?: 'EncounterCallAction', id: string, name?: string | null, action_type?: string | null, use_emergency_info_flag?: boolean | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null } | null, encounterTypePhoneNumbers: Array<{ __typename?: 'EncounterTypePhoneNumber', id: string, name?: string | null, phone_number?: string | null }> }> } | null, participant_allergies?: Array<{ __typename?: 'ParticipantAllergy', id: string, name?: string | null, type?: string | null, note?: string | null } | null> | null, participant_medications?: Array<{ __typename?: 'ParticipantMedication', id: string, name?: string | null, directions?: string | null, note?: string | null } | null> | null, participant_conditions?: Array<{ __typename?: 'ParticipantCondition', id: string, name?: string | null, note?: string | null } | null> | null, participant_answers?: Array<{ __typename?: 'ParticipantAnswer', id: string, answer?: string | null, participant_question?: { __typename?: 'ParticipantQuestion', id: string, title?: string | null } | null } | null> | null, master_encounters?: Array<{ __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null, created_at?: Date | null, updated_at?: Date | null, parent?: { __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null, created_at?: Date | null, updated_at?: Date | null, created_by_user?: { __typename?: 'User', full_name: string } | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, category?: ActivityCategory | null } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, default_nearest_station?: boolean | null, dont_relate_events?: boolean | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, latitude?: number | null, longitude?: number | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, parent_encounter_id?: string | null, message?: string | null, contact_phone?: string | null, contact_email?: string | null, created_at?: Date | null, encounter_call_action?: { __typename?: 'EncounterCallAction', name?: string | null, updated_at?: Date | null } | null, event_button_data?: Array<{ __typename?: 'EventButtonData', id?: string | null, created_at?: Date | null, event_button?: { __typename?: 'EventButton', id: string, label?: string | null } | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_button_freetext_data?: Array<{ __typename?: 'EventButtonFreetextData', id?: string | null, freetext?: string | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_bodypart_data?: Array<{ __typename?: 'EventBodyPartData', id?: string | null, body?: string | null, part?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_labs_data?: Array<{ __typename?: 'EventLabsData', id?: string | null, saturation?: string | null, sodium?: string | null, glucose?: string | null, note?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_vitalsigns_data?: Array<{ __typename?: 'EventVitalSignsData', id?: string | null, temperature?: string | null, pulse?: string | null, breathing?: string | null, systole?: string | null, diastole?: string | null, note?: string | null, blood_pressure?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_medicationgiven_data?: Array<{ __typename?: 'EventMedicationGivenData', id?: string | null, medication?: string | null, directions?: string | null, strength?: string | null, doseunit?: string | null, note?: string | null, route?: string | null, status?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string, note?: string | null, care_provider?: string | null, is_cancel_transport?: boolean | null, diagnosis?: string | null, admit_at?: string | null, discharge_at?: string | null, parent_encounter_id?: string | null, created_at?: Date | null, local_time?: Date | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null, transport_disposition?: boolean | null, is_mobile_activity?: boolean | null, is_sagbus_activity?: boolean | null } | null, event_transport?: { __typename?: 'EventTransport', event_hospital?: { __typename?: 'EventHospital', name?: string | null } | null } | null } | null> | null, event_research_question_data?: Array<{ __typename?: 'EventResearchQuestionData', id: string, encounter_spot_data_id?: string | null, research_question_type?: string | null, research_question_title?: string | null, research_question_answer?: string | null, created_at?: Date | null } | null> | null, latest_encounter_disposition?: { __typename?: 'EncounterDisposition', id: string, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null, tracking?: { __typename?: 'Tracking', status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', label?: string | null, color?: string | null } | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null, merged_encounters?: Array<{ __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null, created_at?: Date | null, updated_at?: Date | null, created_by_user?: { __typename?: 'User', full_name: string } | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, category?: ActivityCategory | null } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, default_nearest_station?: boolean | null, dont_relate_events?: boolean | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, latitude?: number | null, longitude?: number | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, parent_encounter_id?: string | null, message?: string | null, contact_phone?: string | null, contact_email?: string | null, created_at?: Date | null, encounter_call_action?: { __typename?: 'EncounterCallAction', name?: string | null, updated_at?: Date | null } | null, event_button_data?: Array<{ __typename?: 'EventButtonData', id?: string | null, created_at?: Date | null, event_button?: { __typename?: 'EventButton', id: string, label?: string | null } | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_button_freetext_data?: Array<{ __typename?: 'EventButtonFreetextData', id?: string | null, freetext?: string | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_bodypart_data?: Array<{ __typename?: 'EventBodyPartData', id?: string | null, body?: string | null, part?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_labs_data?: Array<{ __typename?: 'EventLabsData', id?: string | null, saturation?: string | null, sodium?: string | null, glucose?: string | null, note?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_vitalsigns_data?: Array<{ __typename?: 'EventVitalSignsData', id?: string | null, temperature?: string | null, pulse?: string | null, breathing?: string | null, systole?: string | null, diastole?: string | null, note?: string | null, blood_pressure?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_medicationgiven_data?: Array<{ __typename?: 'EventMedicationGivenData', id?: string | null, medication?: string | null, directions?: string | null, strength?: string | null, doseunit?: string | null, note?: string | null, route?: string | null, status?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string, note?: string | null, care_provider?: string | null, is_cancel_transport?: boolean | null, diagnosis?: string | null, admit_at?: string | null, discharge_at?: string | null, parent_encounter_id?: string | null, created_at?: Date | null, local_time?: Date | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null, transport_disposition?: boolean | null, is_mobile_activity?: boolean | null, is_sagbus_activity?: boolean | null } | null, event_transport?: { __typename?: 'EventTransport', event_hospital?: { __typename?: 'EventHospital', name?: string | null } | null } | null } | null> | null, event_research_question_data?: Array<{ __typename?: 'EventResearchQuestionData', id: string, encounter_spot_data_id?: string | null, research_question_type?: string | null, research_question_title?: string | null, research_question_answer?: string | null, created_at?: Date | null } | null> | null, latest_encounter_disposition?: { __typename?: 'EncounterDisposition', id: string, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null, tracking?: { __typename?: 'Tracking', status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', label?: string | null, color?: string | null } | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null> | null, created_by_user?: { __typename?: 'User', full_name: string } | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, category?: ActivityCategory | null } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, default_nearest_station?: boolean | null, dont_relate_events?: boolean | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, latitude?: number | null, longitude?: number | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, parent_encounter_id?: string | null, message?: string | null, contact_phone?: string | null, contact_email?: string | null, created_at?: Date | null, encounter_call_action?: { __typename?: 'EncounterCallAction', name?: string | null, updated_at?: Date | null } | null, event_button_data?: Array<{ __typename?: 'EventButtonData', id?: string | null, created_at?: Date | null, event_button?: { __typename?: 'EventButton', id: string, label?: string | null } | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_button_freetext_data?: Array<{ __typename?: 'EventButtonFreetextData', id?: string | null, freetext?: string | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_bodypart_data?: Array<{ __typename?: 'EventBodyPartData', id?: string | null, body?: string | null, part?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_labs_data?: Array<{ __typename?: 'EventLabsData', id?: string | null, saturation?: string | null, sodium?: string | null, glucose?: string | null, note?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_vitalsigns_data?: Array<{ __typename?: 'EventVitalSignsData', id?: string | null, temperature?: string | null, pulse?: string | null, breathing?: string | null, systole?: string | null, diastole?: string | null, note?: string | null, blood_pressure?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_medicationgiven_data?: Array<{ __typename?: 'EventMedicationGivenData', id?: string | null, medication?: string | null, directions?: string | null, strength?: string | null, doseunit?: string | null, note?: string | null, route?: string | null, status?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string, note?: string | null, care_provider?: string | null, is_cancel_transport?: boolean | null, diagnosis?: string | null, admit_at?: string | null, discharge_at?: string | null, parent_encounter_id?: string | null, created_at?: Date | null, local_time?: Date | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null, transport_disposition?: boolean | null, is_mobile_activity?: boolean | null, is_sagbus_activity?: boolean | null } | null, event_transport?: { __typename?: 'EventTransport', event_hospital?: { __typename?: 'EventHospital', name?: string | null } | null } | null } | null> | null, event_research_question_data?: Array<{ __typename?: 'EventResearchQuestionData', id: string, encounter_spot_data_id?: string | null, research_question_type?: string | null, research_question_title?: string | null, research_question_answer?: string | null, created_at?: Date | null } | null> | null, latest_encounter_disposition?: { __typename?: 'EncounterDisposition', id: string, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null, tracking?: { __typename?: 'Tracking', status?: string | null, status_name?: string | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', label?: string | null, color?: string | null } | null } | null, event?: { __typename?: 'Event', id: string, name: string } | null } | null> | null } | null } | null };

export type GetCommandStatsQueryVariables = Exact<{
  hash: Scalars['ID']['input'];
}>;


export type GetCommandStatsQuery = { __typename?: 'Query', getCommandStats?: { __typename?: 'CommandStats', activeMedicalIncidents?: any | null, activeMedicalIncidentsByParticipant?: any | null, incidentSummaryByParticipant?: any | null, incidentSummary?: any | null, incidentSummaryByParticipantByDay?: any | null, activeMedicalIncidentsByParticipantByDay?: any | null } | null };

export type GetDataExportQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  physical_findings?: InputMaybe<Scalars['String']['input']>;
  opinion?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Scalars['String']['input']>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  selected_dispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetDataExportQuery = { __typename?: 'Query', getDataExport?: { __typename?: 'DataExport', success?: boolean | null, message?: string | null, filename?: string | null, export_type?: string | null, filters_applied?: any | null, export_download?: string | null, download_url?: string | null, expires_at?: string | null, expires_in_minutes?: number | null } | null };

export type GetEncounterQueryVariables = Exact<{
  encounter_id: Scalars['ID']['input'];
}>;


export type GetEncounterQuery = { __typename?: 'Query', getEncounter?: { __typename?: 'Encounter', id?: string | null, is_resolved?: boolean | null, created_at?: Date | null, updated_at?: Date | null, created_by_user?: { __typename?: 'User', full_name: string } | null, event?: { __typename?: 'Event', id: string, name: string, event_research_questions: Array<{ __typename?: 'EventResearchQuestion', id: string, form_name?: string | null, title?: string | null, is_active?: boolean | null, show_in_amr?: boolean | null, sort_order?: number | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, event_forms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> } | null, event_activity?: { __typename?: 'EventActivity', id: string, name?: string | null, category?: ActivityCategory | null } | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null, encounter_spot_data?: Array<{ __typename?: 'EncounterSpotData', id: string, created_at?: Date | null, encounter_call_action?: { __typename?: 'EncounterCallAction', name?: string | null, updated_at?: Date | null } | null, event_button_data?: Array<{ __typename?: 'EventButtonData', id?: string | null, created_at?: Date | null, event_button?: { __typename?: 'EventButton', id: string, label?: string | null } | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_button_freetext_data?: Array<{ __typename?: 'EventButtonFreetextData', id?: string | null, freetext?: string | null, event_button_group?: { __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null } | null } | null> | null, event_bodypart_data?: Array<{ __typename?: 'EventBodyPartData', id?: string | null, body?: string | null, part?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_labs_data?: Array<{ __typename?: 'EventLabsData', id?: string | null, saturation?: string | null, sodium?: string | null, glucose?: string | null, note?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_vitalsigns_data?: Array<{ __typename?: 'EventVitalSignsData', id?: string | null, temperature?: string | null, pulse?: string | null, breathing?: string | null, systole?: string | null, diastole?: string | null, note?: string | null, blood_pressure?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null, event_medicationgiven_data?: Array<{ __typename?: 'EventMedicationGivenData', id?: string | null, medication?: string | null, directions?: string | null, strength?: string | null, doseunit?: string | null, note?: string | null, route?: string | null, status?: string | null, event_form?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null } | null> | null } | null> | null, event_research_question_data?: Array<{ __typename?: 'EventResearchQuestionData', id: string, encounter_spot_data_id?: string | null, research_question_type?: string | null, research_question_title?: string | null, research_question_answer?: string | null, created_at?: Date | null } | null> | null, encounter_dispositions?: Array<{ __typename?: 'EncounterDisposition', id: string, note?: string | null, care_provider?: string | null, is_cancel_transport?: boolean | null, diagnosis?: string | null, admit_at?: string | null, discharge_at?: string | null, created_at?: Date | null, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null, event_transport?: { __typename?: 'EventTransport', event_hospital?: { __typename?: 'EventHospital', name?: string | null } | null } | null, event_resource?: { __typename?: 'EventResource', name?: string | null } | null } | null> | null, latest_encounter_disposition?: { __typename?: 'EncounterDisposition', id: string, encounter_disposition_type?: { __typename?: 'EncounterDispositionType', name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', id: string, user?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null, event_participant?: { __typename?: 'EventParticipant', id: string, identifier_number?: string | null, birth_date?: string | null, age?: string | null, height_formatted?: string | null, weight_lbs?: string | null, gender?: string | null, primary_cellphone_number?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_phone?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_phone?: string | null, sports?: string | null, delegation?: string | null, role?: string | null, event?: { __typename?: 'Event', id: string } | null, user?: { __typename?: 'User', id: string, full_name: string } | null, participant_allergies?: Array<{ __typename?: 'ParticipantAllergy', id: string, name?: string | null, type?: string | null } | null> | null, participant_medications?: Array<{ __typename?: 'ParticipantMedication', id: string, name?: string | null } | null> | null, participant_conditions?: Array<{ __typename?: 'ParticipantCondition', id: string, name?: string | null } | null> | null, participant_answers?: Array<{ __typename?: 'ParticipantAnswer', id: string, answer?: string | null, participant_question?: { __typename?: 'ParticipantQuestion', id: string, title?: string | null } | null } | null> | null } | null } | null };

export type GetEncounterAuditHistoryQueryVariables = Exact<{
  encounter_id: Scalars['ID']['input'];
}>;


export type GetEncounterAuditHistoryQuery = { __typename?: 'Query', getEncounterAuditHistory: Array<{ __typename?: 'EventAuditLog', id: string, change_id: string, table_name: string, record_pk: string, action: string, actor_id?: string | null, changed: any, enriched_changes?: any | null, ip?: string | null, user_agent?: string | null, created_at: Date, entity_type?: string | null, actor?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string, email_address: string } | null }> };

export type GetEventParticipantDetailsQueryVariables = Exact<{
  participantHash: Scalars['String']['input'];
}>;


export type GetEventParticipantDetailsQuery = { __typename?: 'Query', getEventParticipantDetails?: { __typename?: 'EventParticipant', id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, gender?: string | null, pronoun?: string | null, is_agreement_consented?: boolean | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null, participant_allergies?: Array<{ __typename?: 'ParticipantAllergy', id: string, name?: string | null } | null> | null, participant_medications?: Array<{ __typename?: 'ParticipantMedication', id: string, name?: string | null } | null> | null, participant_conditions?: Array<{ __typename?: 'ParticipantCondition', id: string, name?: string | null } | null> | null, participant_answers?: Array<{ __typename?: 'ParticipantAnswer', id: string, participant_questions_id?: string | null, answer?: string | null } | null> | null, user_medications?: Array<{ __typename?: 'UserMedication', id: string, name?: string | null } | null> | null, user_allergies?: Array<{ __typename?: 'Allergy', id: string, name?: string | null } | null> | null, user_conditions?: Array<{ __typename?: 'Condition', id: string, name?: string | null } | null> | null } | null };

export type GetGenerateIdentifierNumberQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
}>;


export type GetGenerateIdentifierNumberQuery = { __typename?: 'Query', generateIdentifierNumber?: string | null };

export type GetHostConfigQueryVariables = Exact<{
  subdomain_name?: InputMaybe<Scalars['String']['input']>;
  domain_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHostConfigQuery = { __typename?: 'Query', getHostConfig?: { __typename?: 'HostConfig', id: string, domain_name?: string | null, app_title?: string | null, logo_url?: string | null, primary_color?: string | null, primary_color_hover?: string | null, primary_text_color?: string | null, header_color?: string | null, header_font_color?: string | null, hero_main_title?: string | null, hero_sub_title?: string | null, hero_text_color?: string | null, hero_image?: Array<string | null> | null, hero_background_color?: string | null, hero_buttons?: string | null, better_title?: string | null, better_subtitle?: string | null, better_image?: string | null, better_left_text?: string | null, better_right_text?: string | null, better_left_image?: string | null, better_right_image?: string | null, experience_title?: string | null, experience_subtitle?: string | null, experience_text?: string | null, experience_image?: string | null, partners_title?: string | null, partners_logo?: string | null, balloons_title?: string | null, blocks_order?: Array<string | null> | null, meta_title?: string | null, meta_description?: string | null, meta_keywords?: string | null, og_title?: string | null, og_description?: string | null, og_image?: string | null } | null };

export type GetKunakDataQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type GetKunakDataQuery = { __typename?: 'Query', getKunakTemperatureData?: { __typename?: 'KunakTemperatureData', period_uuid?: string | null, enabled: boolean, timestamp?: string | null, elements: Array<{ __typename?: 'KunakElement', element_id: string, value?: string | null, unit?: string | null, timestamp?: string | null, metadata?: any | null }> } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null };

export type GetMyEventTeamQueryVariables = Exact<{
  volunteer_hash: Scalars['String']['input'];
}>;


export type GetMyEventTeamQuery = { __typename?: 'Query', getMyEventTeam?: { __typename?: 'EventTeam', id: string, event?: { __typename?: 'Event', id: string, name: string } | null, user?: { __typename?: 'User', is_super_admin?: boolean | null } | null, team_role?: { __typename?: 'TeamRole', id: string, role_name?: string | null, controls?: Array<string | null> | null } | null } | null };

export type GetParticipantProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParticipantProfileDataQuery = { __typename?: 'Query', getParticipantProfileData?: { __typename?: 'ParticipantProfileData', user?: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', profile_picture?: string | null, medical_background?: string | null } | null } | null, event_participants?: Array<{ __typename?: 'EventParticipant', id: string, event?: { __typename?: 'Event', id: string, name: string, date?: any | null, logo?: string | null, volunteer_hash?: string | null, participant_hash?: string | null } | null } | null> | null } | null };

export type GetRegisteredEventTeamsQueryVariables = Exact<{
  volunteer_hash: Scalars['String']['input'];
}>;


export type GetRegisteredEventTeamsQuery = { __typename?: 'Query', getRegisteredEventTeams?: Array<{ __typename?: 'EventTeam', id: string, is_volunteer_other_events?: boolean | null, station_preference?: string | null, experience?: string | null, volunteer_notes?: string | null, can_be_moved?: boolean | null, event?: { __typename?: 'Event', id: string, name: string, logo?: string | null, volunteer_hash?: string | null, display_station_preference?: boolean | null, display_volunteer_notes?: boolean | null, display_can_be_moved?: boolean | null, display_indicate_skills?: boolean | null, team_experience?: string | null, display_shirt_size?: boolean | null, display_racesafe_app_opt_out?: boolean | null, longitude?: number | null, latitude?: number | null, use_for_signup?: boolean | null, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, event_resources: Array<{ __typename?: 'EventResource', id: string, name?: string | null, latitude?: number | null, longitude?: number | null }>, subevents: Array<{ __typename?: 'Event', id: string, name: string }>, intro_video?: { __typename?: 'EventVideo', id: string, title?: string | null, url?: string | null, medical_background?: string | null, type?: string | null } | null, training_video?: { __typename?: 'EventVideo', id: string, title?: string | null, url?: string | null, medical_background?: string | null } | null } | null, event_team_answers?: Array<{ __typename?: 'TeamAnswer', id: string, answer?: string | null, team_question?: { __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null } | null } | null> | null } | null> | null };

export type GetReportTableDataQueryVariables = Exact<{
  event_id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  participantName?: InputMaybe<Scalars['String']['input']>;
  participantCountry?: InputMaybe<Scalars['String']['input']>;
  participantSports?: InputMaybe<Scalars['String']['input']>;
  participantTeam?: InputMaybe<Scalars['String']['input']>;
  participantSex?: InputMaybe<Scalars['String']['input']>;
  participantRole?: InputMaybe<Scalars['String']['input']>;
  displayArchived?: InputMaybe<Scalars['Boolean']['input']>;
  symptom?: InputMaybe<Scalars['String']['input']>;
  physicalFindings?: InputMaybe<Scalars['String']['input']>;
  opinion?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<Scalars['String']['input']>;
  selectedEvents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  selectedDispositions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetReportTableDataQuery = { __typename?: 'Query', getReportTableData?: { __typename?: 'ReportTableData', eventTitle?: string | null, eventDateRange?: string | null, incidentOutcomes?: any | null, dailyIncidentSummary?: { __typename?: 'DailyIncidentSummary', totalUniquePersonsSeen?: number | null, totalMajorIncidents?: number | null, totalIncidents?: number | null, totalInjuryActivity?: any | null, totalIllnessActivity?: any | null, totalMinorAssistance?: any | null } | null } | null };

export type GetResourceTrackingQueryVariables = Exact<{
  event_resource_id: Scalars['ID']['input'];
}>;


export type GetResourceTrackingQuery = { __typename?: 'Query', getResourceTracking?: Array<{ __typename?: 'Tracking', id: string, is_spot?: boolean | null, is_check_in?: boolean | null, is_check_out?: boolean | null, is_disposition?: boolean | null, is_minorassist?: boolean | null, is_athlete_record?: boolean | null, state?: string | null, status?: string | null, status_name?: string | null, hospital?: string | null, notes?: string | null, updated_at?: Date | null, event_participant?: { __typename?: 'EventParticipant', id: string, identifier_number?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, country?: string | null, sports?: string | null, delegation?: string | null, role?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, age?: string | null, birth_date?: string | null, event?: { __typename?: 'Event', id: string, name: string } | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null } | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', color?: string | null, id: string, label?: string | null } | null, event_transport?: { __typename?: 'EventTransport', id: string, event_hospital?: { __typename?: 'EventHospital', id: string, name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', user?: { __typename?: 'User', full_name: string } | null } | null } | null> | null };

export type GetStatusDashboardCountsQueryVariables = Exact<{
  hash: Scalars['String']['input'];
  recalculate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStatusDashboardCountsQuery = { __typename?: 'Query', getStatusDashboardCounts?: Array<{ __typename?: 'TrackingDashboardCounts', id: string } | null> | null };

export type GetStatusHistoryQueryVariables = Exact<{
  event_participant_id: Scalars['ID']['input'];
}>;


export type GetStatusHistoryQuery = { __typename?: 'Query', getAMRData?: { __typename?: 'AMRData', event_participant?: { __typename?: 'EventParticipant', id: string, master_tracking?: Array<{ __typename?: 'TrackingHistory', id: string, status?: string | null, status_name?: string | null, notes?: string | null, created_at?: Date | null, updated_at?: Date | null, disposition_name?: string | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null } | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null } | null, status_trigger?: { __typename?: 'StatusTrigger', id: string, name?: string | null } | null, creator?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null, updater?: { __typename?: 'User', id: string, full_name: string, first_name: string, last_name: string } | null } | null> | null } | null } | null };

export type GetStatusTrackingQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  eventTrackingStatusId: Scalars['ID']['input'];
}>;


export type GetStatusTrackingQuery = { __typename?: 'Query', getStatusTracking?: Array<{ __typename?: 'Tracking', id: string, status?: string | null, status_name?: string | null, state?: string | null, updated_at?: Date | null, event_participant?: { __typename?: 'EventParticipant', id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, identifier_number?: string | null, country?: string | null, sports?: string | null, delegation?: string | null, role?: string | null } | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null } | null } | null> | null };

export type GetTeamResourcesQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type GetTeamResourcesQuery = { __typename?: 'Query', getTeamResources: Array<{ __typename?: 'EventResource', id: string, name?: string | null, mobile_resource_status?: string | null, is_mobile?: boolean | null, is_sagbus?: boolean | null, event_id?: string | null, ord?: number | null, dont_relate_events?: boolean | null, tracking_dashboard_count?: { __typename?: 'TrackingDashboardCounts', id: string, activity_id?: string | null, total?: number | null, active_total?: number | null, active_red?: number | null, active_yellow?: number | null, active_green?: number | null, active_gray?: number | null, minor?: number | null, resolved?: number | null, transport?: number | null, counts?: { __typename?: 'TrackingDashboardCount', total?: number | null, active?: number | null, minor?: number | null, resolved?: number | null, transport?: number | null, statusCounts?: any | null } | null } | null }> };

export type GetUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', email_address: string, first_name: string, id: string, full_name: string, content_user_id?: string | null, is_super_admin?: boolean | null, is_active?: boolean | null, last_name: string, parent_user_id?: string | null, profile?: { __typename?: 'UserProfile', is_center_user?: boolean | null, is_event_user?: boolean | null, is_waiver_agreement_consented?: boolean | null, is_med_team?: boolean | null, is_race_safe_app_user?: boolean | null, show_in_engage_listing?: boolean | null, communication?: string | null, address_line1?: string | null, address_line2?: string | null, city?: string | null, district?: string | null, state?: string | null, postal_code?: string | null, country?: string | null, primary_cellphone_number?: string | null, alternate_phone_number?: string | null, mobile_type?: string | null, mobile_carrier?: string | null, gender?: string | null, gender_identity?: string | null, pronoun?: string | null, birth_date?: string | null, profile_picture?: string | null, height_inches?: number | null, weight_lbs?: number | null, measurement_unit?: string | null, medical_background?: string | null, license_number?: string | null, hipaa_authorized?: boolean | null, email_about_other_products?: boolean | null, user_timezone?: string | null, user_temperature_unit?: string | null, user_uses_24_clock?: boolean | null, user_uses_metric_system?: boolean | null, fixed_age?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, primary_contact_relationship?: string | null, primary_contact_phone?: string | null, primary_contact_email?: string | null, secondary_contact_first_name?: string | null, secondary_contact_last_name?: string | null, secondary_contact_relationship?: string | null, secondary_contact_phone?: string | null, secondary_contact_email?: string | null } | null, children: Array<{ __typename?: 'User', id: string, full_name: string }> } | null };

export type NavbarQueryVariables = Exact<{ [key: string]: never; }>;


export type NavbarQuery = { __typename?: 'Query', navbar?: { __typename?: 'NavbarData', is_super_admin?: boolean | null, items: Array<{ __typename?: 'NavbarItem', id: string, name: string, volunteer_hash?: string | null, participant_hash?: string | null, team_role_controls?: Array<string | null> | null, subitems?: Array<{ __typename?: 'NavbarItem', id: string, name: string, volunteer_hash?: string | null, participant_hash?: string | null, team_role_controls?: Array<string | null> | null } | null> | null } | null> } | null };

export type GetParticipantEmergencyContactsQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantEmergencyContactsQuery = { __typename?: 'Query', participantEmergencyContacts: Array<{ __typename?: 'EventParticipant', id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, email_address?: string | null, primary_cellphone_number?: string | null, role?: string | null, delegation?: string | null, country?: string | null }> };

export type SearchParticipantTrackingQueryVariables = Exact<{
  hash: Scalars['String']['input'];
  search_query?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  participant_id?: InputMaybe<Scalars['ID']['input']>;
  participant_name?: InputMaybe<Scalars['String']['input']>;
  participant_country?: InputMaybe<Scalars['String']['input']>;
  participant_sports?: InputMaybe<Scalars['String']['input']>;
  participant_team?: InputMaybe<Scalars['String']['input']>;
  participant_sex?: InputMaybe<Scalars['String']['input']>;
  participant_role?: InputMaybe<Scalars['String']['input']>;
  selected_events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  activity?: InputMaybe<Scalars['String']['input']>;
  tracking_status_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tracking_states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  display_archived?: InputMaybe<Scalars['Boolean']['input']>;
  display_active?: InputMaybe<Scalars['Boolean']['input']>;
  display_closed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchParticipantTrackingQuery = { __typename?: 'Query', searchParticipantTracking?: Array<{ __typename?: 'Tracking', id: string, is_spot?: boolean | null, is_check_in?: boolean | null, is_check_out?: boolean | null, is_disposition?: boolean | null, is_minorassist?: boolean | null, is_athlete_record?: boolean | null, state?: string | null, status?: string | null, status_name?: string | null, hospital?: string | null, notes?: string | null, updated_at?: Date | null, event?: { __typename?: 'Event', id: string, name: string } | null, event_resource?: { __typename?: 'EventResource', id: string, name?: string | null, is_mobile?: boolean | null } | null, event_participant?: { __typename?: 'EventParticipant', identifier_number?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, country?: string | null, sports?: string | null, delegation?: string | null, role?: string | null, primary_contact_first_name?: string | null, primary_contact_last_name?: string | null, age?: string | null, birth_date?: string | null, user?: { __typename?: 'User', full_name: string, first_name: string, last_name: string } | null } | null, event_tracking_status?: { __typename?: 'EventTrackingStatus', color?: string | null, id: string, label?: string | null } | null, event_transport?: { __typename?: 'EventTransport', id: string, event_hospital?: { __typename?: 'EventHospital', id: string, name?: string | null } | null } | null, event_team?: { __typename?: 'EventTeam', user?: { __typename?: 'User', full_name: string } | null } | null } | null> | null };

export type UserTeamEventsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type UserTeamEventsQuery = { __typename?: 'Query', userTeamEvents: { __typename?: 'EventPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, total: number }, data: Array<{ __typename?: 'Event', name: string, id: string, participant_description?: string | null, team_description?: string | null, logo?: string | null, subevent_select_behavior?: string | null, subevents: Array<{ __typename?: 'Event', id: string, name: string, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }> }>, eventTranslations: Array<{ __typename?: 'EventTranslation', language?: string | null }>, encounterCallActions: Array<{ __typename?: 'EncounterCallAction', name?: string | null, encounterTypePhoneNumbers: Array<{ __typename?: 'EncounterTypePhoneNumber', id: string }> }>, encounterDispositionTypes: Array<{ __typename?: 'EncounterDispositionType', name?: string | null }>, event_tracking_statuses: Array<{ __typename?: 'EventTrackingStatus', id: string, label?: string | null, color?: string | null, font_color?: string | null, is_private?: boolean | null, sort_order?: number | null }>, event_activities: Array<{ __typename?: 'EventActivity', id: string, label?: string | null, name?: string | null, category?: ActivityCategory | null, systemActivityPage?: { __typename?: 'SystemActivityPage', name?: string | null } | null, eventButtonGroups: Array<{ __typename?: 'EventButtonGroup', id: string, type?: string | null, label?: string | null, is_single_selection?: boolean | null, eventButtons: Array<{ __typename?: 'EventButton', id: string, label?: string | null, eventForm?: { __typename?: 'EventForm', id: string, name?: string | null, label?: string | null } | null }> }>, eventForms: Array<{ __typename?: 'EventForm', id: string, name?: string | null, label?: string | null }> }>, participantQuestions: Array<{ __typename?: 'ParticipantQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }>, teamQuestions: Array<{ __typename?: 'TeamQuestion', id: string, title?: string | null, subtitle?: string | null, other_title?: string | null, tooltip_info?: string | null, options?: string | null, multiple_selection?: boolean | null, mandatory?: boolean | null, type?: string | null }> }> } };

export const AmrEncounterFragmentDoc = gql`
    fragment AmrEncounter on Encounter {
  id
  event_activity {
    id
    name
    label
    category
  }
  event {
    id
    name
  }
  event_team {
    id
    user {
      full_name
    }
  }
  encounter_spot_data {
    id
    serialized_data
  }
  encounter_dispositions {
    id
  }
  created_at
  updated_at
  server_received_at
}
    `;
export const EventTeamFragmentDoc = gql`
    fragment EventTeam on EventTeam {
  id
  event {
    id
    name
  }
  user {
    is_super_admin
  }
  team_role {
    id
    role_name
    controls
  }
}
    `;
export const PaginatorInfoFragmentDoc = gql`
    fragment PaginatorInfo on PaginatorInfo {
  currentPage
  hasMorePages
  lastPage
  total
}
    `;
export const PickEventFragmentDoc = gql`
    fragment PickEvent on Event {
  name
  id
  participant_description
  team_description
  logo
  subevent_select_behavior
  subevents {
    id
    name
    eventTranslations {
      language
    }
  }
  eventTranslations {
    language
  }
  encounterCallActions {
    name
    encounterTypePhoneNumbers {
      id
    }
  }
  encounterDispositionTypes {
    name
  }
  event_tracking_statuses {
    id
    label
    color
    font_color
    is_private
    sort_order
  }
  event_activities {
    id
    label
    name
    category
    systemActivityPage {
      name
    }
    eventButtonGroups {
      id
      type
      label
      is_single_selection
      eventButtons {
        id
        label
        eventForm {
          id
          name
          label
        }
      }
    }
    eventForms {
      id
      name
      label
    }
  }
  participantQuestions {
    id
    title
    subtitle
    other_title
    options
    multiple_selection
    mandatory
    type
  }
  teamQuestions {
    id
    title
    subtitle
    other_title
    tooltip_info
    options
    multiple_selection
    mandatory
    type
  }
}
    `;
export const SearchParticipantFragmentDoc = gql`
    fragment SearchParticipant on EventParticipant {
  id
  last_name
  first_name
  full_name
  age
  gender_short
  birth_date
  identifier_number
  email_address
  gender
  pronoun
  user {
    full_name
    first_name
    last_name
  }
  event {
    id
    name
  }
}
    `;
export const SpotEncounterFragmentDoc = gql`
    fragment SpotEncounter on Encounter {
  id
  is_resolved
  created_at
  updated_at
  created_by_user {
    full_name
  }
  event_activity {
    id
    name
    category
  }
  event_resource {
    id
    name
    default_nearest_station
    dont_relate_events
    is_mobile
    is_sagbus
    latitude
    longitude
  }
  encounter_spot_data {
    id
    parent_encounter_id
    message
    contact_phone
    contact_email
    encounter_call_action {
      name
      updated_at
    }
    event_button_data {
      id
      event_button {
        id
        label
      }
      event_button_group {
        id
        type
        label
      }
      created_at
    }
    event_button_freetext_data {
      id
      freetext
      event_button_group {
        id
        type
        label
      }
    }
    event_bodypart_data {
      id
      event_form {
        id
        name
        label
      }
      body
      part
    }
    event_labs_data {
      id
      event_form {
        id
        name
        label
      }
      saturation
      sodium
      glucose
      note
    }
    event_vitalsigns_data {
      id
      event_form {
        id
        name
        label
      }
      temperature
      pulse
      breathing
      systole
      diastole
      note
      blood_pressure
    }
    event_medicationgiven_data {
      id
      event_form {
        id
        name
        label
      }
      medication
      directions
      strength
      doseunit
      note
      route
      status
    }
    created_at
  }
  encounter_dispositions {
    id
    note
    care_provider
    is_cancel_transport
    diagnosis
    admit_at
    discharge_at
    parent_encounter_id
    event_resource {
      name
    }
    encounter_disposition_type {
      name
      transport_disposition
      is_mobile_activity
      is_sagbus_activity
    }
    event_transport {
      event_hospital {
        name
      }
    }
    created_at
    local_time
  }
  event_research_question_data {
    id
    encounter_spot_data_id
    research_question_type
    research_question_title
    research_question_answer
    created_at
  }
  latest_encounter_disposition {
    id
    encounter_disposition_type {
      name
    }
  }
  event_team {
    id
    user {
      id
      full_name
      first_name
      last_name
    }
  }
  tracking {
    status
    status_name
    event_tracking_status {
      label
      color
    }
  }
  event {
    id
    name
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  email_address
  first_name
  id
  full_name
  content_user_id
  is_super_admin
  is_active
  last_name
  parent_user_id
  profile {
    is_center_user
    is_event_user
    is_waiver_agreement_consented
    is_med_team
    is_race_safe_app_user
    show_in_engage_listing
    communication
    address_line1
    address_line2
    city
    district
    state
    postal_code
    country
    primary_cellphone_number
    alternate_phone_number
    mobile_type
    mobile_carrier
    gender
    gender_identity
    pronoun
    birth_date
    profile_picture
    height_inches
    weight_lbs
    measurement_unit
    medical_background
    license_number
    hipaa_authorized
    email_about_other_products
    user_timezone
    user_temperature_unit
    user_uses_24_clock
    user_uses_metric_system
    fixed_age
    primary_contact_first_name
    primary_contact_last_name
    primary_contact_relationship
    primary_contact_phone
    primary_contact_email
    secondary_contact_first_name
    secondary_contact_last_name
    secondary_contact_relationship
    secondary_contact_phone
    secondary_contact_email
  }
  children {
    id
    full_name
  }
}
    `;
export const UpdateEventTeamByAdminDocument = gql`
    mutation UpdateEventTeamByAdmin($volunteer_hash: String!, $event_team_id: ID!, $experience: [String], $custom: JSON, $location: String, $background: String, $phone_number: String, $role: String, $delegation: String, $sports: String, $volunteer_other_events: Boolean, $can_be_moved: Boolean, $volunteer_notes: String) {
  updateEventTeamByAdmin(
    volunteer_hash: $volunteer_hash
    event_team_id: $event_team_id
    experience: $experience
    custom: $custom
    location: $location
    background: $background
    phone_number: $phone_number
    role: $role
    delegation: $delegation
    sports: $sports
    volunteer_other_events: $volunteer_other_events
    can_be_moved: $can_be_moved
    volunteer_notes: $volunteer_notes
  ) {
    id
    background
    background_with_fallback
  }
}
    `;
export type UpdateEventTeamByAdminMutationFn = Apollo.MutationFunction<UpdateEventTeamByAdminMutation, UpdateEventTeamByAdminMutationVariables>;

/**
 * __useUpdateEventTeamByAdminMutation__
 *
 * To run a mutation, you first call `useUpdateEventTeamByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTeamByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventTeamByAdminMutation, { data, loading, error }] = useUpdateEventTeamByAdminMutation({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *      event_team_id: // value for 'event_team_id'
 *      experience: // value for 'experience'
 *      custom: // value for 'custom'
 *      location: // value for 'location'
 *      background: // value for 'background'
 *      phone_number: // value for 'phone_number'
 *      role: // value for 'role'
 *      delegation: // value for 'delegation'
 *      sports: // value for 'sports'
 *      volunteer_other_events: // value for 'volunteer_other_events'
 *      can_be_moved: // value for 'can_be_moved'
 *      volunteer_notes: // value for 'volunteer_notes'
 *   },
 * });
 */
export function useUpdateEventTeamByAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTeamByAdminMutation, UpdateEventTeamByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTeamByAdminMutation, UpdateEventTeamByAdminMutationVariables>(UpdateEventTeamByAdminDocument, options);
      }
export type UpdateEventTeamByAdminMutationHookResult = ReturnType<typeof useUpdateEventTeamByAdminMutation>;
export type UpdateEventTeamByAdminMutationResult = Apollo.MutationResult<UpdateEventTeamByAdminMutation>;
export type UpdateEventTeamByAdminMutationOptions = Apollo.BaseMutationOptions<UpdateEventTeamByAdminMutation, UpdateEventTeamByAdminMutationVariables>;
export const UpdateEventTeamDetailsDocument = gql`
    mutation UpdateEventTeamDetails($experience: [String], $custom: JSON, $location: String, $background: String, $phone_number: String, $role: String, $delegation: String, $sports: String, $volunteer_other_events: Boolean, $can_be_moved: Boolean, $volunteer_notes: String, $volunteer_hash: String!, $event_team_id: ID) {
  updateEventTeamDetails(
    experience: $experience
    custom: $custom
    location: $location
    background: $background
    phone_number: $phone_number
    role: $role
    delegation: $delegation
    sports: $sports
    volunteer_other_events: $volunteer_other_events
    can_be_moved: $can_be_moved
    volunteer_notes: $volunteer_notes
    volunteer_hash: $volunteer_hash
    event_team_id: $event_team_id
  ) {
    id
  }
}
    `;
export type UpdateEventTeamDetailsMutationFn = Apollo.MutationFunction<UpdateEventTeamDetailsMutation, UpdateEventTeamDetailsMutationVariables>;

/**
 * __useUpdateEventTeamDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateEventTeamDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTeamDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventTeamDetailsMutation, { data, loading, error }] = useUpdateEventTeamDetailsMutation({
 *   variables: {
 *      experience: // value for 'experience'
 *      custom: // value for 'custom'
 *      location: // value for 'location'
 *      background: // value for 'background'
 *      phone_number: // value for 'phone_number'
 *      role: // value for 'role'
 *      delegation: // value for 'delegation'
 *      sports: // value for 'sports'
 *      volunteer_other_events: // value for 'volunteer_other_events'
 *      can_be_moved: // value for 'can_be_moved'
 *      volunteer_notes: // value for 'volunteer_notes'
 *      volunteer_hash: // value for 'volunteer_hash'
 *      event_team_id: // value for 'event_team_id'
 *   },
 * });
 */
export function useUpdateEventTeamDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTeamDetailsMutation, UpdateEventTeamDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTeamDetailsMutation, UpdateEventTeamDetailsMutationVariables>(UpdateEventTeamDetailsDocument, options);
      }
export type UpdateEventTeamDetailsMutationHookResult = ReturnType<typeof useUpdateEventTeamDetailsMutation>;
export type UpdateEventTeamDetailsMutationResult = Apollo.MutationResult<UpdateEventTeamDetailsMutation>;
export type UpdateEventTeamDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateEventTeamDetailsMutation, UpdateEventTeamDetailsMutationVariables>;
export const UpdateEventTeamProfileDocument = gql`
    mutation UpdateEventTeamProfile($gender: String, $pronouns: String, $contact: String, $subscribe_to_products_services: Boolean, $medical_background: String, $med_licence_number: String, $country: String, $city: String, $state: String, $zipcode: String, $address1: String, $terms_and_conditions: Boolean!, $volunteer_hash: String!) {
  updateEventTeamProfile(
    gender: $gender
    pronouns: $pronouns
    contact: $contact
    subscribe_to_products_services: $subscribe_to_products_services
    medical_background: $medical_background
    med_licence_number: $med_licence_number
    country: $country
    city: $city
    state: $state
    zipcode: $zipcode
    address1: $address1
    terms_and_conditions: $terms_and_conditions
    volunteer_hash: $volunteer_hash
  ) {
    id
  }
}
    `;
export type UpdateEventTeamProfileMutationFn = Apollo.MutationFunction<UpdateEventTeamProfileMutation, UpdateEventTeamProfileMutationVariables>;

/**
 * __useUpdateEventTeamProfileMutation__
 *
 * To run a mutation, you first call `useUpdateEventTeamProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTeamProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventTeamProfileMutation, { data, loading, error }] = useUpdateEventTeamProfileMutation({
 *   variables: {
 *      gender: // value for 'gender'
 *      pronouns: // value for 'pronouns'
 *      contact: // value for 'contact'
 *      subscribe_to_products_services: // value for 'subscribe_to_products_services'
 *      medical_background: // value for 'medical_background'
 *      med_licence_number: // value for 'med_licence_number'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipcode: // value for 'zipcode'
 *      address1: // value for 'address1'
 *      terms_and_conditions: // value for 'terms_and_conditions'
 *      volunteer_hash: // value for 'volunteer_hash'
 *   },
 * });
 */
export function useUpdateEventTeamProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventTeamProfileMutation, UpdateEventTeamProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventTeamProfileMutation, UpdateEventTeamProfileMutationVariables>(UpdateEventTeamProfileDocument, options);
      }
export type UpdateEventTeamProfileMutationHookResult = ReturnType<typeof useUpdateEventTeamProfileMutation>;
export type UpdateEventTeamProfileMutationResult = Apollo.MutationResult<UpdateEventTeamProfileMutation>;
export type UpdateEventTeamProfileMutationOptions = Apollo.BaseMutationOptions<UpdateEventTeamProfileMutation, UpdateEventTeamProfileMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($first_name: String, $last_name: String, $user_id: ID!, $birth_date: String, $gender: String, $gender_identity: String, $pronouns: String, $contact: String, $email_about_other_products: Boolean, $medical_background: String, $med_licence_number: String, $country: String, $city: String, $state: String, $zipcode: String, $address1: String, $is_waiver_agreement_consented: Boolean) {
  updateProfile(
    user_id: $user_id
    first_name: $first_name
    last_name: $last_name
    birth_date: $birth_date
    gender: $gender
    gender_identity: $gender_identity
    pronouns: $pronouns
    contact: $contact
    email_about_other_products: $email_about_other_products
    medical_background: $medical_background
    med_licence_number: $med_licence_number
    country: $country
    city: $city
    state: $state
    zipcode: $zipcode
    address1: $address1
    is_waiver_agreement_consented: $is_waiver_agreement_consented
  ) {
    id
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      user_id: // value for 'user_id'
 *      birth_date: // value for 'birth_date'
 *      gender: // value for 'gender'
 *      gender_identity: // value for 'gender_identity'
 *      pronouns: // value for 'pronouns'
 *      contact: // value for 'contact'
 *      email_about_other_products: // value for 'email_about_other_products'
 *      medical_background: // value for 'medical_background'
 *      med_licence_number: // value for 'med_licence_number'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipcode: // value for 'zipcode'
 *      address1: // value for 'address1'
 *      is_waiver_agreement_consented: // value for 'is_waiver_agreement_consented'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const AssignEventTeamsToEventResourceDocument = gql`
    mutation AssignEventTeamsToEventResource($event_id: ID!, $event_resource_id: ID!, $event_team_ids: [ID!]!) {
  assignEventTeamsToEventResource(
    event_id: $event_id
    event_resource_id: $event_resource_id
    event_team_ids: $event_team_ids
  ) {
    id
  }
}
    `;
export type AssignEventTeamsToEventResourceMutationFn = Apollo.MutationFunction<AssignEventTeamsToEventResourceMutation, AssignEventTeamsToEventResourceMutationVariables>;

/**
 * __useAssignEventTeamsToEventResourceMutation__
 *
 * To run a mutation, you first call `useAssignEventTeamsToEventResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignEventTeamsToEventResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignEventTeamsToEventResourceMutation, { data, loading, error }] = useAssignEventTeamsToEventResourceMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_resource_id: // value for 'event_resource_id'
 *      event_team_ids: // value for 'event_team_ids'
 *   },
 * });
 */
export function useAssignEventTeamsToEventResourceMutation(baseOptions?: Apollo.MutationHookOptions<AssignEventTeamsToEventResourceMutation, AssignEventTeamsToEventResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignEventTeamsToEventResourceMutation, AssignEventTeamsToEventResourceMutationVariables>(AssignEventTeamsToEventResourceDocument, options);
      }
export type AssignEventTeamsToEventResourceMutationHookResult = ReturnType<typeof useAssignEventTeamsToEventResourceMutation>;
export type AssignEventTeamsToEventResourceMutationResult = Apollo.MutationResult<AssignEventTeamsToEventResourceMutation>;
export type AssignEventTeamsToEventResourceMutationOptions = Apollo.BaseMutationOptions<AssignEventTeamsToEventResourceMutation, AssignEventTeamsToEventResourceMutationVariables>;
export const CancelTransportDocument = gql`
    mutation CancelTransport($encounter_disposition_id: ID!) {
  cancelTransport(encounter_disposition_id: $encounter_disposition_id) {
    id
  }
}
    `;
export type CancelTransportMutationFn = Apollo.MutationFunction<CancelTransportMutation, CancelTransportMutationVariables>;

/**
 * __useCancelTransportMutation__
 *
 * To run a mutation, you first call `useCancelTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransportMutation, { data, loading, error }] = useCancelTransportMutation({
 *   variables: {
 *      encounter_disposition_id: // value for 'encounter_disposition_id'
 *   },
 * });
 */
export function useCancelTransportMutation(baseOptions?: Apollo.MutationHookOptions<CancelTransportMutation, CancelTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTransportMutation, CancelTransportMutationVariables>(CancelTransportDocument, options);
      }
export type CancelTransportMutationHookResult = ReturnType<typeof useCancelTransportMutation>;
export type CancelTransportMutationResult = Apollo.MutationResult<CancelTransportMutation>;
export type CancelTransportMutationOptions = Apollo.BaseMutationOptions<CancelTransportMutation, CancelTransportMutationVariables>;
export const ChangeEncounterRecordDocument = gql`
    mutation changeEncounterRecord($encounter_id: ID!, $encounter_changes: EncounterChangesInput, $disposition_changes: [DispositionChangesInput!]) {
  changeEncounterRecord(
    encounter_id: $encounter_id
    encounter_changes: $encounter_changes
    disposition_changes: $disposition_changes
  ) {
    ...AmrEncounter
  }
}
    ${AmrEncounterFragmentDoc}`;
export type ChangeEncounterRecordMutationFn = Apollo.MutationFunction<ChangeEncounterRecordMutation, ChangeEncounterRecordMutationVariables>;

/**
 * __useChangeEncounterRecordMutation__
 *
 * To run a mutation, you first call `useChangeEncounterRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEncounterRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEncounterRecordMutation, { data, loading, error }] = useChangeEncounterRecordMutation({
 *   variables: {
 *      encounter_id: // value for 'encounter_id'
 *      encounter_changes: // value for 'encounter_changes'
 *      disposition_changes: // value for 'disposition_changes'
 *   },
 * });
 */
export function useChangeEncounterRecordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEncounterRecordMutation, ChangeEncounterRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEncounterRecordMutation, ChangeEncounterRecordMutationVariables>(ChangeEncounterRecordDocument, options);
      }
export type ChangeEncounterRecordMutationHookResult = ReturnType<typeof useChangeEncounterRecordMutation>;
export type ChangeEncounterRecordMutationResult = Apollo.MutationResult<ChangeEncounterRecordMutation>;
export type ChangeEncounterRecordMutationOptions = Apollo.BaseMutationOptions<ChangeEncounterRecordMutation, ChangeEncounterRecordMutationVariables>;
export const CloseRecordDocument = gql`
    mutation closeRecord($encounter_id: ID!, $participant_id: ID!) {
  closeRecord(encounter_id: $encounter_id, participant_id: $participant_id) {
    id
    is_resolved
  }
}
    `;
export type CloseRecordMutationFn = Apollo.MutationFunction<CloseRecordMutation, CloseRecordMutationVariables>;

/**
 * __useCloseRecordMutation__
 *
 * To run a mutation, you first call `useCloseRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeRecordMutation, { data, loading, error }] = useCloseRecordMutation({
 *   variables: {
 *      encounter_id: // value for 'encounter_id'
 *      participant_id: // value for 'participant_id'
 *   },
 * });
 */
export function useCloseRecordMutation(baseOptions?: Apollo.MutationHookOptions<CloseRecordMutation, CloseRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseRecordMutation, CloseRecordMutationVariables>(CloseRecordDocument, options);
      }
export type CloseRecordMutationHookResult = ReturnType<typeof useCloseRecordMutation>;
export type CloseRecordMutationResult = Apollo.MutationResult<CloseRecordMutation>;
export type CloseRecordMutationOptions = Apollo.BaseMutationOptions<CloseRecordMutation, CloseRecordMutationVariables>;
export const CreateChildDocument = gql`
    mutation createChild($parent_id: ID!, $first_name: String!, $last_name: String!, $date_of_birth: Date!) {
  createChild(
    parent_id: $parent_id
    first_name: $first_name
    last_name: $last_name
    date_of_birth: $date_of_birth
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type CreateChildMutationFn = Apollo.MutationFunction<CreateChildMutation, CreateChildMutationVariables>;

/**
 * __useCreateChildMutation__
 *
 * To run a mutation, you first call `useCreateChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChildMutation, { data, loading, error }] = useCreateChildMutation({
 *   variables: {
 *      parent_id: // value for 'parent_id'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      date_of_birth: // value for 'date_of_birth'
 *   },
 * });
 */
export function useCreateChildMutation(baseOptions?: Apollo.MutationHookOptions<CreateChildMutation, CreateChildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChildMutation, CreateChildMutationVariables>(CreateChildDocument, options);
      }
export type CreateChildMutationHookResult = ReturnType<typeof useCreateChildMutation>;
export type CreateChildMutationResult = Apollo.MutationResult<CreateChildMutation>;
export type CreateChildMutationOptions = Apollo.BaseMutationOptions<CreateChildMutation, CreateChildMutationVariables>;
export const CreateEventParticipantDocument = gql`
    mutation createEventParticipant($event_id: ID!, $longitude: Float!, $latitude: Float!, $identifier_number: String, $email_address: String, $phone_number: String, $first_name: String, $last_name: String, $date_of_birth: Date, $sex: String, $pronoun: String) {
  createEventParticipant(
    event_id: $event_id
    longitude: $longitude
    latitude: $latitude
    identifier_number: $identifier_number
    email_address: $email_address
    phone_number: $phone_number
    first_name: $first_name
    last_name: $last_name
    date_of_birth: $date_of_birth
    sex: $sex
    pronoun: $pronoun
  ) {
    ...SearchParticipant
  }
}
    ${SearchParticipantFragmentDoc}`;
export type CreateEventParticipantMutationFn = Apollo.MutationFunction<CreateEventParticipantMutation, CreateEventParticipantMutationVariables>;

/**
 * __useCreateEventParticipantMutation__
 *
 * To run a mutation, you first call `useCreateEventParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventParticipantMutation, { data, loading, error }] = useCreateEventParticipantMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      longitude: // value for 'longitude'
 *      latitude: // value for 'latitude'
 *      identifier_number: // value for 'identifier_number'
 *      email_address: // value for 'email_address'
 *      phone_number: // value for 'phone_number'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      date_of_birth: // value for 'date_of_birth'
 *      sex: // value for 'sex'
 *      pronoun: // value for 'pronoun'
 *   },
 * });
 */
export function useCreateEventParticipantMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventParticipantMutation, CreateEventParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventParticipantMutation, CreateEventParticipantMutationVariables>(CreateEventParticipantDocument, options);
      }
export type CreateEventParticipantMutationHookResult = ReturnType<typeof useCreateEventParticipantMutation>;
export type CreateEventParticipantMutationResult = Apollo.MutationResult<CreateEventParticipantMutation>;
export type CreateEventParticipantMutationOptions = Apollo.BaseMutationOptions<CreateEventParticipantMutation, CreateEventParticipantMutationVariables>;
export const ExportEventTeamListDocument = gql`
    mutation exportEventTeamList($volunteer_hash: String!) {
  exportEventTeamList(volunteer_hash: $volunteer_hash) {
    id
    event {
      name
      teamQuestions {
        id
        title
        subtitle
        other_title
        tooltip_info
        options
        multiple_selection
        mandatory
        type
      }
    }
    event_resource {
      id
      name
      assignment_time
    }
    team_role {
      id
      role_name
    }
    event_team_answers {
      id
      answer
      team_question {
        id
        title
        subtitle
        other_title
        tooltip_info
        options
        multiple_selection
        mandatory
        type
      }
    }
    is_volunteer_other_events
    has_exercises_manager_enabled
    has_cards_creation_enabled
    show_in_engage_listing
    has_health_check_enabled
    health_check_level
    location_status
    location_status_color
    wizard_complete
    sports
    delegation
    role
    country
    background
    background_with_fallback
    phone_number
    mobile_type
    mobile_carrier
    mobile_phone_type
    has_mobile_phone
    volunteer_notes
    volunteer_assignment_info
    event_team_group_preference {
      id
      name
    }
    event_resource_preference {
      id
      name
    }
    can_be_moved
    racesafe_status
    racesafe_status_label
    racesafe_status_decoded
    experience
    agreement
    authorization_level
    last_latitude
    last_longitude
    groupname
    code
    head_of_delegation
    chaperon
    is_own_guardian
    deidentified
    user {
      full_name
      first_name
      last_name
      email_address
      profile {
        is_center_user
        is_event_user
        is_waiver_agreement_consented
        is_med_team
        is_race_safe_app_user
        show_in_engage_listing
        communication
        address_line1
        address_line2
        city
        district
        state
        postal_code
        country
        primary_cellphone_number
        alternate_phone_number
        mobile_type
        mobile_carrier
        gender
        pronoun
        birth_date
        profile_picture
        height_inches
        weight_lbs
        measurement_unit
        medical_background
        license_number
        hipaa_authorized
        email_about_other_products
        user_timezone
        user_temperature_unit
        user_uses_24_clock
        user_uses_metric_system
        fixed_age
        primary_contact_first_name
        primary_contact_last_name
        primary_contact_relationship
        primary_contact_phone
        primary_contact_email
        secondary_contact_first_name
        secondary_contact_last_name
        secondary_contact_relationship
        secondary_contact_phone
        secondary_contact_email
      }
    }
  }
}
    `;
export type ExportEventTeamListMutationFn = Apollo.MutationFunction<ExportEventTeamListMutation, ExportEventTeamListMutationVariables>;

/**
 * __useExportEventTeamListMutation__
 *
 * To run a mutation, you first call `useExportEventTeamListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEventTeamListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEventTeamListMutation, { data, loading, error }] = useExportEventTeamListMutation({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *   },
 * });
 */
export function useExportEventTeamListMutation(baseOptions?: Apollo.MutationHookOptions<ExportEventTeamListMutation, ExportEventTeamListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEventTeamListMutation, ExportEventTeamListMutationVariables>(ExportEventTeamListDocument, options);
      }
export type ExportEventTeamListMutationHookResult = ReturnType<typeof useExportEventTeamListMutation>;
export type ExportEventTeamListMutationResult = Apollo.MutationResult<ExportEventTeamListMutation>;
export type ExportEventTeamListMutationOptions = Apollo.BaseMutationOptions<ExportEventTeamListMutation, ExportEventTeamListMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    status
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GenerateIdentifierNumberDocument = gql`
    mutation generateIdentifierNumber($event_id: ID!) {
  generateIdentifierNumber(event_id: $event_id)
}
    `;
export type GenerateIdentifierNumberMutationFn = Apollo.MutationFunction<GenerateIdentifierNumberMutation, GenerateIdentifierNumberMutationVariables>;

/**
 * __useGenerateIdentifierNumberMutation__
 *
 * To run a mutation, you first call `useGenerateIdentifierNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIdentifierNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIdentifierNumberMutation, { data, loading, error }] = useGenerateIdentifierNumberMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGenerateIdentifierNumberMutation(baseOptions?: Apollo.MutationHookOptions<GenerateIdentifierNumberMutation, GenerateIdentifierNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateIdentifierNumberMutation, GenerateIdentifierNumberMutationVariables>(GenerateIdentifierNumberDocument, options);
      }
export type GenerateIdentifierNumberMutationHookResult = ReturnType<typeof useGenerateIdentifierNumberMutation>;
export type GenerateIdentifierNumberMutationResult = Apollo.MutationResult<GenerateIdentifierNumberMutation>;
export type GenerateIdentifierNumberMutationOptions = Apollo.BaseMutationOptions<GenerateIdentifierNumberMutation, GenerateIdentifierNumberMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MakeCallDocument = gql`
    mutation makeCall($encounter_call_action_id: ID!, $event_id: ID!, $event_participant_id: ID, $latitude: Float!, $longitude: Float!, $offline: Boolean, $type: String) {
  makeCall(
    encounter_call_action_id: $encounter_call_action_id
    event_id: $event_id
    event_participant_id: $event_participant_id
    latitude: $latitude
    longitude: $longitude
    offline: $offline
    type: $type
  ) {
    id
    created_at
    updated_at
  }
}
    `;
export type MakeCallMutationFn = Apollo.MutationFunction<MakeCallMutation, MakeCallMutationVariables>;

/**
 * __useMakeCallMutation__
 *
 * To run a mutation, you first call `useMakeCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCallMutation, { data, loading, error }] = useMakeCallMutation({
 *   variables: {
 *      encounter_call_action_id: // value for 'encounter_call_action_id'
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      offline: // value for 'offline'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMakeCallMutation(baseOptions?: Apollo.MutationHookOptions<MakeCallMutation, MakeCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCallMutation, MakeCallMutationVariables>(MakeCallDocument, options);
      }
export type MakeCallMutationHookResult = ReturnType<typeof useMakeCallMutation>;
export type MakeCallMutationResult = Apollo.MutationResult<MakeCallMutation>;
export type MakeCallMutationOptions = Apollo.BaseMutationOptions<MakeCallMutation, MakeCallMutationVariables>;
export const MoveParticipantDataDocument = gql`
    mutation moveParticipantData($event_id: ID!, $from_participant: ID!, $to_participant: String!, $to_participant_id: ID) {
  moveParticipantData(
    event_id: $event_id
    from_participant: $from_participant
    to_participant: $to_participant
    to_participant_id: $to_participant_id
  ) {
    ...SearchParticipant
  }
}
    ${SearchParticipantFragmentDoc}`;
export type MoveParticipantDataMutationFn = Apollo.MutationFunction<MoveParticipantDataMutation, MoveParticipantDataMutationVariables>;

/**
 * __useMoveParticipantDataMutation__
 *
 * To run a mutation, you first call `useMoveParticipantDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveParticipantDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveParticipantDataMutation, { data, loading, error }] = useMoveParticipantDataMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      from_participant: // value for 'from_participant'
 *      to_participant: // value for 'to_participant'
 *      to_participant_id: // value for 'to_participant_id'
 *   },
 * });
 */
export function useMoveParticipantDataMutation(baseOptions?: Apollo.MutationHookOptions<MoveParticipantDataMutation, MoveParticipantDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveParticipantDataMutation, MoveParticipantDataMutationVariables>(MoveParticipantDataDocument, options);
      }
export type MoveParticipantDataMutationHookResult = ReturnType<typeof useMoveParticipantDataMutation>;
export type MoveParticipantDataMutationResult = Apollo.MutationResult<MoveParticipantDataMutation>;
export type MoveParticipantDataMutationOptions = Apollo.BaseMutationOptions<MoveParticipantDataMutation, MoveParticipantDataMutationVariables>;
export const NotifyContactDocument = gql`
    mutation notifyContact($encounter_call_action_id: ID!, $event_id: ID!, $event_participant_id: ID, $identifier_number: String, $latitude: Float!, $longitude: Float!, $offline: Boolean, $message: String, $contact_phone: String, $contact_email: String, $dob: Date, $type: String) {
  notifyContact(
    encounter_call_action_id: $encounter_call_action_id
    event_id: $event_id
    event_participant_id: $event_participant_id
    identifier_number: $identifier_number
    latitude: $latitude
    longitude: $longitude
    offline: $offline
    message: $message
    contact_phone: $contact_phone
    contact_email: $contact_email
    dob: $dob
    type: $type
  ) {
    id
    created_at
    updated_at
  }
}
    `;
export type NotifyContactMutationFn = Apollo.MutationFunction<NotifyContactMutation, NotifyContactMutationVariables>;

/**
 * __useNotifyContactMutation__
 *
 * To run a mutation, you first call `useNotifyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyContactMutation, { data, loading, error }] = useNotifyContactMutation({
 *   variables: {
 *      encounter_call_action_id: // value for 'encounter_call_action_id'
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      identifier_number: // value for 'identifier_number'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      offline: // value for 'offline'
 *      message: // value for 'message'
 *      contact_phone: // value for 'contact_phone'
 *      contact_email: // value for 'contact_email'
 *      dob: // value for 'dob'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useNotifyContactMutation(baseOptions?: Apollo.MutationHookOptions<NotifyContactMutation, NotifyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyContactMutation, NotifyContactMutationVariables>(NotifyContactDocument, options);
      }
export type NotifyContactMutationHookResult = ReturnType<typeof useNotifyContactMutation>;
export type NotifyContactMutationResult = Apollo.MutationResult<NotifyContactMutation>;
export type NotifyContactMutationOptions = Apollo.BaseMutationOptions<NotifyContactMutation, NotifyContactMutationVariables>;
export const OpenRecordDocument = gql`
    mutation openRecord($encounter_id: ID!, $participant_id: ID!) {
  openRecord(encounter_id: $encounter_id, participant_id: $participant_id) {
    id
    is_resolved
  }
}
    `;
export type OpenRecordMutationFn = Apollo.MutationFunction<OpenRecordMutation, OpenRecordMutationVariables>;

/**
 * __useOpenRecordMutation__
 *
 * To run a mutation, you first call `useOpenRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openRecordMutation, { data, loading, error }] = useOpenRecordMutation({
 *   variables: {
 *      encounter_id: // value for 'encounter_id'
 *      participant_id: // value for 'participant_id'
 *   },
 * });
 */
export function useOpenRecordMutation(baseOptions?: Apollo.MutationHookOptions<OpenRecordMutation, OpenRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenRecordMutation, OpenRecordMutationVariables>(OpenRecordDocument, options);
      }
export type OpenRecordMutationHookResult = ReturnType<typeof useOpenRecordMutation>;
export type OpenRecordMutationResult = Apollo.MutationResult<OpenRecordMutation>;
export type OpenRecordMutationOptions = Apollo.BaseMutationOptions<OpenRecordMutation, OpenRecordMutationVariables>;
export const RecordSpotDocument = gql`
    mutation recordSpot($data: JSON, $dob: Date, $encounter_id: ID, $encounter_timestamp: DateTime, $event_id: ID!, $event_participant_id: ID, $identifier_number: String, $latitude: Float!, $longitude: Float!, $offline: Boolean, $old_visit: Boolean, $type: String) {
  recordSpot(
    data: $data
    dob: $dob
    encounter_id: $encounter_id
    encounter_timestamp: $encounter_timestamp
    event_id: $event_id
    event_participant_id: $event_participant_id
    identifier_number: $identifier_number
    latitude: $latitude
    longitude: $longitude
    offline: $offline
    old_visit: $old_visit
    type: $type
  ) {
    ...AmrEncounter
  }
}
    ${AmrEncounterFragmentDoc}`;
export type RecordSpotMutationFn = Apollo.MutationFunction<RecordSpotMutation, RecordSpotMutationVariables>;

/**
 * __useRecordSpotMutation__
 *
 * To run a mutation, you first call `useRecordSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSpotMutation, { data, loading, error }] = useRecordSpotMutation({
 *   variables: {
 *      data: // value for 'data'
 *      dob: // value for 'dob'
 *      encounter_id: // value for 'encounter_id'
 *      encounter_timestamp: // value for 'encounter_timestamp'
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      identifier_number: // value for 'identifier_number'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      offline: // value for 'offline'
 *      old_visit: // value for 'old_visit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRecordSpotMutation(baseOptions?: Apollo.MutationHookOptions<RecordSpotMutation, RecordSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSpotMutation, RecordSpotMutationVariables>(RecordSpotDocument, options);
      }
export type RecordSpotMutationHookResult = ReturnType<typeof useRecordSpotMutation>;
export type RecordSpotMutationResult = Apollo.MutationResult<RecordSpotMutation>;
export type RecordSpotMutationOptions = Apollo.BaseMutationOptions<RecordSpotMutation, RecordSpotMutationVariables>;
export const RecordSpotDispositionDocument = gql`
    mutation recordSpotDisposition($identifier_number: String, $event_id: ID!, $event_action_id: ID, $event_participant_id: ID!, $event_activity_id: ID, $encounter_id: ID, $latitude: Float, $longitude: Float, $resource_id: ID, $type: String, $data: JSON, $encounter_disposition_type_id: ID, $event_tracking_status_id: ID, $hospital: String, $note: String, $reported_by: String, $care_provider: String, $mobile_resource_id: ID) {
  recordSpotDisposition(
    identifier_number: $identifier_number
    event_id: $event_id
    event_action_id: $event_action_id
    event_participant_id: $event_participant_id
    event_activity_id: $event_activity_id
    encounter_id: $encounter_id
    latitude: $latitude
    longitude: $longitude
    resource_id: $resource_id
    type: $type
    data: $data
    encounter_disposition_type_id: $encounter_disposition_type_id
    event_tracking_status_id: $event_tracking_status_id
    hospital: $hospital
    note: $note
    reported_by: $reported_by
    care_provider: $care_provider
    mobile_resource_id: $mobile_resource_id
  ) {
    ...AmrEncounter
  }
}
    ${AmrEncounterFragmentDoc}`;
export type RecordSpotDispositionMutationFn = Apollo.MutationFunction<RecordSpotDispositionMutation, RecordSpotDispositionMutationVariables>;

/**
 * __useRecordSpotDispositionMutation__
 *
 * To run a mutation, you first call `useRecordSpotDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSpotDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSpotDispositionMutation, { data, loading, error }] = useRecordSpotDispositionMutation({
 *   variables: {
 *      identifier_number: // value for 'identifier_number'
 *      event_id: // value for 'event_id'
 *      event_action_id: // value for 'event_action_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      event_activity_id: // value for 'event_activity_id'
 *      encounter_id: // value for 'encounter_id'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      resource_id: // value for 'resource_id'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *      encounter_disposition_type_id: // value for 'encounter_disposition_type_id'
 *      event_tracking_status_id: // value for 'event_tracking_status_id'
 *      hospital: // value for 'hospital'
 *      note: // value for 'note'
 *      reported_by: // value for 'reported_by'
 *      care_provider: // value for 'care_provider'
 *      mobile_resource_id: // value for 'mobile_resource_id'
 *   },
 * });
 */
export function useRecordSpotDispositionMutation(baseOptions?: Apollo.MutationHookOptions<RecordSpotDispositionMutation, RecordSpotDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSpotDispositionMutation, RecordSpotDispositionMutationVariables>(RecordSpotDispositionDocument, options);
      }
export type RecordSpotDispositionMutationHookResult = ReturnType<typeof useRecordSpotDispositionMutation>;
export type RecordSpotDispositionMutationResult = Apollo.MutationResult<RecordSpotDispositionMutation>;
export type RecordSpotDispositionMutationOptions = Apollo.BaseMutationOptions<RecordSpotDispositionMutation, RecordSpotDispositionMutationVariables>;
export const RecordWbgtDocument = gql`
    mutation RecordWbgt($volunteer_hash: String!, $temperature: Float!, $scale: String!, $event_resource_id: ID) {
  recordWbgt(
    volunteer_hash: $volunteer_hash
    temperature: $temperature
    scale: $scale
    event_resource_id: $event_resource_id
  ) {
    id
    build_date
    value
    is_wgbt
    humidity
    event_resource {
      id
      name
    }
    temperature_fahrenheit
    temperature_celsius
  }
}
    `;
export type RecordWbgtMutationFn = Apollo.MutationFunction<RecordWbgtMutation, RecordWbgtMutationVariables>;

/**
 * __useRecordWbgtMutation__
 *
 * To run a mutation, you first call `useRecordWbgtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordWbgtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordWbgtMutation, { data, loading, error }] = useRecordWbgtMutation({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *      temperature: // value for 'temperature'
 *      scale: // value for 'scale'
 *      event_resource_id: // value for 'event_resource_id'
 *   },
 * });
 */
export function useRecordWbgtMutation(baseOptions?: Apollo.MutationHookOptions<RecordWbgtMutation, RecordWbgtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordWbgtMutation, RecordWbgtMutationVariables>(RecordWbgtDocument, options);
      }
export type RecordWbgtMutationHookResult = ReturnType<typeof useRecordWbgtMutation>;
export type RecordWbgtMutationResult = Apollo.MutationResult<RecordWbgtMutation>;
export type RecordWbgtMutationOptions = Apollo.BaseMutationOptions<RecordWbgtMutation, RecordWbgtMutationVariables>;
export const RegisterEventParticipantDocument = gql`
    mutation registerEventParticipant($event_ids: [ID!]!) {
  registerEventParticipant(event_ids: $event_ids) {
    id
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type RegisterEventParticipantMutationFn = Apollo.MutationFunction<RegisterEventParticipantMutation, RegisterEventParticipantMutationVariables>;

/**
 * __useRegisterEventParticipantMutation__
 *
 * To run a mutation, you first call `useRegisterEventParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEventParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEventParticipantMutation, { data, loading, error }] = useRegisterEventParticipantMutation({
 *   variables: {
 *      event_ids: // value for 'event_ids'
 *   },
 * });
 */
export function useRegisterEventParticipantMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEventParticipantMutation, RegisterEventParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEventParticipantMutation, RegisterEventParticipantMutationVariables>(RegisterEventParticipantDocument, options);
      }
export type RegisterEventParticipantMutationHookResult = ReturnType<typeof useRegisterEventParticipantMutation>;
export type RegisterEventParticipantMutationResult = Apollo.MutationResult<RegisterEventParticipantMutation>;
export type RegisterEventParticipantMutationOptions = Apollo.BaseMutationOptions<RegisterEventParticipantMutation, RegisterEventParticipantMutationVariables>;
export const RegisterEventTeamDocument = gql`
    mutation registerEventTeam($event_ids: [ID!]!) {
  registerEventTeam(event_ids: $event_ids) {
    id
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type RegisterEventTeamMutationFn = Apollo.MutationFunction<RegisterEventTeamMutation, RegisterEventTeamMutationVariables>;

/**
 * __useRegisterEventTeamMutation__
 *
 * To run a mutation, you first call `useRegisterEventTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEventTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEventTeamMutation, { data, loading, error }] = useRegisterEventTeamMutation({
 *   variables: {
 *      event_ids: // value for 'event_ids'
 *   },
 * });
 */
export function useRegisterEventTeamMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEventTeamMutation, RegisterEventTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEventTeamMutation, RegisterEventTeamMutationVariables>(RegisterEventTeamDocument, options);
      }
export type RegisterEventTeamMutationHookResult = ReturnType<typeof useRegisterEventTeamMutation>;
export type RegisterEventTeamMutationResult = Apollo.MutationResult<RegisterEventTeamMutation>;
export type RegisterEventTeamMutationOptions = Apollo.BaseMutationOptions<RegisterEventTeamMutation, RegisterEventTeamMutationVariables>;
export const Resend2FaCodeDocument = gql`
    mutation resend2FACode($user_id: ID!) {
  resend2FACode(user_id: $user_id) {
    status
    message
    retry_after_seconds
  }
}
    `;
export type Resend2FaCodeMutationFn = Apollo.MutationFunction<Resend2FaCodeMutation, Resend2FaCodeMutationVariables>;

/**
 * __useResend2FaCodeMutation__
 *
 * To run a mutation, you first call `useResend2FaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResend2FaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resend2FaCodeMutation, { data, loading, error }] = useResend2FaCodeMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useResend2FaCodeMutation(baseOptions?: Apollo.MutationHookOptions<Resend2FaCodeMutation, Resend2FaCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Resend2FaCodeMutation, Resend2FaCodeMutationVariables>(Resend2FaCodeDocument, options);
      }
export type Resend2FaCodeMutationHookResult = ReturnType<typeof useResend2FaCodeMutation>;
export type Resend2FaCodeMutationResult = Apollo.MutationResult<Resend2FaCodeMutation>;
export type Resend2FaCodeMutationOptions = Apollo.BaseMutationOptions<Resend2FaCodeMutation, Resend2FaCodeMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!, $token: String!, $password: String!, $password_confirmation: String!) {
  resetPassword(
    email: $email
    token: $token
    password: $password
    password_confirmation: $password_confirmation
  ) {
    status
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      password_confirmation: // value for 'password_confirmation'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SearchParticipantsDocument = gql`
    mutation searchParticipants($query: String!, $event_id: ID!, $only_subevent: Boolean) {
  searchParticipantsByQuery(
    query: $query
    event_id: $event_id
    only_subevent: $only_subevent
  ) {
    participants {
      ...SearchParticipant
    }
    empty_due_permissions
  }
}
    ${SearchParticipantFragmentDoc}`;
export type SearchParticipantsMutationFn = Apollo.MutationFunction<SearchParticipantsMutation, SearchParticipantsMutationVariables>;

/**
 * __useSearchParticipantsMutation__
 *
 * To run a mutation, you first call `useSearchParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchParticipantsMutation, { data, loading, error }] = useSearchParticipantsMutation({
 *   variables: {
 *      query: // value for 'query'
 *      event_id: // value for 'event_id'
 *      only_subevent: // value for 'only_subevent'
 *   },
 * });
 */
export function useSearchParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<SearchParticipantsMutation, SearchParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SearchParticipantsMutation, SearchParticipantsMutationVariables>(SearchParticipantsDocument, options);
      }
export type SearchParticipantsMutationHookResult = ReturnType<typeof useSearchParticipantsMutation>;
export type SearchParticipantsMutationResult = Apollo.MutationResult<SearchParticipantsMutation>;
export type SearchParticipantsMutationOptions = Apollo.BaseMutationOptions<SearchParticipantsMutation, SearchParticipantsMutationVariables>;
export const SendPushNotificationDocument = gql`
    mutation SendPushNotification($emails: [String!]!, $title: String!, $message: String!, $event_id: ID) {
  sendPushNotification(
    emails: $emails
    title: $title
    message: $message
    event_id: $event_id
  ) {
    success
    message
  }
}
    `;
export type SendPushNotificationMutationFn = Apollo.MutationFunction<SendPushNotificationMutation, SendPushNotificationMutationVariables>;

/**
 * __useSendPushNotificationMutation__
 *
 * To run a mutation, you first call `useSendPushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPushNotificationMutation, { data, loading, error }] = useSendPushNotificationMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useSendPushNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendPushNotificationMutation, SendPushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPushNotificationMutation, SendPushNotificationMutationVariables>(SendPushNotificationDocument, options);
      }
export type SendPushNotificationMutationHookResult = ReturnType<typeof useSendPushNotificationMutation>;
export type SendPushNotificationMutationResult = Apollo.MutationResult<SendPushNotificationMutation>;
export type SendPushNotificationMutationOptions = Apollo.BaseMutationOptions<SendPushNotificationMutation, SendPushNotificationMutationVariables>;
export const SignupDocument = gql`
    mutation signup($email: String!, $password: String!, $first_name: String!, $last_name: String!, $dob: String!) {
  signup(
    email: $email
    password: $password
    first_name: $first_name
    last_name: $last_name
    dob: $dob
  ) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SubmitSmsNotificationConsentDocument = gql`
    mutation submitSmsNotificationConsent($event_id: ID!, $name: String!, $phone_number: String!, $is_consent: Boolean!) {
  submitSmsNotificationConsent(
    event_id: $event_id
    name: $name
    phone_number: $phone_number
    is_consent: $is_consent
  ) {
    id
    master_event {
      id
      name
    }
    submitted_event {
      id
      name
    }
    name
    phone_number
    phone_normalized
    is_consent
    consented_at
    created_at
  }
}
    `;
export type SubmitSmsNotificationConsentMutationFn = Apollo.MutationFunction<SubmitSmsNotificationConsentMutation, SubmitSmsNotificationConsentMutationVariables>;

/**
 * __useSubmitSmsNotificationConsentMutation__
 *
 * To run a mutation, you first call `useSubmitSmsNotificationConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSmsNotificationConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSmsNotificationConsentMutation, { data, loading, error }] = useSubmitSmsNotificationConsentMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      name: // value for 'name'
 *      phone_number: // value for 'phone_number'
 *      is_consent: // value for 'is_consent'
 *   },
 * });
 */
export function useSubmitSmsNotificationConsentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSmsNotificationConsentMutation, SubmitSmsNotificationConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSmsNotificationConsentMutation, SubmitSmsNotificationConsentMutationVariables>(SubmitSmsNotificationConsentDocument, options);
      }
export type SubmitSmsNotificationConsentMutationHookResult = ReturnType<typeof useSubmitSmsNotificationConsentMutation>;
export type SubmitSmsNotificationConsentMutationResult = Apollo.MutationResult<SubmitSmsNotificationConsentMutation>;
export type SubmitSmsNotificationConsentMutationOptions = Apollo.BaseMutationOptions<SubmitSmsNotificationConsentMutation, SubmitSmsNotificationConsentMutationVariables>;
export const UnassignEventTeamFromEventResourceDocument = gql`
    mutation UnassignEventTeamFromEventResource($event_id: ID!, $event_team_id: ID!) {
  unassignEventTeamFromEventResource(
    event_id: $event_id
    event_team_id: $event_team_id
  ) {
    id
    event_resource {
      id
    }
  }
}
    `;
export type UnassignEventTeamFromEventResourceMutationFn = Apollo.MutationFunction<UnassignEventTeamFromEventResourceMutation, UnassignEventTeamFromEventResourceMutationVariables>;

/**
 * __useUnassignEventTeamFromEventResourceMutation__
 *
 * To run a mutation, you first call `useUnassignEventTeamFromEventResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignEventTeamFromEventResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignEventTeamFromEventResourceMutation, { data, loading, error }] = useUnassignEventTeamFromEventResourceMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_team_id: // value for 'event_team_id'
 *   },
 * });
 */
export function useUnassignEventTeamFromEventResourceMutation(baseOptions?: Apollo.MutationHookOptions<UnassignEventTeamFromEventResourceMutation, UnassignEventTeamFromEventResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignEventTeamFromEventResourceMutation, UnassignEventTeamFromEventResourceMutationVariables>(UnassignEventTeamFromEventResourceDocument, options);
      }
export type UnassignEventTeamFromEventResourceMutationHookResult = ReturnType<typeof useUnassignEventTeamFromEventResourceMutation>;
export type UnassignEventTeamFromEventResourceMutationResult = Apollo.MutationResult<UnassignEventTeamFromEventResourceMutation>;
export type UnassignEventTeamFromEventResourceMutationOptions = Apollo.BaseMutationOptions<UnassignEventTeamFromEventResourceMutation, UnassignEventTeamFromEventResourceMutationVariables>;
export const UnassignEventTeamsFromEventResourceDocument = gql`
    mutation UnassignEventTeamsFromEventResource($event_id: ID!, $event_team_ids: [ID!]!) {
  unassignEventTeamsFromEventResource(
    event_id: $event_id
    event_team_ids: $event_team_ids
  ) {
    id
    event_resource {
      id
    }
  }
}
    `;
export type UnassignEventTeamsFromEventResourceMutationFn = Apollo.MutationFunction<UnassignEventTeamsFromEventResourceMutation, UnassignEventTeamsFromEventResourceMutationVariables>;

/**
 * __useUnassignEventTeamsFromEventResourceMutation__
 *
 * To run a mutation, you first call `useUnassignEventTeamsFromEventResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignEventTeamsFromEventResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignEventTeamsFromEventResourceMutation, { data, loading, error }] = useUnassignEventTeamsFromEventResourceMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_team_ids: // value for 'event_team_ids'
 *   },
 * });
 */
export function useUnassignEventTeamsFromEventResourceMutation(baseOptions?: Apollo.MutationHookOptions<UnassignEventTeamsFromEventResourceMutation, UnassignEventTeamsFromEventResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignEventTeamsFromEventResourceMutation, UnassignEventTeamsFromEventResourceMutationVariables>(UnassignEventTeamsFromEventResourceDocument, options);
      }
export type UnassignEventTeamsFromEventResourceMutationHookResult = ReturnType<typeof useUnassignEventTeamsFromEventResourceMutation>;
export type UnassignEventTeamsFromEventResourceMutationResult = Apollo.MutationResult<UnassignEventTeamsFromEventResourceMutation>;
export type UnassignEventTeamsFromEventResourceMutationOptions = Apollo.BaseMutationOptions<UnassignEventTeamsFromEventResourceMutation, UnassignEventTeamsFromEventResourceMutationVariables>;
export const UpdateEventParticipantDetailsDocument = gql`
    mutation updateEventParticipantDetails($termsAgreement: Boolean, $participant_hash: String!, $conditions: JSON, $primary_contact_first_name: String, $primary_contact_last_name: String, $primary_contact_relationship: String, $primary_contact_phone: String, $primary_contact_email: String, $secondary_contact_first_name: String, $secondary_contact_last_name: String, $secondary_contact_relationship: String, $secondary_contact_phone: String, $secondary_contact_email: String) {
  updateEventParticipantDetails(
    termsAgreement: $termsAgreement
    participant_hash: $participant_hash
    conditions: $conditions
    primary_contact_first_name: $primary_contact_first_name
    primary_contact_last_name: $primary_contact_last_name
    primary_contact_relationship: $primary_contact_relationship
    primary_contact_phone: $primary_contact_phone
    primary_contact_email: $primary_contact_email
    secondary_contact_first_name: $secondary_contact_first_name
    secondary_contact_last_name: $secondary_contact_last_name
    secondary_contact_relationship: $secondary_contact_relationship
    secondary_contact_phone: $secondary_contact_phone
    secondary_contact_email: $secondary_contact_email
  ) {
    id
  }
}
    `;
export type UpdateEventParticipantDetailsMutationFn = Apollo.MutationFunction<UpdateEventParticipantDetailsMutation, UpdateEventParticipantDetailsMutationVariables>;

/**
 * __useUpdateEventParticipantDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateEventParticipantDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventParticipantDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventParticipantDetailsMutation, { data, loading, error }] = useUpdateEventParticipantDetailsMutation({
 *   variables: {
 *      termsAgreement: // value for 'termsAgreement'
 *      participant_hash: // value for 'participant_hash'
 *      conditions: // value for 'conditions'
 *      primary_contact_first_name: // value for 'primary_contact_first_name'
 *      primary_contact_last_name: // value for 'primary_contact_last_name'
 *      primary_contact_relationship: // value for 'primary_contact_relationship'
 *      primary_contact_phone: // value for 'primary_contact_phone'
 *      primary_contact_email: // value for 'primary_contact_email'
 *      secondary_contact_first_name: // value for 'secondary_contact_first_name'
 *      secondary_contact_last_name: // value for 'secondary_contact_last_name'
 *      secondary_contact_relationship: // value for 'secondary_contact_relationship'
 *      secondary_contact_phone: // value for 'secondary_contact_phone'
 *      secondary_contact_email: // value for 'secondary_contact_email'
 *   },
 * });
 */
export function useUpdateEventParticipantDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventParticipantDetailsMutation, UpdateEventParticipantDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventParticipantDetailsMutation, UpdateEventParticipantDetailsMutationVariables>(UpdateEventParticipantDetailsDocument, options);
      }
export type UpdateEventParticipantDetailsMutationHookResult = ReturnType<typeof useUpdateEventParticipantDetailsMutation>;
export type UpdateEventParticipantDetailsMutationResult = Apollo.MutationResult<UpdateEventParticipantDetailsMutation>;
export type UpdateEventParticipantDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateEventParticipantDetailsMutation, UpdateEventParticipantDetailsMutationVariables>;
export const UpdateParticipantStatusDocument = gql`
    mutation updateParticipantStatus($event_id: ID!, $event_participant_id: ID!, $event_tracking_status_id: ID!, $latitude: Float, $longitude: Float) {
  updateParticipantStatus(
    event_id: $event_id
    latitude: $latitude
    longitude: $longitude
    event_tracking_status_id: $event_tracking_status_id
    event_participant_id: $event_participant_id
  ) {
    id
    event_tracking_status {
      color
      id
      label
      font_color
      is_private
    }
    status
    status_name
  }
}
    `;
export type UpdateParticipantStatusMutationFn = Apollo.MutationFunction<UpdateParticipantStatusMutation, UpdateParticipantStatusMutationVariables>;

/**
 * __useUpdateParticipantStatusMutation__
 *
 * To run a mutation, you first call `useUpdateParticipantStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipantStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipantStatusMutation, { data, loading, error }] = useUpdateParticipantStatusMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      event_tracking_status_id: // value for 'event_tracking_status_id'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useUpdateParticipantStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipantStatusMutation, UpdateParticipantStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipantStatusMutation, UpdateParticipantStatusMutationVariables>(UpdateParticipantStatusDocument, options);
      }
export type UpdateParticipantStatusMutationHookResult = ReturnType<typeof useUpdateParticipantStatusMutation>;
export type UpdateParticipantStatusMutationResult = Apollo.MutationResult<UpdateParticipantStatusMutation>;
export type UpdateParticipantStatusMutationOptions = Apollo.BaseMutationOptions<UpdateParticipantStatusMutation, UpdateParticipantStatusMutationVariables>;
export const UpdateTransportDocument = gql`
    mutation UpdateTransport($encounter_disposition_id: ID!, $admission_date: Date, $discharge_date: Date, $diagnosis: String, $notes: String) {
  updateTransport(
    encounter_disposition_id: $encounter_disposition_id
    admission_date: $admission_date
    discharge_date: $discharge_date
    diagnosis: $diagnosis
    notes: $notes
  ) {
    id
    diagnosis
    note
  }
}
    `;
export type UpdateTransportMutationFn = Apollo.MutationFunction<UpdateTransportMutation, UpdateTransportMutationVariables>;

/**
 * __useUpdateTransportMutation__
 *
 * To run a mutation, you first call `useUpdateTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransportMutation, { data, loading, error }] = useUpdateTransportMutation({
 *   variables: {
 *      encounter_disposition_id: // value for 'encounter_disposition_id'
 *      admission_date: // value for 'admission_date'
 *      discharge_date: // value for 'discharge_date'
 *      diagnosis: // value for 'diagnosis'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateTransportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransportMutation, UpdateTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransportMutation, UpdateTransportMutationVariables>(UpdateTransportDocument, options);
      }
export type UpdateTransportMutationHookResult = ReturnType<typeof useUpdateTransportMutation>;
export type UpdateTransportMutationResult = Apollo.MutationResult<UpdateTransportMutation>;
export type UpdateTransportMutationOptions = Apollo.BaseMutationOptions<UpdateTransportMutation, UpdateTransportMutationVariables>;
export const UploadEventParticipantFilesDocument = gql`
    mutation uploadEventParticipantFiles($file: Upload!, $event_id: ID!, $event_participant_id: ID!) {
  uploadEventParticipantFiles(
    event_id: $event_id
    event_participant_id: $event_participant_id
    file: $file
  ) {
    temporaryUrl
    name
    metadata {
      key
      value
    }
  }
}
    `;
export type UploadEventParticipantFilesMutationFn = Apollo.MutationFunction<UploadEventParticipantFilesMutation, UploadEventParticipantFilesMutationVariables>;

/**
 * __useUploadEventParticipantFilesMutation__
 *
 * To run a mutation, you first call `useUploadEventParticipantFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEventParticipantFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEventParticipantFilesMutation, { data, loading, error }] = useUploadEventParticipantFilesMutation({
 *   variables: {
 *      file: // value for 'file'
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *   },
 * });
 */
export function useUploadEventParticipantFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadEventParticipantFilesMutation, UploadEventParticipantFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEventParticipantFilesMutation, UploadEventParticipantFilesMutationVariables>(UploadEventParticipantFilesDocument, options);
      }
export type UploadEventParticipantFilesMutationHookResult = ReturnType<typeof useUploadEventParticipantFilesMutation>;
export type UploadEventParticipantFilesMutationResult = Apollo.MutationResult<UploadEventParticipantFilesMutation>;
export type UploadEventParticipantFilesMutationOptions = Apollo.BaseMutationOptions<UploadEventParticipantFilesMutation, UploadEventParticipantFilesMutationVariables>;
export const Verify2FaDocument = gql`
    mutation verify2FA($code: String!, $user_id: ID!) {
  verify2FA(code: $code, user_id: $user_id) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type Verify2FaMutationFn = Apollo.MutationFunction<Verify2FaMutation, Verify2FaMutationVariables>;

/**
 * __useVerify2FaMutation__
 *
 * To run a mutation, you first call `useVerify2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerify2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verify2FaMutation, { data, loading, error }] = useVerify2FaMutation({
 *   variables: {
 *      code: // value for 'code'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useVerify2FaMutation(baseOptions?: Apollo.MutationHookOptions<Verify2FaMutation, Verify2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Verify2FaMutation, Verify2FaMutationVariables>(Verify2FaDocument, options);
      }
export type Verify2FaMutationHookResult = ReturnType<typeof useVerify2FaMutation>;
export type Verify2FaMutationResult = Apollo.MutationResult<Verify2FaMutation>;
export type Verify2FaMutationOptions = Apollo.BaseMutationOptions<Verify2FaMutation, Verify2FaMutationVariables>;
export const EventDocument = gql`
    query Event($volunteer_hash: String, $participant_hash: String) {
  fetchEvent(volunteer_hash: $volunteer_hash, participant_hash: $participant_hash) {
    ...PickEvent
    date_display
    date_start
    date_end
    state
  }
}
    ${PickEventFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *      participant_hash: // value for 'participant_hash'
 *   },
 * });
 */
export function useEventQuery(baseOptions?: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
// @ts-ignore
export function useEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>): Apollo.UseSuspenseQueryResult<EventQuery, EventQueryVariables>;
export function useEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>): Apollo.UseSuspenseQueryResult<EventQuery | undefined, EventQueryVariables>;
export function useEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventSuspenseQueryHookResult = ReturnType<typeof useEventSuspenseQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export function refetchEventQuery(variables?: EventQueryVariables) {
      return { query: EventDocument, variables: variables }
    }
export const EventContentsDocument = gql`
    query EventContents($participant_hash: String!) {
  eventContents(participant_hash: $participant_hash) {
    id
    copy
    image
    url
    event {
      id
      name
      logo
    }
  }
}
    `;

/**
 * __useEventContentsQuery__
 *
 * To run a query within a React component, call `useEventContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventContentsQuery({
 *   variables: {
 *      participant_hash: // value for 'participant_hash'
 *   },
 * });
 */
export function useEventContentsQuery(baseOptions: Apollo.QueryHookOptions<EventContentsQuery, EventContentsQueryVariables> & ({ variables: EventContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventContentsQuery, EventContentsQueryVariables>(EventContentsDocument, options);
      }
export function useEventContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventContentsQuery, EventContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventContentsQuery, EventContentsQueryVariables>(EventContentsDocument, options);
        }
// @ts-ignore
export function useEventContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventContentsQuery, EventContentsQueryVariables>): Apollo.UseSuspenseQueryResult<EventContentsQuery, EventContentsQueryVariables>;
export function useEventContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventContentsQuery, EventContentsQueryVariables>): Apollo.UseSuspenseQueryResult<EventContentsQuery | undefined, EventContentsQueryVariables>;
export function useEventContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventContentsQuery, EventContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventContentsQuery, EventContentsQueryVariables>(EventContentsDocument, options);
        }
export type EventContentsQueryHookResult = ReturnType<typeof useEventContentsQuery>;
export type EventContentsLazyQueryHookResult = ReturnType<typeof useEventContentsLazyQuery>;
export type EventContentsSuspenseQueryHookResult = ReturnType<typeof useEventContentsSuspenseQuery>;
export type EventContentsQueryResult = Apollo.QueryResult<EventContentsQuery, EventContentsQueryVariables>;
export function refetchEventContentsQuery(variables: EventContentsQueryVariables) {
      return { query: EventContentsDocument, variables: variables }
    }
export const EventRegistrationFieldOptionsDocument = gql`
    query EventRegistrationFieldOptions($eventId: ID!) {
  eventRegistrationFieldOptions(event_id: $eventId) {
    roles
    delegations
    sports
    countries
  }
}
    `;

/**
 * __useEventRegistrationFieldOptionsQuery__
 *
 * To run a query within a React component, call `useEventRegistrationFieldOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRegistrationFieldOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRegistrationFieldOptionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventRegistrationFieldOptionsQuery(baseOptions: Apollo.QueryHookOptions<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables> & ({ variables: EventRegistrationFieldOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>(EventRegistrationFieldOptionsDocument, options);
      }
export function useEventRegistrationFieldOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>(EventRegistrationFieldOptionsDocument, options);
        }
// @ts-ignore
export function useEventRegistrationFieldOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>;
export function useEventRegistrationFieldOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<EventRegistrationFieldOptionsQuery | undefined, EventRegistrationFieldOptionsQueryVariables>;
export function useEventRegistrationFieldOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>(EventRegistrationFieldOptionsDocument, options);
        }
export type EventRegistrationFieldOptionsQueryHookResult = ReturnType<typeof useEventRegistrationFieldOptionsQuery>;
export type EventRegistrationFieldOptionsLazyQueryHookResult = ReturnType<typeof useEventRegistrationFieldOptionsLazyQuery>;
export type EventRegistrationFieldOptionsSuspenseQueryHookResult = ReturnType<typeof useEventRegistrationFieldOptionsSuspenseQuery>;
export type EventRegistrationFieldOptionsQueryResult = Apollo.QueryResult<EventRegistrationFieldOptionsQuery, EventRegistrationFieldOptionsQueryVariables>;
export function refetchEventRegistrationFieldOptionsQuery(variables: EventRegistrationFieldOptionsQueryVariables) {
      return { query: EventRegistrationFieldOptionsDocument, variables: variables }
    }
export const EventWithHashDocument = gql`
    query EventWithHash($hash: String) {
  fetchEventWithHash(hash: $hash) {
    ...PickEvent
  }
}
    ${PickEventFragmentDoc}`;

/**
 * __useEventWithHashQuery__
 *
 * To run a query within a React component, call `useEventWithHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWithHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWithHashQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useEventWithHashQuery(baseOptions?: Apollo.QueryHookOptions<EventWithHashQuery, EventWithHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventWithHashQuery, EventWithHashQueryVariables>(EventWithHashDocument, options);
      }
export function useEventWithHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventWithHashQuery, EventWithHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventWithHashQuery, EventWithHashQueryVariables>(EventWithHashDocument, options);
        }
// @ts-ignore
export function useEventWithHashSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventWithHashQuery, EventWithHashQueryVariables>): Apollo.UseSuspenseQueryResult<EventWithHashQuery, EventWithHashQueryVariables>;
export function useEventWithHashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventWithHashQuery, EventWithHashQueryVariables>): Apollo.UseSuspenseQueryResult<EventWithHashQuery | undefined, EventWithHashQueryVariables>;
export function useEventWithHashSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventWithHashQuery, EventWithHashQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventWithHashQuery, EventWithHashQueryVariables>(EventWithHashDocument, options);
        }
export type EventWithHashQueryHookResult = ReturnType<typeof useEventWithHashQuery>;
export type EventWithHashLazyQueryHookResult = ReturnType<typeof useEventWithHashLazyQuery>;
export type EventWithHashSuspenseQueryHookResult = ReturnType<typeof useEventWithHashSuspenseQuery>;
export type EventWithHashQueryResult = Apollo.QueryResult<EventWithHashQuery, EventWithHashQueryVariables>;
export function refetchEventWithHashQuery(variables?: EventWithHashQueryVariables) {
      return { query: EventWithHashDocument, variables: variables }
    }
export const EventsDocument = gql`
    query events($first: Int!, $page: Int!) {
  events(first: $first, page: $page) {
    data {
      id
      name
      slug
      longitude
      latitude
      time_zone
      temperature_unit
      state
      logo
      is_active_app
      is_active_command
      is_highschool
      is_master
      is_private
      is_subevent
      is_volunteer_shared
      has_triage_feature
      has_wgbt
      hospital_list
      has_barcode
      has_chat_feature
      has_deidentified_data
      has_health_illness_button
      has_opinion_questionnaire
      google_analytics_code
      country
      allow_user_location
      barcode_query_string
      button_triage_delayed
      button_triage_immediate
      button_triage_minor
      parent_event_id
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables> & ({ variables: EventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
// @ts-ignore
export function useEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>): Apollo.UseSuspenseQueryResult<EventsQuery, EventsQueryVariables>;
export function useEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>): Apollo.UseSuspenseQueryResult<EventsQuery | undefined, EventsQueryVariables>;
export function useEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export function refetchEventsQuery(variables: EventsQueryVariables) {
      return { query: EventsDocument, variables: variables }
    }
export const FetchEventDocument = gql`
    query FetchEvent($volunteer_hash: String, $participant_hash: String) {
  fetchEvent(volunteer_hash: $volunteer_hash, participant_hash: $participant_hash) {
    name
    id
    participant_description
    team_description
    logo
  }
}
    `;

/**
 * __useFetchEventQuery__
 *
 * To run a query within a React component, call `useFetchEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEventQuery({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *      participant_hash: // value for 'participant_hash'
 *   },
 * });
 */
export function useFetchEventQuery(baseOptions?: Apollo.QueryHookOptions<FetchEventQuery, FetchEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEventQuery, FetchEventQueryVariables>(FetchEventDocument, options);
      }
export function useFetchEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEventQuery, FetchEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEventQuery, FetchEventQueryVariables>(FetchEventDocument, options);
        }
// @ts-ignore
export function useFetchEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchEventQuery, FetchEventQueryVariables>): Apollo.UseSuspenseQueryResult<FetchEventQuery, FetchEventQueryVariables>;
export function useFetchEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventQuery, FetchEventQueryVariables>): Apollo.UseSuspenseQueryResult<FetchEventQuery | undefined, FetchEventQueryVariables>;
export function useFetchEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchEventQuery, FetchEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEventQuery, FetchEventQueryVariables>(FetchEventDocument, options);
        }
export type FetchEventQueryHookResult = ReturnType<typeof useFetchEventQuery>;
export type FetchEventLazyQueryHookResult = ReturnType<typeof useFetchEventLazyQuery>;
export type FetchEventSuspenseQueryHookResult = ReturnType<typeof useFetchEventSuspenseQuery>;
export type FetchEventQueryResult = Apollo.QueryResult<FetchEventQuery, FetchEventQueryVariables>;
export function refetchFetchEventQuery(variables?: FetchEventQueryVariables) {
      return { query: FetchEventDocument, variables: variables }
    }
export const FetchParticipantStatusDocument = gql`
    query fetchParticipantStatus($event_id: ID!, $event_participant_id: ID!) {
  fetchParticipantStatus(
    event_id: $event_id
    event_participant_id: $event_participant_id
  ) {
    id
    event_tracking_status {
      color
      id
      label
      font_color
      is_private
    }
    status
    status_name
  }
}
    `;

/**
 * __useFetchParticipantStatusQuery__
 *
 * To run a query within a React component, call `useFetchParticipantStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParticipantStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParticipantStatusQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *   },
 * });
 */
export function useFetchParticipantStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables> & ({ variables: FetchParticipantStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>(FetchParticipantStatusDocument, options);
      }
export function useFetchParticipantStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>(FetchParticipantStatusDocument, options);
        }
// @ts-ignore
export function useFetchParticipantStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>;
export function useFetchParticipantStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FetchParticipantStatusQuery | undefined, FetchParticipantStatusQueryVariables>;
export function useFetchParticipantStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>(FetchParticipantStatusDocument, options);
        }
export type FetchParticipantStatusQueryHookResult = ReturnType<typeof useFetchParticipantStatusQuery>;
export type FetchParticipantStatusLazyQueryHookResult = ReturnType<typeof useFetchParticipantStatusLazyQuery>;
export type FetchParticipantStatusSuspenseQueryHookResult = ReturnType<typeof useFetchParticipantStatusSuspenseQuery>;
export type FetchParticipantStatusQueryResult = Apollo.QueryResult<FetchParticipantStatusQuery, FetchParticipantStatusQueryVariables>;
export function refetchFetchParticipantStatusQuery(variables: FetchParticipantStatusQueryVariables) {
      return { query: FetchParticipantStatusDocument, variables: variables }
    }
export const FindEventParticipantDocument = gql`
    query findEventParticipant($event_id: ID!, $event_participant_id: ID!, $latitude: Float!, $longitude: Float!) {
  findEventParticipant(
    event_id: $event_id
    event_participant_id: $event_participant_id
    latitude: $latitude
    longitude: $longitude
  ) {
    id
    user {
      full_name
    }
    event {
      name
      id
    }
    participant_allergies {
      id
      allergy_id
    }
    participant_medications {
      id
      name
      note
      doseunit
      directions
    }
    participant_conditions {
      id
      name
    }
    master_encounters {
      ...AmrEncounter
    }
  }
}
    ${AmrEncounterFragmentDoc}`;

/**
 * __useFindEventParticipantQuery__
 *
 * To run a query within a React component, call `useFindEventParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventParticipantQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useFindEventParticipantQuery(baseOptions: Apollo.QueryHookOptions<FindEventParticipantQuery, FindEventParticipantQueryVariables> & ({ variables: FindEventParticipantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEventParticipantQuery, FindEventParticipantQueryVariables>(FindEventParticipantDocument, options);
      }
export function useFindEventParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEventParticipantQuery, FindEventParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEventParticipantQuery, FindEventParticipantQueryVariables>(FindEventParticipantDocument, options);
        }
// @ts-ignore
export function useFindEventParticipantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindEventParticipantQuery, FindEventParticipantQueryVariables>): Apollo.UseSuspenseQueryResult<FindEventParticipantQuery, FindEventParticipantQueryVariables>;
export function useFindEventParticipantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindEventParticipantQuery, FindEventParticipantQueryVariables>): Apollo.UseSuspenseQueryResult<FindEventParticipantQuery | undefined, FindEventParticipantQueryVariables>;
export function useFindEventParticipantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindEventParticipantQuery, FindEventParticipantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindEventParticipantQuery, FindEventParticipantQueryVariables>(FindEventParticipantDocument, options);
        }
export type FindEventParticipantQueryHookResult = ReturnType<typeof useFindEventParticipantQuery>;
export type FindEventParticipantLazyQueryHookResult = ReturnType<typeof useFindEventParticipantLazyQuery>;
export type FindEventParticipantSuspenseQueryHookResult = ReturnType<typeof useFindEventParticipantSuspenseQuery>;
export type FindEventParticipantQueryResult = Apollo.QueryResult<FindEventParticipantQuery, FindEventParticipantQueryVariables>;
export function refetchFindEventParticipantQuery(variables: FindEventParticipantQueryVariables) {
      return { query: FindEventParticipantDocument, variables: variables }
    }
export const FindEventParticipantFilesDocument = gql`
    query findEventParticipantFiles($event_id: ID!, $event_participant_id: ID!) {
  findEventParticipantFiles(
    event_id: $event_id
    event_participant_id: $event_participant_id
  ) {
    temporaryUrl
    uploadedAt
    type
    metadata {
      key
      value
    }
    name
  }
}
    `;

/**
 * __useFindEventParticipantFilesQuery__
 *
 * To run a query within a React component, call `useFindEventParticipantFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventParticipantFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEventParticipantFilesQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_participant_id: // value for 'event_participant_id'
 *   },
 * });
 */
export function useFindEventParticipantFilesQuery(baseOptions: Apollo.QueryHookOptions<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables> & ({ variables: FindEventParticipantFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>(FindEventParticipantFilesDocument, options);
      }
export function useFindEventParticipantFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>(FindEventParticipantFilesDocument, options);
        }
// @ts-ignore
export function useFindEventParticipantFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>): Apollo.UseSuspenseQueryResult<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>;
export function useFindEventParticipantFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>): Apollo.UseSuspenseQueryResult<FindEventParticipantFilesQuery | undefined, FindEventParticipantFilesQueryVariables>;
export function useFindEventParticipantFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>(FindEventParticipantFilesDocument, options);
        }
export type FindEventParticipantFilesQueryHookResult = ReturnType<typeof useFindEventParticipantFilesQuery>;
export type FindEventParticipantFilesLazyQueryHookResult = ReturnType<typeof useFindEventParticipantFilesLazyQuery>;
export type FindEventParticipantFilesSuspenseQueryHookResult = ReturnType<typeof useFindEventParticipantFilesSuspenseQuery>;
export type FindEventParticipantFilesQueryResult = Apollo.QueryResult<FindEventParticipantFilesQuery, FindEventParticipantFilesQueryVariables>;
export function refetchFindEventParticipantFilesQuery(variables: FindEventParticipantFilesQueryVariables) {
      return { query: FindEventParticipantFilesDocument, variables: variables }
    }
export const FindTeamNearestResourceDocument = gql`
    query findTeamNearestResource($event_id: ID!, $latitude: Float!, $longitude: Float!) {
  findTeamNearestResource(
    event_id: $event_id
    latitude: $latitude
    longitude: $longitude
  ) {
    status
    same_resource
    nearest_resource {
      id
      name
    }
    assigned_resource {
      id
      name
    }
    team_role {
      controls
      role_name
    }
  }
}
    `;

/**
 * __useFindTeamNearestResourceQuery__
 *
 * To run a query within a React component, call `useFindTeamNearestResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTeamNearestResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTeamNearestResourceQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useFindTeamNearestResourceQuery(baseOptions: Apollo.QueryHookOptions<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables> & ({ variables: FindTeamNearestResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>(FindTeamNearestResourceDocument, options);
      }
export function useFindTeamNearestResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>(FindTeamNearestResourceDocument, options);
        }
// @ts-ignore
export function useFindTeamNearestResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>): Apollo.UseSuspenseQueryResult<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>;
export function useFindTeamNearestResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>): Apollo.UseSuspenseQueryResult<FindTeamNearestResourceQuery | undefined, FindTeamNearestResourceQueryVariables>;
export function useFindTeamNearestResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>(FindTeamNearestResourceDocument, options);
        }
export type FindTeamNearestResourceQueryHookResult = ReturnType<typeof useFindTeamNearestResourceQuery>;
export type FindTeamNearestResourceLazyQueryHookResult = ReturnType<typeof useFindTeamNearestResourceLazyQuery>;
export type FindTeamNearestResourceSuspenseQueryHookResult = ReturnType<typeof useFindTeamNearestResourceSuspenseQuery>;
export type FindTeamNearestResourceQueryResult = Apollo.QueryResult<FindTeamNearestResourceQuery, FindTeamNearestResourceQueryVariables>;
export function refetchFindTeamNearestResourceQuery(variables: FindTeamNearestResourceQueryVariables) {
      return { query: FindTeamNearestResourceDocument, variables: variables }
    }
export const GetAmrDataDocument = gql`
    query getAMRData($event_participant_id: ID!) {
  getAMRData(event_participant_id: $event_participant_id) {
    event_participant {
      id
      full_name
      profile_photo
      identifier_number
      is_offline_mode
      offline_sync_status
      offline_context
      birth_date
      age
      height_formatted
      weight_lbs
      gender
      primary_cellphone_number
      primary_contact_first_name
      primary_contact_last_name
      primary_contact_phone
      primary_contact_email
      secondary_contact_first_name
      secondary_contact_last_name
      secondary_contact_phone
      secondary_contact_email
      sports
      delegation
      role
      user {
        full_name
        profile {
          profile_picture
          gender
          birth_date
        }
      }
      event {
        id
        name
        language
        default_sms_email_message
        show_event_research_question_on_open_spot
        has_opinion_questionnaire
        event_research_questions {
          id
          form_name
          event_button_group_id
          options_source
          eventButtonGroup {
            id
            label
            is_single_selection
            eventButtons {
              id
              label
              code
              image_url
              image_url_signed
              sort_order
              has_negative
            }
          }
          trigger_type
          title
          subtitle
          other_title
          tooltip_info
          options
          type
          mandatory
          multiple_choice
          has_other_option
          is_active
          show_in_amr
          sort_order
        }
        event_tracking_statuses {
          id
          is_private
          label
          color
        }
        event_activities {
          id
          label
          name
          category
          systemActivityPage {
            name
          }
          eventButtonGroups {
            id
            type
            label
            is_single_selection
            eventButtons {
              id
              label
              research_form_name
              image_url
              eventForm {
                id
                name
                label
              }
            }
          }
          eventForms {
            id
            name
            label
          }
        }
        event_forms {
          id
          name
          label
        }
        participantQuestions {
          id
          title
          subtitle
          other_title
          options
          multiple_selection
          mandatory
          type
        }
        event_resources {
          id
          name
          default_nearest_station
          dont_relate_events
          is_mobile
          is_sagbus
          longitude
          latitude
        }
        event_hospitals {
          id
          name
        }
        encounterDispositionTypes {
          id
          name
          is_mobile_activity
          is_sagbus_activity
          protocol
          eventTrackingStatus {
            id
            is_private
            label
            color
            font_color
          }
        }
        encounterCallActions {
          id
          name
          action_type
          use_emergency_info_flag
          event_tracking_status {
            id
            label
            color
            font_color
          }
          encounterTypePhoneNumbers {
            id
            name
            phone_number
          }
        }
      }
      participant_allergies {
        id
        name
        type
        note
      }
      participant_medications {
        id
        name
        directions
        note
      }
      participant_conditions {
        id
        name
        note
      }
      participant_answers {
        id
        answer
        participant_question {
          id
          title
        }
      }
      master_encounters {
        ...SpotEncounter
        parent {
          ...SpotEncounter
        }
        merged_encounters {
          ...SpotEncounter
        }
      }
    }
  }
}
    ${SpotEncounterFragmentDoc}`;

/**
 * __useGetAmrDataQuery__
 *
 * To run a query within a React component, call `useGetAmrDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmrDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmrDataQuery({
 *   variables: {
 *      event_participant_id: // value for 'event_participant_id'
 *   },
 * });
 */
export function useGetAmrDataQuery(baseOptions: Apollo.QueryHookOptions<GetAmrDataQuery, GetAmrDataQueryVariables> & ({ variables: GetAmrDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmrDataQuery, GetAmrDataQueryVariables>(GetAmrDataDocument, options);
      }
export function useGetAmrDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmrDataQuery, GetAmrDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmrDataQuery, GetAmrDataQueryVariables>(GetAmrDataDocument, options);
        }
// @ts-ignore
export function useGetAmrDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAmrDataQuery, GetAmrDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAmrDataQuery, GetAmrDataQueryVariables>;
export function useGetAmrDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAmrDataQuery, GetAmrDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAmrDataQuery | undefined, GetAmrDataQueryVariables>;
export function useGetAmrDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAmrDataQuery, GetAmrDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAmrDataQuery, GetAmrDataQueryVariables>(GetAmrDataDocument, options);
        }
export type GetAmrDataQueryHookResult = ReturnType<typeof useGetAmrDataQuery>;
export type GetAmrDataLazyQueryHookResult = ReturnType<typeof useGetAmrDataLazyQuery>;
export type GetAmrDataSuspenseQueryHookResult = ReturnType<typeof useGetAmrDataSuspenseQuery>;
export type GetAmrDataQueryResult = Apollo.QueryResult<GetAmrDataQuery, GetAmrDataQueryVariables>;
export function refetchGetAmrDataQuery(variables: GetAmrDataQueryVariables) {
      return { query: GetAmrDataDocument, variables: variables }
    }
export const GetCommandStatsDocument = gql`
    query getCommandStats($hash: ID!) {
  getCommandStats(hash: $hash) {
    activeMedicalIncidents
    activeMedicalIncidentsByParticipant
    incidentSummaryByParticipant
    incidentSummary
    incidentSummaryByParticipantByDay
    activeMedicalIncidentsByParticipantByDay
  }
}
    `;

/**
 * __useGetCommandStatsQuery__
 *
 * To run a query within a React component, call `useGetCommandStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandStatsQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetCommandStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCommandStatsQuery, GetCommandStatsQueryVariables> & ({ variables: GetCommandStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommandStatsQuery, GetCommandStatsQueryVariables>(GetCommandStatsDocument, options);
      }
export function useGetCommandStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommandStatsQuery, GetCommandStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommandStatsQuery, GetCommandStatsQueryVariables>(GetCommandStatsDocument, options);
        }
// @ts-ignore
export function useGetCommandStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommandStatsQuery, GetCommandStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandStatsQuery, GetCommandStatsQueryVariables>;
export function useGetCommandStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandStatsQuery, GetCommandStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandStatsQuery | undefined, GetCommandStatsQueryVariables>;
export function useGetCommandStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandStatsQuery, GetCommandStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommandStatsQuery, GetCommandStatsQueryVariables>(GetCommandStatsDocument, options);
        }
export type GetCommandStatsQueryHookResult = ReturnType<typeof useGetCommandStatsQuery>;
export type GetCommandStatsLazyQueryHookResult = ReturnType<typeof useGetCommandStatsLazyQuery>;
export type GetCommandStatsSuspenseQueryHookResult = ReturnType<typeof useGetCommandStatsSuspenseQuery>;
export type GetCommandStatsQueryResult = Apollo.QueryResult<GetCommandStatsQuery, GetCommandStatsQueryVariables>;
export function refetchGetCommandStatsQuery(variables: GetCommandStatsQueryVariables) {
      return { query: GetCommandStatsDocument, variables: variables }
    }
export const GetDataExportDocument = gql`
    query GetDataExport($event_id: ID!, $start_date: String, $end_date: String, $participant_id: ID, $participant_name: String, $participant_country: String, $participant_sports: String, $participant_team: String, $participant_sex: String, $participant_role: String, $display_archived: Boolean, $display_active: Boolean, $display_closed: Boolean, $symptom: String, $physical_findings: String, $opinion: String, $treatment: String, $activity: String, $selected_events: [ID], $selected_dispositions: [ID]) {
  getDataExport(
    event_id: $event_id
    start_date: $start_date
    end_date: $end_date
    participant_id: $participant_id
    participant_name: $participant_name
    participant_country: $participant_country
    participant_sports: $participant_sports
    participant_team: $participant_team
    participant_sex: $participant_sex
    participant_role: $participant_role
    display_archived: $display_archived
    display_active: $display_active
    display_closed: $display_closed
    symptom: $symptom
    physical_findings: $physical_findings
    opinion: $opinion
    treatment: $treatment
    activity: $activity
    selected_events: $selected_events
    selected_dispositions: $selected_dispositions
  ) {
    success
    message
    filename
    export_type
    filters_applied
    export_download
    download_url
    expires_at
    expires_in_minutes
  }
}
    `;

/**
 * __useGetDataExportQuery__
 *
 * To run a query within a React component, call `useGetDataExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataExportQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      participant_id: // value for 'participant_id'
 *      participant_name: // value for 'participant_name'
 *      participant_country: // value for 'participant_country'
 *      participant_sports: // value for 'participant_sports'
 *      participant_team: // value for 'participant_team'
 *      participant_sex: // value for 'participant_sex'
 *      participant_role: // value for 'participant_role'
 *      display_archived: // value for 'display_archived'
 *      display_active: // value for 'display_active'
 *      display_closed: // value for 'display_closed'
 *      symptom: // value for 'symptom'
 *      physical_findings: // value for 'physical_findings'
 *      opinion: // value for 'opinion'
 *      treatment: // value for 'treatment'
 *      activity: // value for 'activity'
 *      selected_events: // value for 'selected_events'
 *      selected_dispositions: // value for 'selected_dispositions'
 *   },
 * });
 */
export function useGetDataExportQuery(baseOptions: Apollo.QueryHookOptions<GetDataExportQuery, GetDataExportQueryVariables> & ({ variables: GetDataExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataExportQuery, GetDataExportQueryVariables>(GetDataExportDocument, options);
      }
export function useGetDataExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataExportQuery, GetDataExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataExportQuery, GetDataExportQueryVariables>(GetDataExportDocument, options);
        }
// @ts-ignore
export function useGetDataExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataExportQuery, GetDataExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetDataExportQuery, GetDataExportQueryVariables>;
export function useGetDataExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataExportQuery, GetDataExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetDataExportQuery | undefined, GetDataExportQueryVariables>;
export function useGetDataExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataExportQuery, GetDataExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataExportQuery, GetDataExportQueryVariables>(GetDataExportDocument, options);
        }
export type GetDataExportQueryHookResult = ReturnType<typeof useGetDataExportQuery>;
export type GetDataExportLazyQueryHookResult = ReturnType<typeof useGetDataExportLazyQuery>;
export type GetDataExportSuspenseQueryHookResult = ReturnType<typeof useGetDataExportSuspenseQuery>;
export type GetDataExportQueryResult = Apollo.QueryResult<GetDataExportQuery, GetDataExportQueryVariables>;
export function refetchGetDataExportQuery(variables: GetDataExportQueryVariables) {
      return { query: GetDataExportDocument, variables: variables }
    }
export const GetEncounterDocument = gql`
    query GetEncounter($encounter_id: ID!) {
  getEncounter(encounter_id: $encounter_id) {
    id
    is_resolved
    created_at
    updated_at
    created_by_user {
      full_name
    }
    event {
      id
      name
      event_research_questions {
        id
        form_name
        title
        is_active
        show_in_amr
        sort_order
      }
      event_activities {
        id
        label
        name
        category
        systemActivityPage {
          name
        }
        eventButtonGroups {
          id
          type
          label
          is_single_selection
          eventButtons {
            id
            label
            eventForm {
              id
              name
              label
            }
          }
        }
        eventForms {
          id
          name
          label
        }
      }
      event_forms {
        id
        name
        label
      }
    }
    event_activity {
      id
      name
      category
    }
    event_resource {
      name
    }
    encounter_spot_data {
      id
      encounter_call_action {
        name
        updated_at
      }
      event_button_data {
        id
        event_button {
          id
          label
        }
        event_button_group {
          id
          type
          label
        }
        created_at
      }
      event_button_freetext_data {
        id
        freetext
        event_button_group {
          id
          type
          label
        }
      }
      event_bodypart_data {
        id
        event_form {
          id
          name
          label
        }
        body
        part
      }
      event_labs_data {
        id
        event_form {
          id
          name
          label
        }
        saturation
        sodium
        glucose
        note
      }
      event_vitalsigns_data {
        id
        event_form {
          id
          name
          label
        }
        temperature
        pulse
        breathing
        systole
        diastole
        note
        blood_pressure
      }
      event_medicationgiven_data {
        id
        event_form {
          id
          name
          label
        }
        medication
        directions
        strength
        doseunit
        note
        route
        status
      }
      created_at
    }
    event_research_question_data {
      id
      encounter_spot_data_id
      research_question_type
      research_question_title
      research_question_answer
      created_at
    }
    encounter_dispositions {
      id
      note
      care_provider
      is_cancel_transport
      diagnosis
      admit_at
      discharge_at
      encounter_disposition_type {
        name
      }
      event_transport {
        event_hospital {
          name
        }
      }
      event_resource {
        name
      }
      created_at
    }
    latest_encounter_disposition {
      id
      encounter_disposition_type {
        name
      }
    }
    event_team {
      id
      user {
        id
        full_name
        first_name
        last_name
      }
    }
    event_participant {
      id
      identifier_number
      birth_date
      age
      height_formatted
      weight_lbs
      gender
      primary_cellphone_number
      primary_contact_first_name
      primary_contact_last_name
      primary_contact_phone
      secondary_contact_first_name
      secondary_contact_last_name
      secondary_contact_phone
      sports
      delegation
      role
      event {
        id
      }
      user {
        id
        full_name
      }
      participant_allergies {
        id
        name
        type
      }
      participant_medications {
        id
        name
      }
      participant_conditions {
        id
        name
      }
      participant_answers {
        id
        answer
        participant_question {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetEncounterQuery__
 *
 * To run a query within a React component, call `useGetEncounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterQuery({
 *   variables: {
 *      encounter_id: // value for 'encounter_id'
 *   },
 * });
 */
export function useGetEncounterQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterQuery, GetEncounterQueryVariables> & ({ variables: GetEncounterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterQuery, GetEncounterQueryVariables>(GetEncounterDocument, options);
      }
export function useGetEncounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterQuery, GetEncounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterQuery, GetEncounterQueryVariables>(GetEncounterDocument, options);
        }
// @ts-ignore
export function useGetEncounterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEncounterQuery, GetEncounterQueryVariables>): Apollo.UseSuspenseQueryResult<GetEncounterQuery, GetEncounterQueryVariables>;
export function useGetEncounterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEncounterQuery, GetEncounterQueryVariables>): Apollo.UseSuspenseQueryResult<GetEncounterQuery | undefined, GetEncounterQueryVariables>;
export function useGetEncounterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEncounterQuery, GetEncounterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEncounterQuery, GetEncounterQueryVariables>(GetEncounterDocument, options);
        }
export type GetEncounterQueryHookResult = ReturnType<typeof useGetEncounterQuery>;
export type GetEncounterLazyQueryHookResult = ReturnType<typeof useGetEncounterLazyQuery>;
export type GetEncounterSuspenseQueryHookResult = ReturnType<typeof useGetEncounterSuspenseQuery>;
export type GetEncounterQueryResult = Apollo.QueryResult<GetEncounterQuery, GetEncounterQueryVariables>;
export function refetchGetEncounterQuery(variables: GetEncounterQueryVariables) {
      return { query: GetEncounterDocument, variables: variables }
    }
export const GetEncounterAuditHistoryDocument = gql`
    query GetEncounterAuditHistory($encounter_id: ID!) {
  getEncounterAuditHistory(encounter_id: $encounter_id) {
    id
    change_id
    table_name
    record_pk
    action
    actor_id
    actor {
      id
      full_name
      first_name
      last_name
      email_address
    }
    changed
    enriched_changes
    ip
    user_agent
    created_at
    entity_type
  }
}
    `;

/**
 * __useGetEncounterAuditHistoryQuery__
 *
 * To run a query within a React component, call `useGetEncounterAuditHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterAuditHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterAuditHistoryQuery({
 *   variables: {
 *      encounter_id: // value for 'encounter_id'
 *   },
 * });
 */
export function useGetEncounterAuditHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables> & ({ variables: GetEncounterAuditHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>(GetEncounterAuditHistoryDocument, options);
      }
export function useGetEncounterAuditHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>(GetEncounterAuditHistoryDocument, options);
        }
// @ts-ignore
export function useGetEncounterAuditHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>;
export function useGetEncounterAuditHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetEncounterAuditHistoryQuery | undefined, GetEncounterAuditHistoryQueryVariables>;
export function useGetEncounterAuditHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>(GetEncounterAuditHistoryDocument, options);
        }
export type GetEncounterAuditHistoryQueryHookResult = ReturnType<typeof useGetEncounterAuditHistoryQuery>;
export type GetEncounterAuditHistoryLazyQueryHookResult = ReturnType<typeof useGetEncounterAuditHistoryLazyQuery>;
export type GetEncounterAuditHistorySuspenseQueryHookResult = ReturnType<typeof useGetEncounterAuditHistorySuspenseQuery>;
export type GetEncounterAuditHistoryQueryResult = Apollo.QueryResult<GetEncounterAuditHistoryQuery, GetEncounterAuditHistoryQueryVariables>;
export function refetchGetEncounterAuditHistoryQuery(variables: GetEncounterAuditHistoryQueryVariables) {
      return { query: GetEncounterAuditHistoryDocument, variables: variables }
    }
export const GetEventParticipantDetailsDocument = gql`
    query GetEventParticipantDetails($participantHash: String!) {
  getEventParticipantDetails(participant_hash: $participantHash) {
    id
    first_name
    last_name
    email_address
    gender
    pronoun
    is_agreement_consented
    primary_contact_first_name
    primary_contact_last_name
    primary_contact_relationship
    primary_contact_phone
    primary_contact_email
    secondary_contact_first_name
    secondary_contact_last_name
    secondary_contact_relationship
    secondary_contact_phone
    secondary_contact_email
    participant_allergies {
      id
      name
    }
    participant_medications {
      id
      name
    }
    participant_conditions {
      id
      name
    }
    participant_answers {
      id
      participant_questions_id
      answer
    }
    user_medications {
      id
      name
    }
    user_allergies {
      id
      name
    }
    user_conditions {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEventParticipantDetailsQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantDetailsQuery({
 *   variables: {
 *      participantHash: // value for 'participantHash'
 *   },
 * });
 */
export function useGetEventParticipantDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables> & ({ variables: GetEventParticipantDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>(GetEventParticipantDetailsDocument, options);
      }
export function useGetEventParticipantDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>(GetEventParticipantDetailsDocument, options);
        }
// @ts-ignore
export function useGetEventParticipantDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>;
export function useGetEventParticipantDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventParticipantDetailsQuery | undefined, GetEventParticipantDetailsQueryVariables>;
export function useGetEventParticipantDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>(GetEventParticipantDetailsDocument, options);
        }
export type GetEventParticipantDetailsQueryHookResult = ReturnType<typeof useGetEventParticipantDetailsQuery>;
export type GetEventParticipantDetailsLazyQueryHookResult = ReturnType<typeof useGetEventParticipantDetailsLazyQuery>;
export type GetEventParticipantDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEventParticipantDetailsSuspenseQuery>;
export type GetEventParticipantDetailsQueryResult = Apollo.QueryResult<GetEventParticipantDetailsQuery, GetEventParticipantDetailsQueryVariables>;
export function refetchGetEventParticipantDetailsQuery(variables: GetEventParticipantDetailsQueryVariables) {
      return { query: GetEventParticipantDetailsDocument, variables: variables }
    }
export const GetGenerateIdentifierNumberDocument = gql`
    query getGenerateIdentifierNumber($event_id: ID!) {
  generateIdentifierNumber(event_id: $event_id)
}
    `;

/**
 * __useGetGenerateIdentifierNumberQuery__
 *
 * To run a query within a React component, call `useGetGenerateIdentifierNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenerateIdentifierNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenerateIdentifierNumberQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetGenerateIdentifierNumberQuery(baseOptions: Apollo.QueryHookOptions<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables> & ({ variables: GetGenerateIdentifierNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>(GetGenerateIdentifierNumberDocument, options);
      }
export function useGetGenerateIdentifierNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>(GetGenerateIdentifierNumberDocument, options);
        }
// @ts-ignore
export function useGetGenerateIdentifierNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>;
export function useGetGenerateIdentifierNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetGenerateIdentifierNumberQuery | undefined, GetGenerateIdentifierNumberQueryVariables>;
export function useGetGenerateIdentifierNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>(GetGenerateIdentifierNumberDocument, options);
        }
export type GetGenerateIdentifierNumberQueryHookResult = ReturnType<typeof useGetGenerateIdentifierNumberQuery>;
export type GetGenerateIdentifierNumberLazyQueryHookResult = ReturnType<typeof useGetGenerateIdentifierNumberLazyQuery>;
export type GetGenerateIdentifierNumberSuspenseQueryHookResult = ReturnType<typeof useGetGenerateIdentifierNumberSuspenseQuery>;
export type GetGenerateIdentifierNumberQueryResult = Apollo.QueryResult<GetGenerateIdentifierNumberQuery, GetGenerateIdentifierNumberQueryVariables>;
export function refetchGetGenerateIdentifierNumberQuery(variables: GetGenerateIdentifierNumberQueryVariables) {
      return { query: GetGenerateIdentifierNumberDocument, variables: variables }
    }
export const GetHostConfigDocument = gql`
    query getHostConfig($subdomain_name: String, $domain_name: String) {
  getHostConfig(subdomain_name: $subdomain_name, domain_name: $domain_name) {
    id
    domain_name
    app_title
    logo_url
    primary_color
    primary_color_hover
    primary_text_color
    header_color
    header_font_color
    hero_main_title
    hero_sub_title
    hero_text_color
    hero_image
    hero_background_color
    hero_buttons
    better_title
    better_subtitle
    better_image
    better_left_text
    better_right_text
    better_left_image
    better_right_image
    experience_title
    experience_subtitle
    experience_text
    experience_image
    partners_title
    partners_logo
    balloons_title
    blocks_order
    meta_title
    meta_description
    meta_keywords
    og_title
    og_description
    og_image
  }
}
    `;

/**
 * __useGetHostConfigQuery__
 *
 * To run a query within a React component, call `useGetHostConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostConfigQuery({
 *   variables: {
 *      subdomain_name: // value for 'subdomain_name'
 *      domain_name: // value for 'domain_name'
 *   },
 * });
 */
export function useGetHostConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetHostConfigQuery, GetHostConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostConfigQuery, GetHostConfigQueryVariables>(GetHostConfigDocument, options);
      }
export function useGetHostConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostConfigQuery, GetHostConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostConfigQuery, GetHostConfigQueryVariables>(GetHostConfigDocument, options);
        }
// @ts-ignore
export function useGetHostConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHostConfigQuery, GetHostConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetHostConfigQuery, GetHostConfigQueryVariables>;
export function useGetHostConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostConfigQuery, GetHostConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetHostConfigQuery | undefined, GetHostConfigQueryVariables>;
export function useGetHostConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostConfigQuery, GetHostConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHostConfigQuery, GetHostConfigQueryVariables>(GetHostConfigDocument, options);
        }
export type GetHostConfigQueryHookResult = ReturnType<typeof useGetHostConfigQuery>;
export type GetHostConfigLazyQueryHookResult = ReturnType<typeof useGetHostConfigLazyQuery>;
export type GetHostConfigSuspenseQueryHookResult = ReturnType<typeof useGetHostConfigSuspenseQuery>;
export type GetHostConfigQueryResult = Apollo.QueryResult<GetHostConfigQuery, GetHostConfigQueryVariables>;
export function refetchGetHostConfigQuery(variables?: GetHostConfigQueryVariables) {
      return { query: GetHostConfigDocument, variables: variables }
    }
export const GetKunakDataDocument = gql`
    query GetKunakData($hash: String!) {
  getKunakTemperatureData(hash: $hash) {
    period_uuid
    enabled
    timestamp
    elements {
      element_id
      value
      unit
      timestamp
      metadata
    }
  }
}
    `;

/**
 * __useGetKunakDataQuery__
 *
 * To run a query within a React component, call `useGetKunakDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKunakDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKunakDataQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetKunakDataQuery(baseOptions: Apollo.QueryHookOptions<GetKunakDataQuery, GetKunakDataQueryVariables> & ({ variables: GetKunakDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKunakDataQuery, GetKunakDataQueryVariables>(GetKunakDataDocument, options);
      }
export function useGetKunakDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKunakDataQuery, GetKunakDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKunakDataQuery, GetKunakDataQueryVariables>(GetKunakDataDocument, options);
        }
// @ts-ignore
export function useGetKunakDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKunakDataQuery, GetKunakDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetKunakDataQuery, GetKunakDataQueryVariables>;
export function useGetKunakDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKunakDataQuery, GetKunakDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetKunakDataQuery | undefined, GetKunakDataQueryVariables>;
export function useGetKunakDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKunakDataQuery, GetKunakDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKunakDataQuery, GetKunakDataQueryVariables>(GetKunakDataDocument, options);
        }
export type GetKunakDataQueryHookResult = ReturnType<typeof useGetKunakDataQuery>;
export type GetKunakDataLazyQueryHookResult = ReturnType<typeof useGetKunakDataLazyQuery>;
export type GetKunakDataSuspenseQueryHookResult = ReturnType<typeof useGetKunakDataSuspenseQuery>;
export type GetKunakDataQueryResult = Apollo.QueryResult<GetKunakDataQuery, GetKunakDataQueryVariables>;
export function refetchGetKunakDataQuery(variables: GetKunakDataQueryVariables) {
      return { query: GetKunakDataDocument, variables: variables }
    }
export const GetMeDocument = gql`
    query getMe {
  getMe {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export function refetchGetMeQuery(variables?: GetMeQueryVariables) {
      return { query: GetMeDocument, variables: variables }
    }
export const GetMyEventTeamDocument = gql`
    query getMyEventTeam($volunteer_hash: String!) {
  getMyEventTeam(volunteer_hash: $volunteer_hash) {
    ...EventTeam
  }
}
    ${EventTeamFragmentDoc}`;

/**
 * __useGetMyEventTeamQuery__
 *
 * To run a query within a React component, call `useGetMyEventTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEventTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEventTeamQuery({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *   },
 * });
 */
export function useGetMyEventTeamQuery(baseOptions: Apollo.QueryHookOptions<GetMyEventTeamQuery, GetMyEventTeamQueryVariables> & ({ variables: GetMyEventTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>(GetMyEventTeamDocument, options);
      }
export function useGetMyEventTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>(GetMyEventTeamDocument, options);
        }
// @ts-ignore
export function useGetMyEventTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>;
export function useGetMyEventTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyEventTeamQuery | undefined, GetMyEventTeamQueryVariables>;
export function useGetMyEventTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>(GetMyEventTeamDocument, options);
        }
export type GetMyEventTeamQueryHookResult = ReturnType<typeof useGetMyEventTeamQuery>;
export type GetMyEventTeamLazyQueryHookResult = ReturnType<typeof useGetMyEventTeamLazyQuery>;
export type GetMyEventTeamSuspenseQueryHookResult = ReturnType<typeof useGetMyEventTeamSuspenseQuery>;
export type GetMyEventTeamQueryResult = Apollo.QueryResult<GetMyEventTeamQuery, GetMyEventTeamQueryVariables>;
export function refetchGetMyEventTeamQuery(variables: GetMyEventTeamQueryVariables) {
      return { query: GetMyEventTeamDocument, variables: variables }
    }
export const GetParticipantProfileDataDocument = gql`
    query getParticipantProfileData {
  getParticipantProfileData {
    user {
      id
      full_name
      profile {
        profile_picture
        medical_background
      }
    }
    event_participants {
      id
      event {
        id
        name
        date
        logo
        volunteer_hash
        participant_hash
      }
    }
  }
}
    `;

/**
 * __useGetParticipantProfileDataQuery__
 *
 * To run a query within a React component, call `useGetParticipantProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParticipantProfileDataQuery(baseOptions?: Apollo.QueryHookOptions<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>(GetParticipantProfileDataDocument, options);
      }
export function useGetParticipantProfileDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>(GetParticipantProfileDataDocument, options);
        }
// @ts-ignore
export function useGetParticipantProfileDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>;
export function useGetParticipantProfileDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetParticipantProfileDataQuery | undefined, GetParticipantProfileDataQueryVariables>;
export function useGetParticipantProfileDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>(GetParticipantProfileDataDocument, options);
        }
export type GetParticipantProfileDataQueryHookResult = ReturnType<typeof useGetParticipantProfileDataQuery>;
export type GetParticipantProfileDataLazyQueryHookResult = ReturnType<typeof useGetParticipantProfileDataLazyQuery>;
export type GetParticipantProfileDataSuspenseQueryHookResult = ReturnType<typeof useGetParticipantProfileDataSuspenseQuery>;
export type GetParticipantProfileDataQueryResult = Apollo.QueryResult<GetParticipantProfileDataQuery, GetParticipantProfileDataQueryVariables>;
export function refetchGetParticipantProfileDataQuery(variables?: GetParticipantProfileDataQueryVariables) {
      return { query: GetParticipantProfileDataDocument, variables: variables }
    }
export const GetRegisteredEventTeamsDocument = gql`
    query GetRegisteredEventTeams($volunteer_hash: String!) {
  getRegisteredEventTeams(volunteer_hash: $volunteer_hash) {
    id
    event {
      id
      name
      logo
      volunteer_hash
      display_station_preference
      display_volunteer_notes
      display_can_be_moved
      display_indicate_skills
      team_experience
      display_shirt_size
      display_racesafe_app_opt_out
      longitude
      latitude
      teamQuestions {
        id
        title
        subtitle
        other_title
        tooltip_info
        options
        multiple_selection
        mandatory
        type
      }
      event_resources {
        id
        name
        latitude
        longitude
      }
      subevents {
        id
        name
      }
      intro_video {
        id
        title
        url
        medical_background
        type
      }
      training_video {
        id
        title
        url
        medical_background
      }
      use_for_signup
    }
    event_team_answers {
      id
      team_question {
        id
        title
        subtitle
        other_title
        tooltip_info
        options
        multiple_selection
        mandatory
        type
      }
      answer
    }
    is_volunteer_other_events
    station_preference
    experience
    volunteer_notes
    can_be_moved
  }
}
    `;

/**
 * __useGetRegisteredEventTeamsQuery__
 *
 * To run a query within a React component, call `useGetRegisteredEventTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisteredEventTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisteredEventTeamsQuery({
 *   variables: {
 *      volunteer_hash: // value for 'volunteer_hash'
 *   },
 * });
 */
export function useGetRegisteredEventTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables> & ({ variables: GetRegisteredEventTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>(GetRegisteredEventTeamsDocument, options);
      }
export function useGetRegisteredEventTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>(GetRegisteredEventTeamsDocument, options);
        }
// @ts-ignore
export function useGetRegisteredEventTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>;
export function useGetRegisteredEventTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisteredEventTeamsQuery | undefined, GetRegisteredEventTeamsQueryVariables>;
export function useGetRegisteredEventTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>(GetRegisteredEventTeamsDocument, options);
        }
export type GetRegisteredEventTeamsQueryHookResult = ReturnType<typeof useGetRegisteredEventTeamsQuery>;
export type GetRegisteredEventTeamsLazyQueryHookResult = ReturnType<typeof useGetRegisteredEventTeamsLazyQuery>;
export type GetRegisteredEventTeamsSuspenseQueryHookResult = ReturnType<typeof useGetRegisteredEventTeamsSuspenseQuery>;
export type GetRegisteredEventTeamsQueryResult = Apollo.QueryResult<GetRegisteredEventTeamsQuery, GetRegisteredEventTeamsQueryVariables>;
export function refetchGetRegisteredEventTeamsQuery(variables: GetRegisteredEventTeamsQueryVariables) {
      return { query: GetRegisteredEventTeamsDocument, variables: variables }
    }
export const GetReportTableDataDocument = gql`
    query getReportTableData($event_id: ID!, $startDate: String, $endDate: String, $participantId: ID, $participantName: String, $participantCountry: String, $participantSports: String, $participantTeam: String, $participantSex: String, $participantRole: String, $displayArchived: Boolean, $symptom: String, $physicalFindings: String, $opinion: String, $treatment: String, $activity: String, $selectedEvents: [ID], $selectedDispositions: [ID]) {
  getReportTableData(
    event_id: $event_id
    start_date: $startDate
    end_date: $endDate
    participant_id: $participantId
    participant_name: $participantName
    participant_country: $participantCountry
    participant_sports: $participantSports
    participant_team: $participantTeam
    participant_sex: $participantSex
    participant_role: $participantRole
    display_archived: $displayArchived
    selected_events: $selectedEvents
    selected_dispositions: $selectedDispositions
    symptom: $symptom
    physical_findings: $physicalFindings
    opinion: $opinion
    treatment: $treatment
    activity: $activity
  ) {
    eventTitle
    eventDateRange
    incidentOutcomes
    dailyIncidentSummary {
      totalUniquePersonsSeen
      totalMajorIncidents
      totalIncidents
      totalInjuryActivity
      totalIllnessActivity
      totalMinorAssistance
    }
  }
}
    `;

/**
 * __useGetReportTableDataQuery__
 *
 * To run a query within a React component, call `useGetReportTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTableDataQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      participantId: // value for 'participantId'
 *      participantName: // value for 'participantName'
 *      participantCountry: // value for 'participantCountry'
 *      participantSports: // value for 'participantSports'
 *      participantTeam: // value for 'participantTeam'
 *      participantSex: // value for 'participantSex'
 *      participantRole: // value for 'participantRole'
 *      displayArchived: // value for 'displayArchived'
 *      symptom: // value for 'symptom'
 *      physicalFindings: // value for 'physicalFindings'
 *      opinion: // value for 'opinion'
 *      treatment: // value for 'treatment'
 *      activity: // value for 'activity'
 *      selectedEvents: // value for 'selectedEvents'
 *      selectedDispositions: // value for 'selectedDispositions'
 *   },
 * });
 */
export function useGetReportTableDataQuery(baseOptions: Apollo.QueryHookOptions<GetReportTableDataQuery, GetReportTableDataQueryVariables> & ({ variables: GetReportTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTableDataQuery, GetReportTableDataQueryVariables>(GetReportTableDataDocument, options);
      }
export function useGetReportTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTableDataQuery, GetReportTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTableDataQuery, GetReportTableDataQueryVariables>(GetReportTableDataDocument, options);
        }
// @ts-ignore
export function useGetReportTableDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportTableDataQuery, GetReportTableDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportTableDataQuery, GetReportTableDataQueryVariables>;
export function useGetReportTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportTableDataQuery, GetReportTableDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportTableDataQuery | undefined, GetReportTableDataQueryVariables>;
export function useGetReportTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportTableDataQuery, GetReportTableDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportTableDataQuery, GetReportTableDataQueryVariables>(GetReportTableDataDocument, options);
        }
export type GetReportTableDataQueryHookResult = ReturnType<typeof useGetReportTableDataQuery>;
export type GetReportTableDataLazyQueryHookResult = ReturnType<typeof useGetReportTableDataLazyQuery>;
export type GetReportTableDataSuspenseQueryHookResult = ReturnType<typeof useGetReportTableDataSuspenseQuery>;
export type GetReportTableDataQueryResult = Apollo.QueryResult<GetReportTableDataQuery, GetReportTableDataQueryVariables>;
export function refetchGetReportTableDataQuery(variables: GetReportTableDataQueryVariables) {
      return { query: GetReportTableDataDocument, variables: variables }
    }
export const GetResourceTrackingDocument = gql`
    query GetResourceTracking($event_resource_id: ID!) {
  getResourceTracking(event_resource_id: $event_resource_id) {
    id
    is_spot
    is_check_in
    is_check_out
    is_disposition
    is_minorassist
    is_athlete_record
    state
    event_participant {
      id
      identifier_number
      full_name
      first_name
      last_name
      country
      sports
      delegation
      role
      event {
        id
        name
      }
      user {
        full_name
        first_name
        last_name
      }
      primary_contact_first_name
      primary_contact_last_name
      age
      birth_date
    }
    event_tracking_status {
      color
      id
      label
    }
    status
    status_name
    hospital
    event_transport {
      id
      event_hospital {
        id
        name
      }
    }
    notes
    event_team {
      user {
        full_name
      }
    }
    updated_at
  }
}
    `;

/**
 * __useGetResourceTrackingQuery__
 *
 * To run a query within a React component, call `useGetResourceTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceTrackingQuery({
 *   variables: {
 *      event_resource_id: // value for 'event_resource_id'
 *   },
 * });
 */
export function useGetResourceTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetResourceTrackingQuery, GetResourceTrackingQueryVariables> & ({ variables: GetResourceTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>(GetResourceTrackingDocument, options);
      }
export function useGetResourceTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>(GetResourceTrackingDocument, options);
        }
// @ts-ignore
export function useGetResourceTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>;
export function useGetResourceTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceTrackingQuery | undefined, GetResourceTrackingQueryVariables>;
export function useGetResourceTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>(GetResourceTrackingDocument, options);
        }
export type GetResourceTrackingQueryHookResult = ReturnType<typeof useGetResourceTrackingQuery>;
export type GetResourceTrackingLazyQueryHookResult = ReturnType<typeof useGetResourceTrackingLazyQuery>;
export type GetResourceTrackingSuspenseQueryHookResult = ReturnType<typeof useGetResourceTrackingSuspenseQuery>;
export type GetResourceTrackingQueryResult = Apollo.QueryResult<GetResourceTrackingQuery, GetResourceTrackingQueryVariables>;
export function refetchGetResourceTrackingQuery(variables: GetResourceTrackingQueryVariables) {
      return { query: GetResourceTrackingDocument, variables: variables }
    }
export const GetStatusDashboardCountsDocument = gql`
    query GetStatusDashboardCounts($hash: String!, $recalculate: Boolean) {
  getStatusDashboardCounts(hash: $hash, recalculate: $recalculate) {
    id
  }
}
    `;

/**
 * __useGetStatusDashboardCountsQuery__
 *
 * To run a query within a React component, call `useGetStatusDashboardCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusDashboardCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusDashboardCountsQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *      recalculate: // value for 'recalculate'
 *   },
 * });
 */
export function useGetStatusDashboardCountsQuery(baseOptions: Apollo.QueryHookOptions<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables> & ({ variables: GetStatusDashboardCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>(GetStatusDashboardCountsDocument, options);
      }
export function useGetStatusDashboardCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>(GetStatusDashboardCountsDocument, options);
        }
// @ts-ignore
export function useGetStatusDashboardCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>;
export function useGetStatusDashboardCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusDashboardCountsQuery | undefined, GetStatusDashboardCountsQueryVariables>;
export function useGetStatusDashboardCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>(GetStatusDashboardCountsDocument, options);
        }
export type GetStatusDashboardCountsQueryHookResult = ReturnType<typeof useGetStatusDashboardCountsQuery>;
export type GetStatusDashboardCountsLazyQueryHookResult = ReturnType<typeof useGetStatusDashboardCountsLazyQuery>;
export type GetStatusDashboardCountsSuspenseQueryHookResult = ReturnType<typeof useGetStatusDashboardCountsSuspenseQuery>;
export type GetStatusDashboardCountsQueryResult = Apollo.QueryResult<GetStatusDashboardCountsQuery, GetStatusDashboardCountsQueryVariables>;
export function refetchGetStatusDashboardCountsQuery(variables: GetStatusDashboardCountsQueryVariables) {
      return { query: GetStatusDashboardCountsDocument, variables: variables }
    }
export const GetStatusHistoryDocument = gql`
    query getStatusHistory($event_participant_id: ID!) {
  getAMRData(event_participant_id: $event_participant_id) {
    event_participant {
      id
      master_tracking {
        id
        status
        status_name
        notes
        created_at
        updated_at
        event {
          id
          name
        }
        event_resource {
          id
          name
        }
        event_tracking_status {
          id
          label
          color
          font_color
        }
        status_trigger {
          id
          name
        }
        disposition_name
        creator {
          id
          full_name
          first_name
          last_name
        }
        updater {
          id
          full_name
          first_name
          last_name
        }
      }
    }
  }
}
    `;

/**
 * __useGetStatusHistoryQuery__
 *
 * To run a query within a React component, call `useGetStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusHistoryQuery({
 *   variables: {
 *      event_participant_id: // value for 'event_participant_id'
 *   },
 * });
 */
export function useGetStatusHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetStatusHistoryQuery, GetStatusHistoryQueryVariables> & ({ variables: GetStatusHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>(GetStatusHistoryDocument, options);
      }
export function useGetStatusHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>(GetStatusHistoryDocument, options);
        }
// @ts-ignore
export function useGetStatusHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>;
export function useGetStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusHistoryQuery | undefined, GetStatusHistoryQueryVariables>;
export function useGetStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>(GetStatusHistoryDocument, options);
        }
export type GetStatusHistoryQueryHookResult = ReturnType<typeof useGetStatusHistoryQuery>;
export type GetStatusHistoryLazyQueryHookResult = ReturnType<typeof useGetStatusHistoryLazyQuery>;
export type GetStatusHistorySuspenseQueryHookResult = ReturnType<typeof useGetStatusHistorySuspenseQuery>;
export type GetStatusHistoryQueryResult = Apollo.QueryResult<GetStatusHistoryQuery, GetStatusHistoryQueryVariables>;
export function refetchGetStatusHistoryQuery(variables: GetStatusHistoryQueryVariables) {
      return { query: GetStatusHistoryDocument, variables: variables }
    }
export const GetStatusTrackingDocument = gql`
    query GetStatusTracking($eventId: ID!, $eventTrackingStatusId: ID!) {
  getStatusTracking(
    event_id: $eventId
    event_tracking_status_id: $eventTrackingStatusId
  ) {
    id
    status
    status_name
    state
    updated_at
    event_participant {
      id
      full_name
      first_name
      last_name
      identifier_number
      country
      sports
      delegation
      role
    }
    event_tracking_status {
      id
      label
      color
      font_color
    }
    event_resource {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStatusTrackingQuery__
 *
 * To run a query within a React component, call `useGetStatusTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusTrackingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventTrackingStatusId: // value for 'eventTrackingStatusId'
 *   },
 * });
 */
export function useGetStatusTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetStatusTrackingQuery, GetStatusTrackingQueryVariables> & ({ variables: GetStatusTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>(GetStatusTrackingDocument, options);
      }
export function useGetStatusTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>(GetStatusTrackingDocument, options);
        }
// @ts-ignore
export function useGetStatusTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>;
export function useGetStatusTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusTrackingQuery | undefined, GetStatusTrackingQueryVariables>;
export function useGetStatusTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>(GetStatusTrackingDocument, options);
        }
export type GetStatusTrackingQueryHookResult = ReturnType<typeof useGetStatusTrackingQuery>;
export type GetStatusTrackingLazyQueryHookResult = ReturnType<typeof useGetStatusTrackingLazyQuery>;
export type GetStatusTrackingSuspenseQueryHookResult = ReturnType<typeof useGetStatusTrackingSuspenseQuery>;
export type GetStatusTrackingQueryResult = Apollo.QueryResult<GetStatusTrackingQuery, GetStatusTrackingQueryVariables>;
export function refetchGetStatusTrackingQuery(variables: GetStatusTrackingQueryVariables) {
      return { query: GetStatusTrackingDocument, variables: variables }
    }
export const GetTeamResourcesDocument = gql`
    query GetTeamResources($hash: String!) {
  getTeamResources(hash: $hash) {
    id
    name
    mobile_resource_status
    is_mobile
    is_sagbus
    event_id
    ord
    dont_relate_events
    tracking_dashboard_count {
      id
      activity_id
      total
      active_total
      active_red
      active_yellow
      active_green
      active_gray
      minor
      resolved
      transport
      counts {
        total
        active
        minor
        resolved
        transport
        statusCounts
      }
    }
  }
}
    `;

/**
 * __useGetTeamResourcesQuery__
 *
 * To run a query within a React component, call `useGetTeamResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamResourcesQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetTeamResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamResourcesQuery, GetTeamResourcesQueryVariables> & ({ variables: GetTeamResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>(GetTeamResourcesDocument, options);
      }
export function useGetTeamResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>(GetTeamResourcesDocument, options);
        }
// @ts-ignore
export function useGetTeamResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>;
export function useGetTeamResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamResourcesQuery | undefined, GetTeamResourcesQueryVariables>;
export function useGetTeamResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>(GetTeamResourcesDocument, options);
        }
export type GetTeamResourcesQueryHookResult = ReturnType<typeof useGetTeamResourcesQuery>;
export type GetTeamResourcesLazyQueryHookResult = ReturnType<typeof useGetTeamResourcesLazyQuery>;
export type GetTeamResourcesSuspenseQueryHookResult = ReturnType<typeof useGetTeamResourcesSuspenseQuery>;
export type GetTeamResourcesQueryResult = Apollo.QueryResult<GetTeamResourcesQuery, GetTeamResourcesQueryVariables>;
export function refetchGetTeamResourcesQuery(variables: GetTeamResourcesQueryVariables) {
      return { query: GetTeamResourcesDocument, variables: variables }
    }
export const GetUserDocument = gql`
    query getUser($id: ID) {
  getUser(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables?: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const NavbarDocument = gql`
    query navbar {
  navbar {
    is_super_admin
    items {
      id
      name
      volunteer_hash
      participant_hash
      team_role_controls
      subitems {
        id
        name
        volunteer_hash
        participant_hash
        team_role_controls
      }
    }
  }
}
    `;

/**
 * __useNavbarQuery__
 *
 * To run a query within a React component, call `useNavbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavbarQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavbarQuery(baseOptions?: Apollo.QueryHookOptions<NavbarQuery, NavbarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavbarQuery, NavbarQueryVariables>(NavbarDocument, options);
      }
export function useNavbarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavbarQuery, NavbarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavbarQuery, NavbarQueryVariables>(NavbarDocument, options);
        }
// @ts-ignore
export function useNavbarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavbarQuery, NavbarQueryVariables>): Apollo.UseSuspenseQueryResult<NavbarQuery, NavbarQueryVariables>;
export function useNavbarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavbarQuery, NavbarQueryVariables>): Apollo.UseSuspenseQueryResult<NavbarQuery | undefined, NavbarQueryVariables>;
export function useNavbarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavbarQuery, NavbarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavbarQuery, NavbarQueryVariables>(NavbarDocument, options);
        }
export type NavbarQueryHookResult = ReturnType<typeof useNavbarQuery>;
export type NavbarLazyQueryHookResult = ReturnType<typeof useNavbarLazyQuery>;
export type NavbarSuspenseQueryHookResult = ReturnType<typeof useNavbarSuspenseQuery>;
export type NavbarQueryResult = Apollo.QueryResult<NavbarQuery, NavbarQueryVariables>;
export function refetchNavbarQuery(variables?: NavbarQueryVariables) {
      return { query: NavbarDocument, variables: variables }
    }
export const GetParticipantEmergencyContactsDocument = gql`
    query getParticipantEmergencyContacts($participantId: ID!) {
  participantEmergencyContacts(participant_id: $participantId) {
    id
    first_name
    last_name
    full_name
    email_address
    primary_cellphone_number
    role
    delegation
    country
  }
}
    `;

/**
 * __useGetParticipantEmergencyContactsQuery__
 *
 * To run a query within a React component, call `useGetParticipantEmergencyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantEmergencyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantEmergencyContactsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantEmergencyContactsQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables> & ({ variables: GetParticipantEmergencyContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>(GetParticipantEmergencyContactsDocument, options);
      }
export function useGetParticipantEmergencyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>(GetParticipantEmergencyContactsDocument, options);
        }
// @ts-ignore
export function useGetParticipantEmergencyContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>;
export function useGetParticipantEmergencyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetParticipantEmergencyContactsQuery | undefined, GetParticipantEmergencyContactsQueryVariables>;
export function useGetParticipantEmergencyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>(GetParticipantEmergencyContactsDocument, options);
        }
export type GetParticipantEmergencyContactsQueryHookResult = ReturnType<typeof useGetParticipantEmergencyContactsQuery>;
export type GetParticipantEmergencyContactsLazyQueryHookResult = ReturnType<typeof useGetParticipantEmergencyContactsLazyQuery>;
export type GetParticipantEmergencyContactsSuspenseQueryHookResult = ReturnType<typeof useGetParticipantEmergencyContactsSuspenseQuery>;
export type GetParticipantEmergencyContactsQueryResult = Apollo.QueryResult<GetParticipantEmergencyContactsQuery, GetParticipantEmergencyContactsQueryVariables>;
export function refetchGetParticipantEmergencyContactsQuery(variables: GetParticipantEmergencyContactsQueryVariables) {
      return { query: GetParticipantEmergencyContactsDocument, variables: variables }
    }
export const SearchParticipantTrackingDocument = gql`
    query SearchParticipantTracking($hash: String!, $search_query: String, $start_date: String, $end_date: String, $participant_id: ID, $participant_name: String, $participant_country: String, $participant_sports: String, $participant_team: String, $participant_sex: String, $participant_role: String, $selected_events: [ID], $activity: String, $tracking_status_ids: [ID], $tracking_states: [String], $display_archived: Boolean, $display_active: Boolean, $display_closed: Boolean) {
  searchParticipantTracking(
    hash: $hash
    search_query: $search_query
    start_date: $start_date
    end_date: $end_date
    participant_id: $participant_id
    participant_name: $participant_name
    participant_country: $participant_country
    participant_sports: $participant_sports
    participant_team: $participant_team
    participant_sex: $participant_sex
    participant_role: $participant_role
    selected_events: $selected_events
    activity: $activity
    tracking_status_ids: $tracking_status_ids
    tracking_states: $tracking_states
    display_archived: $display_archived
    display_active: $display_active
    display_closed: $display_closed
  ) {
    id
    is_spot
    is_check_in
    is_check_out
    is_disposition
    is_minorassist
    is_athlete_record
    event {
      id
      name
    }
    event_resource {
      id
      name
      is_mobile
    }
    event_participant {
      identifier_number
      full_name
      first_name
      last_name
      country
      sports
      delegation
      role
      user {
        full_name
        first_name
        last_name
      }
      primary_contact_first_name
      primary_contact_last_name
      age
      birth_date
    }
    event_tracking_status {
      color
      id
      label
    }
    state
    status
    status_name
    hospital
    event_transport {
      id
      event_hospital {
        id
        name
      }
    }
    notes
    event_team {
      user {
        full_name
      }
    }
    updated_at
  }
}
    `;

/**
 * __useSearchParticipantTrackingQuery__
 *
 * To run a query within a React component, call `useSearchParticipantTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchParticipantTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchParticipantTrackingQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *      search_query: // value for 'search_query'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      participant_id: // value for 'participant_id'
 *      participant_name: // value for 'participant_name'
 *      participant_country: // value for 'participant_country'
 *      participant_sports: // value for 'participant_sports'
 *      participant_team: // value for 'participant_team'
 *      participant_sex: // value for 'participant_sex'
 *      participant_role: // value for 'participant_role'
 *      selected_events: // value for 'selected_events'
 *      activity: // value for 'activity'
 *      tracking_status_ids: // value for 'tracking_status_ids'
 *      tracking_states: // value for 'tracking_states'
 *      display_archived: // value for 'display_archived'
 *      display_active: // value for 'display_active'
 *      display_closed: // value for 'display_closed'
 *   },
 * });
 */
export function useSearchParticipantTrackingQuery(baseOptions: Apollo.QueryHookOptions<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables> & ({ variables: SearchParticipantTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>(SearchParticipantTrackingDocument, options);
      }
export function useSearchParticipantTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>(SearchParticipantTrackingDocument, options);
        }
// @ts-ignore
export function useSearchParticipantTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>;
export function useSearchParticipantTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>): Apollo.UseSuspenseQueryResult<SearchParticipantTrackingQuery | undefined, SearchParticipantTrackingQueryVariables>;
export function useSearchParticipantTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>(SearchParticipantTrackingDocument, options);
        }
export type SearchParticipantTrackingQueryHookResult = ReturnType<typeof useSearchParticipantTrackingQuery>;
export type SearchParticipantTrackingLazyQueryHookResult = ReturnType<typeof useSearchParticipantTrackingLazyQuery>;
export type SearchParticipantTrackingSuspenseQueryHookResult = ReturnType<typeof useSearchParticipantTrackingSuspenseQuery>;
export type SearchParticipantTrackingQueryResult = Apollo.QueryResult<SearchParticipantTrackingQuery, SearchParticipantTrackingQueryVariables>;
export function refetchSearchParticipantTrackingQuery(variables: SearchParticipantTrackingQueryVariables) {
      return { query: SearchParticipantTrackingDocument, variables: variables }
    }
export const UserTeamEventsDocument = gql`
    query userTeamEvents($first: Int!, $page: Int!) {
  userTeamEvents(first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
    }
    data {
      ...PickEvent
    }
  }
}
    ${PickEventFragmentDoc}`;

/**
 * __useUserTeamEventsQuery__
 *
 * To run a query within a React component, call `useUserTeamEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserTeamEventsQuery(baseOptions: Apollo.QueryHookOptions<UserTeamEventsQuery, UserTeamEventsQueryVariables> & ({ variables: UserTeamEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamEventsQuery, UserTeamEventsQueryVariables>(UserTeamEventsDocument, options);
      }
export function useUserTeamEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamEventsQuery, UserTeamEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamEventsQuery, UserTeamEventsQueryVariables>(UserTeamEventsDocument, options);
        }
// @ts-ignore
export function useUserTeamEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTeamEventsQuery, UserTeamEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UserTeamEventsQuery, UserTeamEventsQueryVariables>;
export function useUserTeamEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTeamEventsQuery, UserTeamEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UserTeamEventsQuery | undefined, UserTeamEventsQueryVariables>;
export function useUserTeamEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTeamEventsQuery, UserTeamEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTeamEventsQuery, UserTeamEventsQueryVariables>(UserTeamEventsDocument, options);
        }
export type UserTeamEventsQueryHookResult = ReturnType<typeof useUserTeamEventsQuery>;
export type UserTeamEventsLazyQueryHookResult = ReturnType<typeof useUserTeamEventsLazyQuery>;
export type UserTeamEventsSuspenseQueryHookResult = ReturnType<typeof useUserTeamEventsSuspenseQuery>;
export type UserTeamEventsQueryResult = Apollo.QueryResult<UserTeamEventsQuery, UserTeamEventsQueryVariables>;
export function refetchUserTeamEventsQuery(variables: UserTeamEventsQueryVariables) {
      return { query: UserTeamEventsDocument, variables: variables }
    }